'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var uikitResources = require('@cometchat/uikit-resources');
var chatSdkJavascript = require('@cometchat/chat-sdk-javascript');
var lit = require('lit');
var decorators_js = require('lit/decorators.js');
var styleMap_js = require('lit/directives/style-map.js');
var uikitElements = require('@cometchat/uikit-elements');

class CometChatSoundManager {
    /**
     * @param  {string} sound
     * @param  {string|null=null} customSound
     */
    static play(sound, customSound = null) {
        const resource = CometChatSoundManager.Sound[sound];
        const handler = CometChatSoundManager.handlers[resource];
        if (!handler) {
            return false;
        }
        return handler(customSound);
    }
    static pause() {
        if (CometChatSoundManager.audio) {
            CometChatSoundManager.audio.pause();
            CometChatSoundManager.audio.currentTime = 0;
            CometChatSoundManager.audio = null;
        }
    }
}
CometChatSoundManager.audio = null;
CometChatSoundManager.Sound = Object.freeze({
    incomingCall: "incomingCall",
    incomingMessage: "incomingMessage",
    incomingMessageFromOther: "incomingMessageFromOther",
    outgoingCall: "outgoingCall",
    outgoingMessage: "outgoingMessage",
});
/**
 * @param  {string|null=null} customSound
 */
CometChatSoundManager.onIncomingMessage = (customSound = null) => {
    CometChatSoundManager.audio = new Audio(customSound || 'https://assets.cometchat.io/uikits/static/audio/incomingmessage.wav');
    CometChatSoundManager.audio.currentTime = 0;
    CometChatSoundManager.audio.play();
};
/**
 * @param  {string|null=null} customSound
 */
CometChatSoundManager.onIncomingOtherMessage = (customSound = null) => {
    CometChatSoundManager.audio = new Audio(customSound || 'https://assets.cometchat.io/uikits/static/audio/incomingothermessage.wav');
    CometChatSoundManager.audio.currentTime = 0;
    CometChatSoundManager.audio.play();
};
/**
 * @param  {string|null=null} customSound
 */
CometChatSoundManager.onOutgoingMessage = (customSound = null) => {
    CometChatSoundManager.audio = new Audio(customSound || 'https://assets.cometchat.io/uikits/static/audio/outgoingmessage.wav');
    CometChatSoundManager.audio.currentTime = 0;
    CometChatSoundManager.audio.play();
};
/**
 * @param  {string|null=null} customSound
 */
CometChatSoundManager.onIncomingCall = (customSound = null) => {
    try {
        CometChatSoundManager.audio = new Audio(customSound || 'https://assets.cometchat.io/uikits/static/audio/incomingcall.wav');
        CometChatSoundManager.audio.currentTime = 0;
        if (typeof CometChatSoundManager.audio.loop == "boolean") {
            CometChatSoundManager.audio.loop = true;
        }
        else {
            CometChatSoundManager.audio.addEventListener("ended", function () {
                this.currentTime = 0;
                this.play();
            }, false);
        }
        CometChatSoundManager.audio.play();
    }
    catch (error) {
        console.log(error);
    }
};
/**
 * @param  {string|null=null} customSound
 */
CometChatSoundManager.onOutgoingCall = (customSound = null) => {
    try {
        CometChatSoundManager.audio = new Audio(customSound || 'https://assets.cometchat.io/uikits/static/audio/outgoingcall.wav');
        CometChatSoundManager.audio.currentTime = 0;
        if (typeof CometChatSoundManager.audio.loop == "boolean") {
            CometChatSoundManager.audio.loop = true;
        }
        else {
            CometChatSoundManager.audio.addEventListener("ended", function () {
                this.currentTime = 0;
                this.play();
            }, false);
        }
        CometChatSoundManager.audio.play();
    }
    catch (error) {
        console.log(error);
    }
};
CometChatSoundManager.handlers = {
    incomingCall: CometChatSoundManager.onIncomingCall,
    outgoingCall: CometChatSoundManager.onOutgoingCall,
    incomingMessage: CometChatSoundManager.onIncomingMessage,
    incomingMessageFromOther: CometChatSoundManager.onIncomingOtherMessage,
    outgoingMessage: CometChatSoundManager.onOutgoingMessage,
};

var DeleteIcon = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M17.25%2021H6.75C6.35218%2021%205.97064%2020.842%205.68934%2020.5607C5.40804%2020.2794%205.25%2019.8978%205.25%2019.5V6H18.75V19.5C18.75%2019.8978%2018.592%2020.2794%2018.3107%2020.5607C18.0294%2020.842%2017.6478%2021%2017.25%2021Z%22%20stroke%3D%22%23FF0000%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9.75%2016.5V10.5%22%20stroke%3D%22%23FF0000%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.25%2016.5V10.5%22%20stroke%3D%22%23FF0000%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.25%206H21.75%22%20stroke%3D%22%23FF0000%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.25%203H9.75C9.35218%203%208.97064%203.15804%208.68934%203.43934C8.40804%203.72064%208.25%204.10218%208.25%204.5V6H15.75V4.5C15.75%204.10218%2015.592%203.72064%2015.3107%203.43934C15.0294%203.15804%2014.6478%203%2014.25%203Z%22%20stroke%3D%22%23FF0000%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

class ConversationUtils {
    static getDefaultOptions(theme = new uikitResources.CometChatTheme({})) {
        return [new uikitResources.CometChatOption({
                id: uikitResources.CometChatUIKitConstants.ConversationOptions.delete,
                title: uikitResources.localize("DELETE"),
                //inside style
                iconURL: DeleteIcon,
                onClick: null,
                iconTint: theme.palette.getAccent700(),
                backgroundColor: "transparent",
                titleFont: uikitResources.fontHelper(theme.typography.subtitle1),
                titleColor: theme.palette.getAccent600()
            })]; //change to cometchatoption
    }
    static getLastConversationMessage(conversationObject, loggedInUser) {
        let msgObject = conversationObject === null || conversationObject === void 0 ? void 0 : conversationObject.getLastMessage();
        var message = "";
        if (!msgObject) {
            message = uikitResources.localize("CLICK_TO_START_CONVERSATION");
        }
        else if (msgObject === null || msgObject === void 0 ? void 0 : msgObject.getDeletedAt()) {
            message = uikitResources.localize("MESSAGE_IS_DELETED");
        }
        else if ((msgObject === null || msgObject === void 0 ? void 0 : msgObject.getCategory()) == uikitResources.CometChatUIKitConstants.MessageCategory.message && !(msgObject === null || msgObject === void 0 ? void 0 : msgObject.getDeletedAt())) {
            message = this.getLastMessage(conversationObject);
        }
        else if ((msgObject === null || msgObject === void 0 ? void 0 : msgObject.getCategory()) == uikitResources.CometChatUIKitConstants.MessageCategory.action) {
            message = this.getLastMessageAction(conversationObject);
        }
        else if ((msgObject === null || msgObject === void 0 ? void 0 : msgObject.getCategory()) == uikitResources.CometChatUIKitConstants.MessageCategory.call) {
            message = this.getLastMessageCall(conversationObject);
        }
        else if ((msgObject === null || msgObject === void 0 ? void 0 : msgObject.getCategory()) == uikitResources.CometChatUIKitConstants.MessageCategory.custom) {
            message = this.getLastMessageCustom(conversationObject);
        }
        else if ((msgObject === null || msgObject === void 0 ? void 0 : msgObject.getCategory()) == uikitResources.CometChatUIKitConstants.MessageCategory.interactive) {
            message = this.getLastMessageInteractive(conversationObject);
        }
        if (msgObject && (conversationObject === null || conversationObject === void 0 ? void 0 : conversationObject.getConversationType()) != chatSdkJavascript.CometChat.RECEIVER_TYPE.USER) {
            if ((msgObject === null || msgObject === void 0 ? void 0 : msgObject.getSender().getUid()) == (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.getUid())) {
                message = `${uikitResources.localize("YOU")}: ${message}`;
            }
            else {
                message = `${msgObject === null || msgObject === void 0 ? void 0 : msgObject.getSender().getName()}:  ${message}`;
            }
        }
        return message;
    }
    static getLastMessage(conversation) {
        let message;
        let messageObject = conversation.getLastMessage();
        switch (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getType()) {
            case uikitResources.CometChatUIKitConstants.MessageTypes.text:
                message = messageObject.getText();
                break;
            case uikitResources.CometChatUIKitConstants.MessageTypes.image:
                message = uikitResources.localize("MESSAGE_IMAGE");
                break;
            case uikitResources.CometChatUIKitConstants.MessageTypes.file:
                message = uikitResources.localize("MESSAGE_FILE");
                break;
            case uikitResources.CometChatUIKitConstants.MessageTypes.video:
                message = uikitResources.localize("MESSAGE_VIDEO");
                break;
            case uikitResources.CometChatUIKitConstants.MessageTypes.audio:
                message = uikitResources.localize("MESSAGE_AUDIO");
                break;
            default:
                message = messageObject.getType();
                break;
        }
        return message;
    }
    static getLastMessageCustom(conversation) {
        let msgObject = conversation.getLastMessage();
        return msgObject.getType();
    }
    static getLastMessageAction(conversation) {
        let messageObject = conversation === null || conversation === void 0 ? void 0 : conversation.getLastMessage();
        return messageObject === null || messageObject === void 0 ? void 0 : messageObject.getMessage();
    }
    static getLastMessageInteractive(conversation) {
        let messageObject = conversation === null || conversation === void 0 ? void 0 : conversation.getLastMessage();
        switch (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getType()) {
            case uikitResources.CometChatUIKitConstants.MessageTypes.form:
                return "📋 " + uikitResources.localize("FORM");
            case uikitResources.CometChatUIKitConstants.MessageTypes.card:
                return "🪧 " + uikitResources.localize("CARD");
            default:
                return messageObject === null || messageObject === void 0 ? void 0 : messageObject.getType();
        }
    }
    static getLastMessageCall(conversation) {
        let messageObject = conversation === null || conversation === void 0 ? void 0 : conversation.getLastMessage();
        if ((messageObject === null || messageObject === void 0 ? void 0 : messageObject.getType()) === "audio") {
            return uikitResources.localize("AUDIO_CALL");
        }
        else if ((messageObject === null || messageObject === void 0 ? void 0 : messageObject.getType()) === "video") {
            return uikitResources.localize("VIDEO_CALL");
        }
        else {
            return messageObject === null || messageObject === void 0 ? void 0 : messageObject.getType();
        }
    }
}

class DetailsUtils {
    static getBanOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban,
            title: uikitResources.localize("BAN"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getPrimary()) !== null && _a !== void 0 ? _a : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.subtitle1)
        });
    }
    static getViewMembersOption(theme) {
        var _a, _b;
        return new uikitResources.CometChatDetailsOption({
            id: (_a = uikitResources.CometChatUIKitConstants.GroupOptions) === null || _a === void 0 ? void 0 : _a.viewMembers,
            title: uikitResources.localize("VIEW_MEMBERS"),
            titleColor: (_b = theme === null || theme === void 0 ? void 0 : theme.palette.getPrimary()) !== null && _b !== void 0 ? _b : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2),
        });
    }
    static getBannedMembersOption(theme) {
        var _a, _b;
        return new uikitResources.CometChatDetailsOption({
            id: (_a = uikitResources.CometChatUIKitConstants.GroupOptions) === null || _a === void 0 ? void 0 : _a.bannedMembers,
            title: uikitResources.localize("BANNED_MEMBERS"),
            titleColor: (_b = theme === null || theme === void 0 ? void 0 : theme.palette.getPrimary()) !== null && _b !== void 0 ? _b : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2),
        });
    }
    static getAddMembersOption(theme) {
        var _a, _b;
        return new uikitResources.CometChatDetailsOption({
            id: (_a = uikitResources.CometChatUIKitConstants.GroupOptions) === null || _a === void 0 ? void 0 : _a.addMembers,
            title: uikitResources.localize("ADD_MEMBERS"),
            titleColor: (_b = theme === null || theme === void 0 ? void 0 : theme.palette.getPrimary()) !== null && _b !== void 0 ? _b : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2),
        });
    }
    static getLeaveGroupOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.GroupOptions.leave,
            title: uikitResources.localize("LEAVE"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getError()) !== null && _a !== void 0 ? _a : '#FF0000',
            titleFont: uikitResources.fontHelper(theme.typography.title2)
        });
    }
    static getDeleteGroupOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.GroupOptions.delete,
            title: uikitResources.localize("DELETE_AND_EXIT"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getError()) !== null && _a !== void 0 ? _a : '#FF0000',
            titleFont: uikitResources.fontHelper(theme.typography.title2),
        });
    }
    static getBlockUserOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.UserOptions.block,
            title: uikitResources.localize("BLOCK_USER"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getError()) !== null && _a !== void 0 ? _a : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2)
        });
    }
    static getUnBlockUserOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.UserOptions.unblock,
            title: uikitResources.localize("UNBLOCK_USER"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getError()) !== null && _a !== void 0 ? _a : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2)
        });
    }
    static getViewProfileOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.UserOptions.viewProfile,
            title: uikitResources.localize("VIEW_PROFILE"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getPrimary()) !== null && _a !== void 0 ? _a : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2)
        });
    }
    static getLeaveOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.GroupOptions.leave,
            title: uikitResources.localize("LEAVE"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getPrimary()) !== null && _a !== void 0 ? _a : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2),
        });
    }
    static getDeleteOption(theme) {
        var _a;
        return new uikitResources.CometChatDetailsOption({
            id: uikitResources.CometChatUIKitConstants.GroupOptions.delete,
            title: uikitResources.localize("DELETE_AND_EXIT"),
            titleColor: (_a = theme === null || theme === void 0 ? void 0 : theme.palette.getError()) !== null && _a !== void 0 ? _a : '#FFC900',
            titleFont: uikitResources.fontHelper(theme.typography.title2),
        });
    }
}
DetailsUtils.getDefaultGroupMemberOptions = (loggedInUser, group = null, groupMember = null) => {
};
DetailsUtils.getDefaultDetailsTemplate = (loggedInUser, user = null, group = null, theme = new uikitResources.CometChatTheme({})) => {
    return [
        DetailsUtils.getPrimaryDetailsTemplate(loggedInUser, user, group, theme),
        DetailsUtils.getSecondaryDetailsTeamplate(loggedInUser, user, group, theme)
    ];
};
DetailsUtils.getPrimaryDetailsTemplate = (loggedInUser, user = null, group = null, theme = new uikitResources.CometChatTheme({})) => {
    return new uikitResources.CometChatDetailsTemplate({
        id: uikitResources.CometChatUIKitConstants.details.primary,
        itemSeparatorColor: theme.palette.getAccent200(),
        options: (user, group, section) => {
            let options = [];
            if (user != null && user.getLink()) {
                options.push(DetailsUtils.getViewProfileOption(theme));
            }
            else if (group) {
                options.push(...[
                    DetailsUtils.getViewMembersOption(theme),
                    DetailsUtils.getAddMembersOption(theme),
                    DetailsUtils.getBannedMembersOption(theme)
                ].filter((template) => {
                    let scope = (group === null || group === void 0 ? void 0 : group.getScope()) ? group === null || group === void 0 ? void 0 : group.getScope() : uikitResources.CometChatUIKitConstants.groupMemberScope.participant;
                    let key = group.getOwner() == (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.getUid()) ? uikitResources.CometChatUIKitConstants.groupMemberScope.owner : scope;
                    return template && _allowedGroupMemberOptions$1[key][template === null || template === void 0 ? void 0 : template.id];
                }));
            }
            return options;
        }
    });
};
DetailsUtils.getSecondaryDetailsTeamplate = (loggedInUser, user = null, group = null, theme = new uikitResources.CometChatTheme({})) => {
    return new uikitResources.CometChatDetailsTemplate({
        id: uikitResources.CometChatUIKitConstants.details.secondary,
        title: group ? uikitResources.localize("MORE") : "",
        titleColor: theme.palette.getAccent600(),
        titleFont: uikitResources.fontHelper(theme.typography.caption1),
        itemSeparatorColor: theme.palette.getAccent200(),
        options: (user, group, section) => {
            let options = [];
            if (user != null) {
                if (user.getBlockedByMe()) {
                    options.push(DetailsUtils.getUnBlockUserOption(theme));
                }
                else {
                    options.push(DetailsUtils.getBlockUserOption(theme));
                }
            }
            else if (group) {
                options.push(...[
                    DetailsUtils.getLeaveGroupOption(theme),
                    DetailsUtils.getDeleteGroupOption(theme)
                ].filter((template) => {
                    let scope = (group === null || group === void 0 ? void 0 : group.getScope()) ? group === null || group === void 0 ? void 0 : group.getScope() : uikitResources.CometChatUIKitConstants.groupMemberScope.participant;
                    let key = group.getOwner() == (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.getUid()) ? uikitResources.CometChatUIKitConstants.groupMemberScope.owner : scope;
                    return _allowedGroupMemberOptions$1[key][template.id];
                }));
            }
            return options;
        }
    });
};
DetailsUtils.validateDetailOptions = (loggedInUserScope, optionId) => {
    return _allowedGroupMemberOptions$1[loggedInUserScope][optionId];
};
const _allowedGroupMemberOptions$1 = {
    [uikitResources.CometChatUIKitConstants.groupMemberScope.participant]: {
        [uikitResources.CometChatUIKitConstants.GroupOptions.leave]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.bannedMembers]: false,
        [uikitResources.CometChatUIKitConstants.GroupOptions.viewMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.addMembers]: false,
        [uikitResources.CometChatUIKitConstants.GroupOptions.delete]: false,
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.moderator]: {
        [uikitResources.CometChatUIKitConstants.GroupOptions.leave]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.bannedMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.viewMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.addMembers]: false,
        [uikitResources.CometChatUIKitConstants.GroupOptions.delete]: false,
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.admin]: {
        [uikitResources.CometChatUIKitConstants.GroupOptions.leave]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.bannedMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.viewMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.addMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.delete]: false,
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.owner]: {
        [uikitResources.CometChatUIKitConstants.GroupOptions.leave]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.bannedMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.viewMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.addMembers]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.delete]: true,
    },
};

class GroupMemberUtils {
    static getViewMemberOptions(groupMember, group, loggedInUser = "", theme = new uikitResources.CometChatTheme({})) {
        let options = [];
        let optionStyle = {
            titleFont: uikitResources.fontHelper(theme.typography.subtitle1),
            titleColor: theme.palette.getAccent(),
            backgroundColor: "transparent",
        };
        if (group.getOwner() == groupMember.getUid()) {
            options = uikitResources.CometChatUIKitConstants.groupMemberScope.owner;
        }
        else {
            let loggedInUserScope = group.getOwner() == loggedInUser ? uikitResources.CometChatUIKitConstants.groupMemberScope.owner : groupMember.getScope();
            let isKickAllowed = _allowedGroupMemberOptions[loggedInUserScope + groupMember.getScope()][uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick];
            let isBanAllowed = _allowedGroupMemberOptions[loggedInUserScope + groupMember.getScope()][uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick];
            let ischangeScopeAllowed = _allowedGroupMemberOptions[loggedInUserScope + groupMember.getScope()][uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick];
            if (isKickAllowed) {
                options.push(new uikitResources.CometChatOption({
                    id: uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick,
                    title: uikitResources.localize("REMOVE"),
                    ...optionStyle
                }));
            }
            if (isBanAllowed) {
                options.push(new uikitResources.CometChatOption({
                    id: uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban,
                    title: uikitResources.localize("BLOCK"),
                    ...optionStyle
                }));
            }
            if (ischangeScopeAllowed) {
                options.push(new uikitResources.CometChatOption({
                    id: uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope,
                    title: uikitResources.localize("CHANGE_ROLE"),
                    ...optionStyle
                }));
            }
            if (!isKickAllowed && !isBanAllowed && !ischangeScopeAllowed) {
                options = groupMember.getScope();
            }
        }
        return options;
    }
    static getBannedMemberOptions(group, groupMember, theme = new uikitResources.CometChatTheme({})) {
        if (_allowedGroupMemberOptions[group.getScope() + groupMember.getScope()][uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]) {
            return [new uikitResources.CometChatOption({
                    id: uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban,
                    titleFont: uikitResources.fontHelper(theme.typography.subtitle1),
                    titleColor: theme.palette.getAccent(),
                    backgroundColor: theme.palette.getBackground(),
                    iconTint: theme.palette.getPrimary(),
                    iconURL: ""
                })];
        }
    }
    static allowScopeChange(group, groupMember) {
        let scopes = _allowedGroupMemberOptions[group.getScope() + groupMember.getScope()][uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope];
        if ((scopes === null || scopes === void 0 ? void 0 : scopes.length) > 0 && scopes.includes(groupMember.getScope())) {
            let index = scopes.indexOf(groupMember.getScope());
            scopes.splice(index, 1);
            scopes.unshift(groupMember.getScope());
        }
        return scopes;
    }
}
const _allowedGroupMemberOptions = {
    [uikitResources.CometChatUIKitConstants.groupMemberScope.participant + uikitResources.CometChatUIKitConstants.groupMemberScope.participant]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.participant + uikitResources.CometChatUIKitConstants.groupMemberScope.moderator]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.participant + uikitResources.CometChatUIKitConstants.groupMemberScope.admin]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.participant + uikitResources.CometChatUIKitConstants.groupMemberScope.owner]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
        [uikitResources.CometChatUIKitConstants.GroupOptions.addMembers]: false,
        [uikitResources.CometChatUIKitConstants.GroupOptions.delete]: false,
        [uikitResources.CometChatUIKitConstants.GroupOptions.leave]: true,
        [uikitResources.CometChatUIKitConstants.GroupOptions.bannedMembers]: false,
        [uikitResources.CometChatUIKitConstants.GroupOptions.viewMembers]: true //Details
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.moderator + uikitResources.CometChatUIKitConstants.groupMemberScope.participant]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.moderator + uikitResources.CometChatUIKitConstants.groupMemberScope.moderator]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.moderator + uikitResources.CometChatUIKitConstants.groupMemberScope.admin]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.moderator + uikitResources.CometChatUIKitConstants.groupMemberScope.owner]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.admin + uikitResources.CometChatUIKitConstants.groupMemberScope.participant]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.admin, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.admin + uikitResources.CometChatUIKitConstants.groupMemberScope.moderator]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.admin, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.admin + uikitResources.CometChatUIKitConstants.groupMemberScope.admin]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.admin, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.admin + uikitResources.CometChatUIKitConstants.groupMemberScope.owner]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: false,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.owner + uikitResources.CometChatUIKitConstants.groupMemberScope.participant]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.admin, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.owner + uikitResources.CometChatUIKitConstants.groupMemberScope.moderator]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.admin, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
    [uikitResources.CometChatUIKitConstants.groupMemberScope.owner + uikitResources.CometChatUIKitConstants.groupMemberScope.admin]: {
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.kick]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.ban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.unban]: true,
        [uikitResources.CometChatUIKitConstants.GroupMemberOptions.changeScope]: [uikitResources.CometChatUIKitConstants.groupMemberScope.participant, uikitResources.CometChatUIKitConstants.groupMemberScope.admin, uikitResources.CometChatUIKitConstants.groupMemberScope.moderator],
    },
};

class MessageReceiptUtils {
}
MessageReceiptUtils.getReceiptStatus = (messageObject) => {
    var _a;
    let icon = receipts.wait;
    if ((messageObject === null || messageObject === void 0 ? void 0 : messageObject.error) || ((_a = messageObject === null || messageObject === void 0 ? void 0 : messageObject.metadata) === null || _a === void 0 ? void 0 : _a.error)) {
        icon = receipts.error;
    }
    else if ((messageObject === null || messageObject === void 0 ? void 0 : messageObject.getReceiverType()) == uikitResources.CometChatUIKitConstants.MessageReceiverType.group) {
        if ((messageObject === null || messageObject === void 0 ? void 0 : messageObject.getSentAt()) && (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getId())) {
            icon = receipts.sent;
        }
        else if (!messageObject.getSender()) {
            icon = receipts.wait;
        }
    }
    else {
        if (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getReadAt()) {
            icon = receipts.read;
        }
        else if (!(messageObject === null || messageObject === void 0 ? void 0 : messageObject.getReadAt()) && (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getDeliveredAt())) {
            icon = receipts.delivered;
        }
        else if ((messageObject === null || messageObject === void 0 ? void 0 : messageObject.getSentAt()) && (messageObject === null || messageObject === void 0 ? void 0 : messageObject.getId())) {
            icon = receipts.sent;
        }
        else {
            icon = receipts.wait;
        }
    }
    return icon;
};
var receipts;
(function (receipts) {
    receipts[receipts["wait"] = 0] = "wait";
    receipts[receipts["sent"] = 1] = "sent";
    receipts[receipts["delivered"] = 2] = "delivered";
    receipts[receipts["read"] = 3] = "read";
    receipts[receipts["error"] = 4] = "error";
})(receipts || (receipts = {}));

class InteractiveMessageUtils {
    /**
     * Converts an interactive message to its corresponding object type.
     * @param message The message to convert.
     * @returns The converted message object.
     */
    static convertInteractiveMessage(message) {
        if (message.getCategory() === uikitResources.CometChatUIKitConstants.MessageCategory.interactive && !message.getDeletedAt()) {
            switch (message.getType()) {
                case uikitResources.CometChatUIKitConstants.MessageTypes.form:
                    return uikitResources.FormMessage.fromJSON(message);
                case uikitResources.CometChatUIKitConstants.MessageTypes.card:
                    return uikitResources.CardMessage.fromJSON(message);
                default:
                    return message;
            }
        }
        else {
            return message;
        }
    }
    static async fetcher({ url, method, body, headers, }) {
        try {
            const res = await fetch(url, {
                method,
                body: JSON.stringify(body),
                headers: {
                    "Content-Type": "application/json",
                    ...headers,
                },
            });
            return res;
        }
        catch (error) {
            throw error;
        }
    }
    static async actionHandler(action, data) {
        var _a, _b;
        let returnBool = false;
        switch (action.getActionType()) {
            case uikitResources.ButtonAction.apiAction:
                const dataKey = (action === null || action === void 0 ? void 0 : action.getDataKey()) || "CometChatData";
                let payload = action.getPayload() || {};
                if (!(typeof payload === "object")) {
                    payload = {};
                }
                if (data === null || data === void 0 ? void 0 : data.data) {
                    payload[dataKey] = data.data;
                }
                if (data === null || data === void 0 ? void 0 : data.loggedInUser) {
                    if (payload[dataKey]) {
                        payload[dataKey]["cometchatSenderUid"] = (_a = data === null || data === void 0 ? void 0 : data.loggedInUser) === null || _a === void 0 ? void 0 : _a.getUid();
                    }
                    else {
                        payload[dataKey] = {
                            "cometchatSenderUid": (_b = data === null || data === void 0 ? void 0 : data.loggedInUser) === null || _b === void 0 ? void 0 : _b.getUid()
                        };
                    }
                }
                const response = await InteractiveMessageUtils.fetcher({
                    url: action.getURL(),
                    method: action.getMethod() || uikitResources.HTTPSRequestMethods.POST,
                    body: payload,
                    headers: action.getHeaders() || {},
                });
                if (response.status === 200) {
                    returnBool = true;
                }
                break;
            case uikitResources.ButtonAction.urlNavigation:
                window.open(action.getURL(), "_blank");
                returnBool = true;
                break;
            case uikitResources.ButtonAction.custom:
                returnBool = true;
                break;
        }
        return returnBool;
    }
}

/**
 * BaseStyle
 *
 * @property {string} height - The height of the component.
 * @property {string} width - The width of the component.
 * @property {string} border - The border of the component.
 * @property {string} borderRadius - The border radius of the component.
 * @property {string} background - The background color of the component.
 */
class BaseStyle {
    constructor(props) {
        this.height = "100%";
        this.width = "100%";
        this.border = "0 none";
        this.borderRadius = "inherit";
        this.background = "inherit";
        Object.assign(this, props);
    }
}

/**
 * The ContactsStyle class defines the style properties for adding members to a group.
 *
 * @extends BaseStyle
 *
 * @property {string} titleTextFont - Font style for the title text.
 * @property {string} titleTextColor - Color for the title text.
 * @property {string} errorStateTextFont - Font style for the error state text.
 * @property {string} errorStateTextColor - Color for the error state text.
 * @property {string} boxShadow - Box shadow for the contacts container.
 * @property {string} closeButtonIconTint - Tint color for the close button icon.
 * @property {string} submitButtonBackground - Background color for the contacts button.
 * @property {string} submitButtonTextColor - Text color for the contacts button.
 * @property {string} submitButtonTextFont - Font style for the text in the contacts button.
 * @property {string} tabWidth - Width of the tab
 * @property {string} tabHeight - Height of the tab
 * @property {string} tabBorder - Border of the tab
 * @property {string} tabBorderRadius - Border Radius of the tab
 * @property {string} tabBackground - Background of the tab
 * @property {string} tabTitleTextFont - Font style for the tab title
 * @property {string} tabTitleTextColor - Font style for the tab title
 * @property {string} activeTabTitleTextColor - Font style for the active tab title
 * @property {string} activeTabTitleTextFont - Font style for the active tab title
 * @property {string} activeTabBackground  - Background style for the active tab
 * @property {string} activeTabBorder - Border style for the active tab
 * @property {string} selectionIconTint - Selection icon tint
 */
class ContactsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.closeIconTint = "RGB(51, 153, 255)";
        this.tabWidth = "";
        this.tabHeight = "";
        this.tabBorder = "";
        this.tabBorderRadius = "";
        this.tabBackground = "";
        this.tabTitleTextFont = "";
        this.tabTitleTextColor = "";
        this.activeTabTitleTextColor = "";
        this.activeTabTitleTextFont = "";
        this.activeTabBackground = "";
        this.activeTabBorder = "";
        this.selectionIconTint = "";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.boxShadow = "";
        this.submitButtonBackground = "RGB(51, 153, 255)";
        this.submitButtonTextColor = "white";
        this.submitButtonTextFont = "600 15px Inter, sans-serif";
        this.padding = "0 100px";
        Object.assign(this, props);
    }
}

/**
 * WithDetailsStyle
 *
 * @property {string} iconTint - The icon color of the component.
 * @property {string} activeIconTint - The active icon color of the component.
 * @property {string} titleTextFont - The title font of the component.
 * @property {string} titleTextColor - The title color of the component.
 * @property {string} activeTitleTextFont - The active title font of the component.
 * @property {string} activeTitleTextColor - The active title color  of the component.
 * @property {string} activeBackground - The mactive background color of the component.
 */
class TabItemStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.iconTint = "RGBA(20, 20, 20, 0.33)";
        this.activeIconTint = "RGB(51, 153, 255)";
        this.titleTextFont = "400 13px Inter";
        this.titleTextColor = "black";
        this.activeTitleTextFont = "400 13px Inter";
        this.activeTitleTextColor = "RGB(51, 153, 255)";
        this.activeBackground = "transparent";
        this.activeBorderRadius = "0";
        this.boxShadow = "";
        Object.assign(this, props);
    }
}

/**
 * ListStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} titleTextFont - Font for title text.
 * @property {string} titleTextColor - Color for title text.
 * @property {string} searchPlaceholderTextFont - Font for search placeholder text.
 * @property {string} searchPlaceholderTextColor - Color for search placeholder text.
 * @property {string} searchTextFont - Font for search text.
 * @property {string} searchTextColor - Color for search text.
 * @property {string} emptyStateTextFont - Font for empty state text.
 * @property {string} emptyStateTextColor - Color for empty state text.
 * @property {string} errorStateTextFont - Font for error state text.
 * @property {string} errorStateTextColor - Color for error state text.
 * @property {string} loadingIconTint - Tint color for loading icon.
 * @property {string} searchIconTint - Tint color for search icon.
 * @property {string} searchBorder - Border for the search field.
 * @property {string} searchBorderRadius - Border radius for the search field.
 * @property {string} searchBackground - Background color for the search field.
 * @property {string} onlineStatusColor - Color for online status.
 * @property {string} separatorColor - Color for separator.
 * @property {string} sectionHeaderTextFont - Font for section header text.
 * @property {string} sectionHeaderTextColor - Color for section header text.
 * @property {string} boxShadow - Shadow for the box.
 */
class ListStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.searchIconTint = "#bcbcbc";
        this.searchBorder = "1px solid RGBA(20, 20, 20, 0.04)";
        this.searchBorderRadius = "8px";
        this.searchBackground = "RGBA(20, 20, 20, 0.04)";
        this.searchPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.searchPlaceholderTextColor = "#bcbcbc";
        this.searchTextFont = "400 13px Inter, sans-serif";
        this.searchTextColor = "RGBA(20, 20, 20, 0.58)";
        this.sectionHeaderTextFont = "500 12px Inter";
        this.sectionHeaderTextColor = "RGBA(20, 20, 20, 0.46)";
        Object.assign(this, props);
    }
}

class TransferOwnershipStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.MemberScopeTextColor = "rgba(20, 20, 20, 0.33)";
        this.MemberScopeTextFont = "400 15px sans-serif";
        this.transferButtonTextFont = "600 15px Inter, sans-serif";
        this.transferButtonTextColor = "white";
        this.cancelButtonTextFont = "600 15px Inter, sans-serif";
        this.cancelButtonTextColor = "black";
        Object.assign(this, props);
    }
}

/**
 * WithMessagesStyle
 *
 * @property {string} height - The height of the component.
 * @property {string} width - The width of the component.
 * @property {string} border - The border of the component.
 * @property {string} borderRadius - The border radius of the component.
 * @property {string} background - The background color of the component.
 * @property {string} messageTextColor - The messageText color of the component.
 * @property {string} messageTextFont - The messageText font of the component.
 */
class WithMessagesStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.messageTextColor = "RGBA(20, 20, 20, 0.33)";
        this.messageTextFont = "700 22px Inter";
        Object.assign(this, props);
    }
}

/**
 * ConversationsStyle
 *
 * @extends BaseStyle
 *
 * @property {string} titleTextFont - The font of the title text.
 * @property {string} titleTextColor - The color of the title text.
 * @property {string} searchPlaceholderTextFont - The font of the search placeholder text.
 * @property {string} searchPlaceholderTextColor - The color of the search placeholder text.
 * @property {string} searchTextFont - The font of the search text.
 * @property {string} searchTextColor - The color of the search text.
 * @property {string} emptyStateTextFont - The font of the empty state text.
 * @property {string} emptyStateTextColor - The color of the empty state text.
 * @property {string} errorStateTextFont - The font of the error state text.
 * @property {string} errorStateTextColor - The color of the error state text.
 * @property {string} loadingIconTint - The tint color of the loading icon.
 * @property {string} searchIconTint - The tint color of the search icon.
 * @property {string} searchBorder - The border of the search input.
 * @property {string} searchBorderRadius - The border radius of the search input.
 * @property {string} searchBackground - The background color of the search input.
 * @property {string} onlineStatusColor - The color of the online status indicator.
 * @property {string} separatorColor - The color of the separator.
 * @property {string} boxShadow - The box shadow of the component.
 * @property {string} privateGroupIconBackground - The background color of the private group icon.
 * @property {string} passwordGroupIconBackground - The background color of the password group icon.
 * @property {string} sectionHeaderTextFont - The font of the section header text.
 * @property {string} sectionHeaderTextColor - The color of the section header text.
 * @property {string} lastMessageTextColor - The color of the last message text.
 * @property {string} lastMessageTextFont - The font of the last message text.
 * @property {string} typingIndictorTextColor - The color of the typing indicator text.
 * @property {string} typingIndictorTextFont - The font of the typing indicator text.
 * @property {string} threadIndicatorTextFont - The font of the thread indicator text.
 * @property {string} threadIndicatorTextColor - The color of the thread indicator text.
 */
class ConversationsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.onlineStatusColor = "RGB(0, 200, 111)";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.privateGroupIconBackground = "RGBA(20, 20, 20, 0.04)";
        this.passwordGroupIconBackground = "RGB(247, 165, 0)";
        this.lastMessageTextColor = "rgba(20, 20, 20, 0.58)";
        this.lastMessageTextFont = "400 13px Inter, sans-serif";
        this.typingIndictorTextColor = "RGB(67, 161, 255)";
        this.typingIndictorTextFont = "400 13px Inter, sans-serif";
        this.threadIndicatorTextFont = "400 13px Inter, sans-serif";
        this.threadIndicatorTextColor = "RGBA(20, 20, 20, 0.6)";
        Object.assign(this, props);
    }
}

/**
 * GroupsStyle Class to define the styles for the Groups component.
 *
 * @property {string} titleTextFont - The font for the title text.
 * @property {string} titleTextColor - The color for the title text.
 * @property {string} searchPlaceholderTextFont - The font for the search placeholder text.
 * @property {string} searchPlaceholderTextColor - The color for the search placeholder text.
 * @property {string} searchTextFont - The font for the search text.
 * @property {string} searchTextColor - The color for the search text.
 * @property {string} emptyStateTextFont - The font for the empty state text.
 * @property {string} emptyStateTextColor - The color for the empty state text.
 * @property {string} errorStateTextFont - The font for the error state text.
 * @property {string} errorStateTextColor - The color for the error state text.
 * @property {string} loadingIconTint - The tint color for the loading icon.
 * @property {string} searchIconTint - The tint color for the search icon.
 * @property {string} searchBorder - The border for the search field.
 * @property {string} searchBorderRadius - The border radius for the search field.
 * @property {string} searchBackground - The background color for the search field.
 * @property {string} onlineStatusColor - The color for the online status indicator.
 * @property {string} separatorColor - The color for the separators between items.
 * @property {string} boxShadow - The box shadow for the group item.
 * @property {string} subTitleTextFont - The font for the subtitle text.
 * @property {string} subTitleTextColor - The color for the subtitle text.
 * @property {string} privateGroupIconBackground - The background color for the private group icon.
 * @property {string} passwordGroupIconBackground - The background color for the password protected group icon.
 *
 * @extends {BaseStyle}
 */
class GroupsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.privateGroupIconBackground = "RGBA(20, 20, 20, 0.04)";
        this.passwordGroupIconBackground = "RGB(247, 165, 0)";
        this.searchIconTint = "#bcbcbc";
        this.searchBorder = "1px solid RGBA(20, 20, 20, 0.04)";
        this.searchBorderRadius = "8px";
        this.searchBackground = "RGBA(20, 20, 20, 0.04)";
        this.searchPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.searchPlaceholderTextColor = "#bcbcbc";
        this.searchTextFont = "400 13px Inter, sans-serif";
        this.searchTextColor = "RGBA(20, 20, 20, 0.58)";
        this.subTitleTextFont = "400 13px Inter, sans-serif";
        this.subTitleTextColor = "RGBA(20, 20, 20, 0.58)";
        Object.assign(this, props);
    }
}

/**
 * MessageComposerStyle class defines the style for a message composer component.
 *
 * @property {string} attachIcontint - The tint color for the attach icon.
 * @property {string} sendIconTint - The tint color for the send icon.
 * @property {string} emojiIconTint - The tint color for the emoji icon.
 * @property {string} inputBackground - The background color for the input field.
 * @property {string} inputBorder - The border color for the input field.
 * @property {string} dividerTint - The tint color for the divider.
 * @property {string} textFont - The font for the text.
 * @property {string} textColor - The color for the text.
 * @property {string} placeHolderTextColor - The color for the placeholder text.
 * @property {string} placeHolderTextFont - The font for the placeholder text.
 * @property {string} ActionSheetSeparatorTint - The tint color for the action sheet separator.
 * @property {string} ActionSheetTitleColor - The color for the action sheet title.
 * @property {string} ActionSheetTitleFont - The font for the action sheet title.
 * @property {string} ActionSheetLayoutModeIconTint - The tint color for the action sheet layout mode icon.
 * @property {string} emojiKeyboardTextFont - The font for the emoji keyboard text.
 * @property {string} emojiKeyboardTextColor - The color for the emoji keyboard text.
 * @property {string} previewTitleFont - The font for the preview title.
 * @property {string} previewTitleColor - The color for the preview title.
 * @property {string} previewSubtitleFont - The font for the preview subtitle.
 * @property {string} previewSubtitleColor - The color for the preview subtitle.
 * @property {string} closePreviewTint - The tint color for the close preview button.
 * @property {string} maxInputHeight - The maximum height of the input field.
 * @extends {BaseStyle}
 */
class MessageComposerStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.attachIcontint = "RGBA(20, 20, 20, 0.46)";
        this.sendIconTint = "RGBA(20, 20, 20, 0.46)";
        this.emojiIconTint = "RGBA(20, 20, 20, 0.46)";
        this.AIIconTint = "RGBA(20, 20, 20, 0.46)";
        this.voiceRecordingIconTint = "RGBA(20, 20, 20, 0.46)";
        this.inputBackground = "RGBA(20, 20, 20, 0.04)";
        this.inputBorder = "1px solid RGBA(20, 20, 20, 0.08)";
        this.inputBorderRadius = "12px";
        this.dividerTint = "RGBA(20, 20, 20, 0.08)";
        this.textFont = "400 13px Inter";
        this.textColor = "black";
        this.placeHolderTextColor = "";
        this.placeHolderTextFont = "";
        this.emojiKeyboardTextFont = "400 13px Inter";
        this.emojiKeyboardTextColor = "RGBA(20, 20, 20, 0.6)";
        this.previewTitleFont = "500 12px Inter, sans-serif";
        this.previewTitleColor = "grey";
        this.previewSubtitleColor = "grey";
        this.previewSubtitleFont = "400 13px Inter, sans-serif";
        this.closePreviewTint = "grey";
        this.maxInputHeight = "100px";
        Object.assign(this, props);
    }
}

/**
 * MessageHeaderStyle class represents the styles for message header.
 *
 * @property {string} backButtonIconTint- Tint color for back button icon.
 * @property {string} onlineStatusColor - Color for online status.
 * @property {string} subtitleTextColor - Text color for subtitle.
 * @property {string} subtitleTextFont - Font for subtitle text.
 * @property {string} typingIndicatorTextColor - Text color for typing indicator.
 * @property {string} typingIndicatorTextFont - Font for typing indicator text.
 *  @extends {BaseStyle}
 */
class MessageHeaderStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.backButtonIconTint = "#3399FF";
        this.onlineStatusColor = "#00f300";
        this.subtitleTextColor = "grey";
        this.subtitleTextFont = "400 14px Inter";
        this.typingIndicatorTextColor = "#3399FF";
        this.typingIndicatorTextFont = "400 13px Inter";
        this.privateGroupIconBackground = "rgb(0, 200, 111)";
        this.passwordGroupIconBackground = "RGB(247, 165, 0)";
        Object.assign(this, props);
    }
}

/**
 * MessageListStyle class represents the styles for message list. It extends BaseStyle.
 *
 * @property {string} nameTextFont - Font for name text.
 * @property {string} nameTextColor - Color for name text.
 * @property {string} threadReplySeparatorColor - Separator color for thread reply.
 * @property {string} threadReplyTextFont - Font for thread reply text.
 * @property {string} threadReplyIconTint - Tint color for thread reply icon.
 * @property {string} threadReplyTextColor - Color for thread reply text.
 * @property {string} textFont - Font for text.
 * @property {string} textColor - Color for text.
 * @property {string} emptyStateTextFont - Font for empty state text.
 * @property {string} emptyStateTextColor - Color for empty state text.
 * @property {string} errorStateTextFont - Font for error state text.
 * @property {string} errorStateTextColor - Color for error state text.
 * @property {string} loadingIconTint - Tint color for loading icon.
 *   @extends {BaseStyle}
 */
class MessageListStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.nameTextFont = "500 12px Inter, sans-serif";
        this.nameTextColor = "RGBA(20, 20, 20, 0.6)";
        this.threadReplySeparatorColor = "#bcbcbc";
        this.threadReplyTextFont = "500 15px Inter, sans-serif,";
        this.threadReplyIconTint = "RGBA(20, 20, 20, 0.6)";
        this.threadReplyTextColor = "RGB(51, 153, 255)";
        this.TimestampTextFont = "";
        this.TimestampTextColor = "";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "grey";
        Object.assign(this, props);
    }
}

/**
 * MessagesStyle class represents the styles for messages. It extends BaseStyle.
 *
 * @property {string} messageTextColor - Color for message text.
 * @property {string} messageTextFont - Font for message text.
 *   @extends {BaseStyle}
 */
class MessagesStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.messageTextColor = "rgba(20, 20, 20, 0.33)";
        this.messageTextFont = "700 22px Inter";
        Object.assign(this, props);
    }
}

/**
 * UsersStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} titleTextFont - Font for title text.
 * @property {string} titleTextColor - Color for title text.
 * @property {string} searchPlaceholderTextFont - Font for search placeholder text.
 * @property {string} searchPlaceholderTextColor - Color for search placeholder text.
 * @property {string} searchTextFont - Font for search text.
 * @property {string} searchTextColor - Color for search text.
 * @property {string} emptyStateTextFont - Font for empty state text.
 * @property {string} emptyStateTextColor - Color for empty state text.
 * @property {string} errorStateTextFont - Font for error state text.
 * @property {string} errorStateTextColor - Color for error state text.
 * @property {string} loadingIconTint - Tint color for loading icon.
 * @property {string} searchIconTint - Tint color for search icon.
 * @property {string} searchBorder - Border for the search field.
 * @property {string} searchBorderRadius - Border radius for the search field.
 * @property {string} searchBackground - Background color for the search field.
 * @property {string} onlineStatusColor - Color for online status.
 * @property {string} separatorColor - Color for separator.
 * @property {string} sectionHeaderTextFont - Font for section header text.
 * @property {string} sectionHeaderTextColor - Color for section header text.
 * @property {string} boxShadow - Shadow for the box.
 */
class UsersStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.onlineStatusColor = "RGB(0, 200, 111)";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.searchIconTint = "#bcbcbc";
        this.searchBorder = "1px solid RGBA(20, 20, 20, 0.04)";
        this.searchBorderRadius = "8px";
        this.searchBackground = "RGBA(20, 20, 20, 0.04)";
        this.searchPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.searchPlaceholderTextColor = "#bcbcbc";
        this.searchTextFont = "400 13px Inter, sans-serif";
        this.searchTextColor = "RGBA(20, 20, 20, 0.58)";
        this.sectionHeaderTextFont = "500 12px Inter";
        this.sectionHeaderTextColor = "RGBA(20, 20, 20, 0.46)";
        Object.assign(this, props);
    }
}

/**
 * GroupMembersStyle Class representing the styles for group members
 *
 * @property {string} titleTextFont - The font style for the title text.
 * @property {string} titleTextColor - The text color for the title text.
 * @property {string} searchPlaceholderTextFont - The font style for the search placeholder text.
 * @property {string} searchPlaceholderTextColor - The text color for the search placeholder text.
 * @property {string} searchTextFont - The font style for the search text.
 * @property {string} searchTextColor - The text color for the search text.
 * @property {string} emptyStateTextFont - The font style for the empty state text.
 * @property {string} emptyStateTextColor - The text color for the empty state text.
 * @property {string} errorStateTextFont - The font style for the error state text.
 * @property {string} errorStateTextColor - The text color for the error state text.
 * @property {string} loadingIconTint - The tint color for the loading icon.
 * @property {string} searchIconTint - The tint color for the search icon.
 * @property {string} searchBorder - The border for the search box.
 * @property {string} searchBorderRadius - The border radius for the search box.
 * @property {string} searchBackground - The background color for the search box.
 * @property {string} onlineStatusColor - The color indicating the online status of a member.
 * @property {string} separatorColor - The color of the separator.
 * @property {string} sectionHeaderTextFont - The font style for the section header text.
 * @property {string} sectionHeaderTextColor - The text color for the section header text.
 * @property {string} boxShadow - The box shadow for the members list.
 * @property {string} backButtonIconTint - The tint color for the back button icon.
 * @property {string} closeButtonIconTint - The tint color for the close button icon.
 * @property {string} privateGroupIconBackground - The background color for the private group icon.
 * @property {string} passwordGroupIconBackground - The background color for the password protected group icon.
 *
 * @extends {BaseStyle}
 */
class GroupMembersStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.searchPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.searchPlaceholderTextColor = "#bcbcbc";
        this.searchTextFont = "400 13px Inter, sans-serif";
        this.searchTextColor = "RGBA(20, 20, 20, 0.58)";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.searchIconTint = "#bcbcbc";
        this.searchBorder = "1px solid RGBA(20, 20, 20, 0.04)";
        this.searchBorderRadius = "8px";
        this.searchBackground = "RGBA(20, 20, 20, 0.04)";
        this.onlineStatusColor = "RGB(0, 200, 111)";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.boxShadow = "";
        this.backButtonIconTint = "RGB(51, 153, 255)";
        this.closeButtonIconTint = "RGB(51, 153, 255)";
        this.privateGroupIconBackground = "RGBA(20, 20, 20, 0.04)";
        this.passwordGroupIconBackground = "RGB(247, 165, 0)";
        this.padding = "0 100px";
        Object.assign(this, props);
    }
}

/**
 * The AddMembersStyle class defines the style properties for adding members to a group.
 *
 * @extends BaseStyle
 *
 * @property {string} titleTextFont - Font style for the title text.
 * @property {string} titleTextColor - Color for the title text.
 * @property {string} searchPlaceholderTextFont - Font style for the search placeholder text.
 * @property {string} searchPlaceholderTextColor - Color for the search placeholder text.
 * @property {string} searchTextFont - Font style for the search text.
 * @property {string} searchTextColor - Color for the search text.
 * @property {string} emptyStateTextFont - Font style for the empty state text.
 * @property {string} emptyStateTextColor - Color for the empty state text.
 * @property {string} errorStateTextFont - Font style for the error state text.
 * @property {string} errorStateTextColor - Color for the error state text.
 * @property {string} loadingIconTint - Tint color for the loading icon.
 * @property {string} searchIconTint - Tint color for the search icon.
 * @property {string} searchBorder - Border for the search container.
 * @property {string} searchBorderRadius - Border radius for the search container.
 * @property {string} searchBackground - Background color for the search container.
 * @property {string} onlineStatusColor - Color for the online status indicator.
 * @property {string} separatorColor - Color for the separator.
 * @property {string} sectionHeaderTextFont - Font style for the section header text.
 * @property {string} sectionHeaderTextColor - Color for the section header text.
 * @property {string} boxShadow - Box shadow for the add members container.
 * @property {string} backButtonIconTint - Tint color for the back button icon.
 * @property {string} closeButtonIconTint - Tint color for the close button icon.
 * @property {string} privateGroupIconBackground - Background color for the private group icon.
 * @property {string} passwordGroupIconBackground - Background color for the password protected group icon.
 * @property {string} addMembersButtonBackground - Background color for the add members button.
 * @property {string} addMembersButtonTextColor - Text color for the add members button.
 * @property {string} addMembersButtonTextFont - Font style for the text in the add members button.
 */
class AddMembersStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.searchPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.searchPlaceholderTextColor = "#bcbcbc";
        this.searchTextFont = "400 13px Inter, sans-serif";
        this.searchTextColor = "RGBA(20, 20, 20, 0.58)";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.searchIconTint = "#bcbcbc";
        this.searchBorder = "1px solid RGBA(20, 20, 20, 0.04)";
        this.searchBorderRadius = "8px";
        this.searchBackground = "RGBA(20, 20, 20, 0.04)";
        this.onlineStatusColor = "RGB(0, 200, 111)";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.sectionHeaderTextFont = "500 12px Inter, sans-serif";
        this.sectionHeaderTextColor = "RGBA(20, 20, 20, 0.46)";
        this.boxShadow = "";
        this.backButtonIconTint = "RGB(51, 153, 255)";
        this.closeButtonIconTint = "RGB(51, 153, 255)";
        this.addMembersButtonBackground = "RGB(51, 153, 255)";
        this.addMembersButtonTextColor = "white";
        this.addMembersButtonTextFont = "600 15px Inter, sans-serif";
        this.padding = "0 100px";
        Object.assign(this, props);
    }
}

/**
 * BannedMembersStyle
 *
 * @extends BaseStyle
 *
 * @property {string} titleTextFont - The font of the title text.
 * @property {string} titleTextColor - The color of the title text.
 * @property {string} searchPlaceholderTextFont - The font of the search placeholder text.
 * @property {string} searchPlaceholderTextColor - The color of the search placeholder text.
 * @property {string} searchTextFont - The font of the search text.
 * @property {string} searchTextColor - The color of the search text.
 * @property {string} emptyStateTextFont - The font of the empty state text.
 * @property {string} emptyStateTextColor - The color of the empty state text.
 * @property {string} errorStateTextFont - The font of the error state text.
 * @property {string} errorStateTextColor - The color of the error state text.
 * @property {string} loadingIconTint - The tint of the loading icon.
 * @property {string} searchIconTint - The tint of the search icon.
 * @property {string} searchBorder - The border of the search field.
 * @property {string} searchBorderRadius - The border radius of the search field.
 * @property {string} searchBackground - The background color of the search field.
 * @property {string} onlineStatusColor - The color of the online status.
 * @property {string} separatorColor - The color of the separator.
 * @property {string} sectionHeaderTextFont - The font of the section header text.
 * @property {string} sectionHeaderTextColor - The color of the section header text.
 * @property {string} boxShadow - The box shadow style.
 * @property {string} backButtonIconTint - The tint of the back button icon.
 * @property {string} closeButtonIconTint - The tint of the close button icon.
 * @property {string} privateGroupIconBackground - The background color of the private group icon.
 * @property {string} passwordGroupIconBackground - The background color of the password group icon.
 * @property {string} unbanIconTint - The tint of the unban icon.
 */
class BannedMembersStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.searchPlaceholderTextFont = "400 15px Inter, sans-serif";
        this.searchPlaceholderTextColor = "#bcbcbc";
        this.searchTextFont = "400 13px Inter, sans-serif";
        this.searchTextColor = "RGBA(20, 20, 20, 0.58)";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.searchIconTint = "#bcbcbc";
        this.searchBorder = "1px solid RGBA(20, 20, 20, 0.04)";
        this.searchBorderRadius = "8px";
        this.searchBackground = "RGBA(20, 20, 20, 0.04)";
        this.onlineStatusColor = "RGB(0, 200, 111)";
        this.separatorColor = "RGBA(20, 20, 20, 0.04)";
        this.boxShadow = "";
        this.backButtonIconTint = "RGB(51, 153, 255)";
        this.closeButtonIconTint = "RGB(51, 153, 255)";
        this.unbanIconTint = "RGB(51, 153, 255)";
        this.padding = "0 100px";
        Object.assign(this, props);
    }
}

/**
 * ThreadedMessagesStyle class represents the styles for ThreadedMessagesStyle. It extends BaseStyle.
 *
 * @property {string} titleColor - Color for title text.
 * @property {string} titleFont - Font for title text.
 * @property {string} closeIconTint - Shadow for the box.
 *   @extends {BaseStyle}
 */
class ThreadedMessagesStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleColor = "rgba(20, 20, 20, 0.33)";
        this.titleFont = "700 22px Inter";
        this.closeIconTint = "rgba(20, 20, 20, 0.1)";
        Object.assign(this, props);
    }
}

/**
 * DetailsStyle
 *
 * @extends BaseStyle
 *
 * @property {string} titleTextFont - The font of the title text.
 * @property {string} titleTextColor - The color of the title text.
 * @property {string} onlineStatusColor - The color of the online status indicator.
 * @property {string} separatorColor - The color of the separator.
 * @property {string} privateGroupIconBackground - The background color of the private group icon.
 * @property {string} passwordGroupIconBackground - The background color of the password group icon.
 * @property {string} subtitleTextColor - The color of the subtitle text.
 * @property {string} subtitleTextFont - The font of the subtitle text.
 * @property {string} closeButtonIconTint - The color of the close button
 *  @property {string} margin - The margin of the DetailsComponent
 */
class DetailsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.onlineStatusColor = "RGB(0, 200, 111)";
        this.privateGroupIconBackground = "RGB(0, 200, 111)";
        this.passwordGroupIconBackground = "RGB(247, 165, 0)";
        this.subtitleTextColor = "rgba(20, 20, 20, 0.58)";
        this.subtitleTextFont = "400 13px Inter, sans-serif";
        this.closeButtonIconTint = "RGB(51, 153, 255)";
        this.padding = "0 100px";
        Object.assign(this, props);
    }
}

class OptionsStyle {
    constructor(props) {
        this.titleFont = "";
        this.titleColor = "";
        this.background = "";
        this.iconTint = "";
        Object.assign(this, props);
    }
}

/**
 * MessageInformationStyle class represents the styles for Message information component. It extends BaseStyle.
 *
 * @property {string} titleTextFont - Font for title text.
 * @property {string} titleTextColor - Color for title text.
 * @property {string} sendIconTint - Send icon tint.
 * @property {string} readIconTint - Read icon tint.
 * @property {string} deliveredIconTint - Delivered icon tint.
 * @property {string} emptyStateTextFont - Font for empty state text.
 * @property {string} emptyStateTextColor - Color for empty state text.
 * @property {string} errorStateTextFont - Font for error state text.
 * @property {string} errorStateTextColor - Color for error state text.
 * @property {string} loadingIconTint - Tint color for loading icon.
 * @property {string} subtitleTextFont - Font for subtitle  text.
 * @property {string} subtitleTextColor - Color for subtitle  text.
 * @property {string} dividerTint - divider icon tint.
 */
class MessageInformationStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.sendIconTint = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.readIconTint = "RGBA(20, 20, 20, 0.04)";
        this.deliveredIconTint = "#bcbcbc";
        this.subtitleTextFont = "500 12px Inter";
        this.subtitleTextColor = "RGBA(20, 20, 20, 0.46)";
        this.dividerTint = "";
        this.captionTextFont = "400 13px Inter, sans-serif";
        this.captionTextColor = "#bcbcbc";
        Object.assign(this, props);
    }
}

var LoadingIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FSpinner%402x%3C%2Ftitle%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpattern%20id%3D%22pattern-1%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20patternUnits%3D%22objectBoundingBox%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23image-2%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%3C%2Fpattern%3E%20%20%20%20%20%20%20%20%3Cimage%20id%3D%22image-2%22%20width%3D%2224%22%20height%3D%2224%22%20xlink%3Ahref%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAACH0lEQVRIDY2SyU0FQQxE57PDlThIAIkDSARARqRAJITACQ5ciYMr%2B1av6TfyDAPCUn27vVS5%2B89qGIaLYK1gvcd4sTGL5%2Bc6Ixe5FY0fQbVVDuBzAUt99kusJ7%2F2l0AdRKxarTWiFCWe%2BP8IcENvgwiEWBWZkKbmk41PVAnadP%2BBBAFFrP2HvIlyg%2FeAg%2BZzQGJNAWt1Yz%2BE6q23G0DCICQ0SZKwGc3kqWNuXwmJWRYvOX4iwCDkFPAKkVeAHGdFIa0wb88owHYmaeIMFCEHkX3EmwWcvRG9cDVQ4IlMSEATeYUSNoKdeGqQbwXbPf7xNMmPAm%2F9EDcKUYSImkskHHYDyPc6EHFzl6x%2BMpzeZjRgtRGxx5YdhoP4%2FQAhyO1L2GI81njYji2r%2Be54wVO9BnfBeXAZHAY%2BYZ1JerRPr18bKikELAD5Q3AfsP1ZP7%2FEXwVHAb3Ojny%2BsyQQAQbBUwfkgFr9D%2FhPTnuO%2FE2PWZzn20CAr0VUIUWeUwec2ZIZyPyK%2BJKIyZ0E1LnRdbDuE3k9PJgLIkyOGn8ecxD6FP7RLnyb2jH1JQHJ8RALl4AMovYE8YokbEtQd5GJAEkhuWLmIXFbBMwrQo0Ze0YBGmimuOTJ0SMRNxAImU%2FYTIEPnsgt9G6tmPlKIoEi%2BLrAt0xusiQgYfV1GHJsLlJ7rC%2FeQGIGiOeDDiPA5vT8doP2uUlY%2FRI5uWr1Bi4x7xm%2BABSc5FGl1EGyAAAAAElFTkSuQmCC%22%3E%3C%2Fimage%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FSpinner%22%20fill%3D%22url%28%23pattern-1%29%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3.86827202%2C3.86827202%20C4.25879631%2C3.47774772%204.89196129%2C3.47774772%205.28248558%2C3.86827202%20L9.17157288%2C7.75735931%20C9.56209717%2C8.1478836%209.56209717%2C8.78104858%209.17157288%2C9.17157288%20C8.78104858%2C9.56209717%208.1478836%2C9.56209717%207.75735931%2C9.17157288%20L3.86827202%2C5.28248558%20C3.47774772%2C4.89196129%203.47774772%2C4.25879631%203.86827202%2C3.86827202%20Z%20M12%2C0.5%20C12.5522847%2C0.5%2013%2C0.94771525%2013%2C1.5%20L13%2C7%20C13%2C7.55228475%2012.5522847%2C8%2012%2C8%20C11.4477153%2C8%2011%2C7.55228475%2011%2C7%20L11%2C1.5%20C11%2C0.94771525%2011.4477153%2C0.5%2012%2C0.5%20Z%20M20.131728%2C3.86827202%20C20.5222523%2C4.25879631%2020.5222523%2C4.89196129%2020.131728%2C5.28248558%20L16.2426407%2C9.17157288%20C15.8521164%2C9.56209717%2015.2189514%2C9.56209717%2014.8284271%2C9.17157288%20C14.4379028%2C8.78104858%2014.4379028%2C8.1478836%2014.8284271%2C7.75735931%20L18.7175144%2C3.86827202%20C19.1080387%2C3.47774772%2019.7412037%2C3.47774772%2020.131728%2C3.86827202%20Z%20M23.5%2C12%20C23.5%2C12.5522847%2023.0522847%2C13%2022.5%2C13%20L17%2C13%20C16.4477153%2C13%2016%2C12.5522847%2016%2C12%20C16%2C11.4477153%2016.4477153%2C11%2017%2C11%20L22.5%2C11%20C23.0522847%2C11%2023.5%2C11.4477153%2023.5%2C12%20Z%20M20.131728%2C20.131728%20C19.7412037%2C20.5222523%2019.1080387%2C20.5222523%2018.7175144%2C20.131728%20L14.8284271%2C16.2426407%20C14.4379028%2C15.8521164%2014.4379028%2C15.2189514%2014.8284271%2C14.8284271%20C15.2189514%2C14.4379028%2015.8521164%2C14.4379028%2016.2426407%2C14.8284271%20L20.131728%2C18.7175144%20C20.5222523%2C19.1080387%2020.5222523%2C19.7412037%2020.131728%2C20.131728%20Z%20M12%2C23.5%20C11.4477153%2C23.5%2011%2C23.0522847%2011%2C22.5%20L11%2C17%20C11%2C16.4477153%2011.4477153%2C16%2012%2C16%20C12.5522847%2C16%2013%2C16.4477153%2013%2C17%20L13%2C22.5%20C13%2C23.0522847%2012.5522847%2C23.5%2012%2C23.5%20Z%20M3.86827202%2C20.131728%20C3.47774772%2C19.7412037%203.47774772%2C19.1080387%203.86827202%2C18.7175144%20L7.75735931%2C14.8284271%20C8.1478836%2C14.4379028%208.78104858%2C14.4379028%209.17157288%2C14.8284271%20C9.56209717%2C15.2189514%209.56209717%2C15.8521164%209.17157288%2C16.2426407%20L5.28248558%2C20.131728%20C4.89196129%2C20.5222523%204.25879631%2C20.5222523%203.86827202%2C20.131728%20Z%20M0.5%2C12%20C0.5%2C11.4477153%200.94771525%2C11%201.5%2C11%20L7%2C11%20C7.55228475%2C11%208%2C11.4477153%208%2C12%20C8%2C12.5522847%207.55228475%2C13%207%2C13%20L1.5%2C13%20C0.94771525%2C13%200.5%2C12.5522847%200.5%2C12%20Z%22%20id%3D%22Rectangle-2%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var closeIcon$1 = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FClose%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FClose%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%285.000000%2C%205.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%2214%22%20y2%3D%2214%22%20id%3D%22Path-9%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%2214%22%20y2%3D%2214%22%20id%3D%22Path-9%22%20transform%3D%22translate%287.000000%2C%207.000000%29%20scale%28-1%2C%201%29%20translate%28-7.000000%2C%20-7.000000%29%20%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var readicon = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cline%20y1%3D%22-0.75%22%20x2%3D%2212.5391%22%20y2%3D%22-0.75%22%20transform%3D%22matrix%28-0.641971%200.766729%20-0.836709%20-0.547648%2019%207.38586%29%22%20stroke%3D%22%2339f%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M16.6377%207L8.87922%2016.3095L5%2013.3697%22%20stroke%3D%22%2339f%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var deliveredicon = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cline%20y1%3D%22-0.75%22%20x2%3D%2212.5391%22%20y2%3D%22-0.75%22%20transform%3D%22matrix%28-0.641971%200.766729%20-0.836709%20-0.547648%2019%207.38586%29%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M16.6377%207L8.87922%2016.3095L5%2013.3697%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

/**
  * @property {any} subtitleView - The view for subtitle.
  * @property {any} listItemView - The view for list item.
  * @property {any} bubbleView - The menu.
  * @property {DatePatterns} receiptDatePattern - Enum for date pattern
  * @property {DatePatterns} readIcon - Read icon url
  * @property {DatePatterns} deliveredIcon - Delivered icon url
  * @property {DatePatterns} closeIconURL - Close icon url
  * @property {any} emptyStateView - The view for empty state.
  * @property {any} errorStateView - The view for error state.
  * @property {string} loadingIconURL - The URL for loading icon.
  * @property {any} loadingStateView - The view for loading state.
  * @property {UsersStyle} messageInformationStyle - The style for users.
  * @property {ListItemStyle} listItemStyle - The style for list item.
  * @property {(()=>void) | null} onClose - The style for list item.
  * @property {((error:CometChat.CometChatException)=>void) | null} onError - The style for list item.
  */
class MessageInformationConfiguration {
    constructor(props) {
        this.readIcon = readicon;
        this.deliveredIcon = deliveredicon;
        this.listItemStyle = {};
        this.loadingIconURL = LoadingIcon;
        this.closeIconURL = closeIcon$1;
        this.messageInformationStyle = {};
        Object.assign(this, props);
    }
}

var searchIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M4.9598%2011.531C5.47958%2012.7541%206.4639%2013.7205%207.69625%2014.2178C8.92859%2014.7151%2010.308%2014.7024%2011.531%2014.1826C12.754%2013.6629%2013.7205%2012.6785%2014.2178%2011.4462C14.715%2010.2139%2014.7024%208.83445%2014.1826%207.61142C13.6629%206.3884%2012.6785%205.42195%2011.4462%204.92467C10.2138%204.4274%208.83444%204.44004%207.61141%204.95981C6.38839%205.47959%205.42194%206.46391%204.92467%207.69626C4.42739%208.9286%204.44003%2010.308%204.9598%2011.531V11.531Z%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.114%2013.1139L17.0001%2017.0005%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

/**
  * @property {any} usersRequestBuilder - The request builder for users.
  * @property {any} searchRequestBuilder - The request builder for search.
  * @property {any} subtitleView - The view for subtitle.
  * @property {boolean} disableUsersPresence - Indicates whether to disable users presence or not.
  * @property {any} listItemView - The view for list item.
  * @property {any} menu - The menu.
  * @property {any} options - The options.
  * @property {boolean} hideSeparator - Indicates whether to hide separator or not.
  * @property {SelectionMode} selectionMode - The selection mode.
  * @property {boolean} hideError - Indicates whether to hide error or not.
  * @property {group:CometChat.User} onSelect - The callback on select.
  * @property {any} emptyStateView - The view for empty state.
  * @property {any} errorStateView - The view for error state.
  * @property {string} loadingIconURL - The URL for loading icon.
  * @property {any} loadingStateView - The view for loading state.
  * @property {TitleAlignment} titleAlignment - The alignment of title.
  * @property {BaseStyle} statusIndicatorStyle - The style for status indicator.
  * @property {AvatarStyle} avatarStyle - The style for avatar.
  * @property {UsersStyle} usersStyle - The style for users.
  * @property {ListItemStyle} listItemStyle - The style for list item.
  */
class UsersConfiguration {
    constructor(props) {
        this.disableUsersPresence = false;
        this.selectionMode = uikitResources.SelectionMode.none;
        this.hideError = false;
        this.showSectionHeader = true;
        this.loadingIconURL = LoadingIcon;
        this.searchIconURL = searchIcon;
        this.hideSearch = false;
        this.titleAlignment = uikitResources.TitleAlignment.left;
        this.statusIndicatorStyle = {
            height: "12px",
            width: "12px",
            borderRadius: "16px"
        };
        this.avatarStyle = {
            borderRadius: "16px",
            width: "28px",
            height: "28px",
            border: "1px solid rgb(238 238 238)",
        };
        this.usersStyle = {};
        this.listItemStyle = {};
        Object.assign(this, props);
    }
}

var privateIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2214px%22%20height%3D%2214px%22%20viewBox%3D%220%200%2014%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EPrivate%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Symbols-v2%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Private%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20fill%3D%22%2300C86F%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2214%22%20height%3D%2214%22%20rx%3D%227%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4%2C5%20C5.33333333%2C4.66666667%206.33333333%2C4%207%2C3%20C7.66666667%2C4%208.66666667%2C4.66666667%2010%2C5%20L10%2C6.14589803%20C10%2C8.20151331%208.83859819%2C10.0807009%207%2C11%20L7%2C11%20L7%2C11%20C5.16140181%2C10.0807009%204%2C8.20151331%204%2C6.14589803%20L4%2C5%20L4%2C5%20Z%22%20id%3D%22Rectangle%22%20fill%3D%22%23FFFFFF%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var lockedIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2214px%22%20height%3D%2214px%22%20viewBox%3D%220%200%2014%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3ELocked%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Symbols-v2%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Locked%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20fill%3D%22%23F7A500%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2214%22%20height%3D%2214%22%20rx%3D%227%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7%2C3%20C8.1045695%2C3%209%2C3.8954305%209%2C5%20L9.00079851%2C6.00841863%20C9.2437935%2C6.025429%209.36573413%2C6.06795171%209.48842285%2C6.13356635%20C9.65138581%2C6.2207199%209.7792801%2C6.34861419%209.86643365%2C6.51157715%20C9.95358719%2C6.67454011%2010%2C6.83618323%2010%2C7.2819426%20L10%2C9.7180574%20C10%2C10.1638168%209.95358719%2C10.3254599%209.86643365%2C10.4884229%20C9.7792801%2C10.6513858%209.65138581%2C10.7792801%209.48842285%2C10.8664336%20C9.32545989%2C10.9535872%209.16381677%2C11%208.7180574%2C11%20L5.2819426%2C11%20C4.83618323%2C11%204.67454011%2C10.9535872%204.51157715%2C10.8664336%20C4.34861419%2C10.7792801%204.2207199%2C10.6513858%204.13356635%2C10.4884229%20C4.04641281%2C10.3254599%204%2C10.1638168%204%2C9.7180574%20L4%2C7.2819426%20C4%2C6.83618323%204.04641281%2C6.67454011%204.13356635%2C6.51157715%20C4.2207199%2C6.34861419%204.34861419%2C6.2207199%204.51157715%2C6.13356635%20C4.63442137%2C6.06786855%204.7565156%2C6.02532125%205.00012601%2C6.00835408%20L5%2C5%20C5%2C3.8954305%205.8954305%2C3%207%2C3%20Z%20M7%2C4%20C6.48716416%2C4%206.06449284%2C4.38604019%206.00672773%2C4.88337887%20L6%2C5%20L6%2C6%20L8%2C6%20L8%2C5%20C8%2C4.44771525%207.55228475%2C4%207%2C4%20Z%22%20id%3D%22Rectangle-3%22%20fill%3D%22%23FFFFFF%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

/**
  * @property {any} groupsRequestBuilder - The request builder for groups.
  * @property {any} searchRequestBuilder - The request builder for search.
  * @property {any} subtitleView - The view for subtitle.
  * @property {any} listItemView - The view for list item.
  * @property {any} menu - The menu.
  * @property {any} options - The options.
  * @property {boolean} hideSeparator - Indicates whether to hide separator or not.
  * @property {SelectionMode} selectionMode - The selection mode.
  * @property {boolean} hideError - Indicates whether to hide error or not.
  * @property {group:CometChat.Group} onSelect - The callback on select.
  * @property {any} emptyStateView - The view for empty state.
  * @property {any} errorStateView - The view for error state.
  * @property {string} loadingIconURL - The URL for loading icon.
  * @property {any} loadingStateView - The view for loading state.
  * @property {TitleAlignment} titleAlignment - The alignment of title.
  * @property {BaseStyle} statusIndicatorStyle - The style for status indicator.
  * @property {AvatarStyle} avatarStyle - The style for avatar.
  * @property {GroupsStyle} groupsStyle - The style for groups.
  * @property {ListItemStyle} listItemStyle - The style for list item.
  */
class GroupsConfiguration {
    constructor(props) {
        this.privateGroupIcon = privateIcon;
        this.protectedGroupIcon = lockedIcon;
        this.selectionMode = uikitResources.SelectionMode.none;
        this.loadingIconURL = LoadingIcon;
        this.searchIconURL = searchIcon;
        this.hideSearch = false;
        this.titleAlignment = uikitResources.TitleAlignment.left;
        this.statusIndicatorStyle = {
            height: "12px",
            width: "12px",
            borderRadius: "16px"
        };
        this.avatarStyle = {};
        this.groupsStyle = {};
        this.listItemStyle = {};
        Object.assign(this, props);
    }
}

/**
 ContactsConfiguration class.
* @property {UsersConfiguration} usersConfiguration
* @property {GroupsConfiguration} groupsConfiguration
* @property {string} closeIconURL
* @property {ContactsStyle} contactsStyle
* @property {SelectionMode} selectionMode
* @property {:()=>void} onClose
* @property {TabsVisibility} tabVisibility
* @property {number} selectionLimit
* @property {CometChatTabItem} tabs
* @property {boolean} hideSubmitButton
*/
class ContactsConfiguration {
    constructor(props) {
        this.usersConfiguration = new UsersConfiguration({});
        this.groupsConfiguration = new GroupsConfiguration({});
        this.closeIconURL = closeIcon$1;
        this.contactsStyle = {};
        this.selectionMode = uikitResources.SelectionMode.multiple;
        this.tabVisibility = uikitResources.TabsVisibility.usersAndGroups;
        this.selectionLimit = 5;
        this.tabs = [];
        this.hideSubmitButton = true;
        Object.assign(this, props);
    }
}

var loadingIcon = "data:image/svg+xml,%3Csvg%20width%3D%2225%22%20height%3D%2224%22%20viewBox%3D%220%200%2025%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8.01057%208.04728C8.34753%209.99213%209.53177%2011.3242%2011.6239%2012C13.716%2011.3242%2014.9002%209.99213%2015.2372%208.04728C15.2572%207.91731%2015.2488%207.78455%2015.2125%207.65816C15.1762%207.53177%2015.1129%207.41476%2015.027%207.3152C14.9411%207.21564%2014.8346%207.1359%2014.7149%207.08149C14.5952%207.02707%2014.4651%206.99928%2014.3336%207.00001H8.9142C8.7827%206.99928%208.65261%207.02707%208.5329%207.08149C8.41319%207.1359%208.30671%207.21564%208.2208%207.3152C8.1349%207.41476%208.07161%207.53177%208.03532%207.65816C7.99902%207.78455%207.99058%207.91731%208.01057%208.04728Z%22%20fill%3D%22%23808080%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.91423%2017C8.78279%2017.0007%208.65276%2016.9729%208.5331%2016.9185C8.41343%2016.8642%208.30699%2016.7845%208.22109%2016.685C8.1352%2016.5855%208.0719%2016.4686%208.03556%2016.3423C7.99922%2016.2159%207.9907%2016.0832%208.01059%2015.9533C8.34756%2014.0085%209.5318%2012.6764%2011.6239%2012C13.716%2012.6764%2014.9003%2014.0085%2015.2372%2015.9533C15.2571%2016.0832%2015.2486%2016.2159%2015.2123%2016.3423C15.1759%2016.4686%2015.1126%2016.5855%2015.0267%2016.685C14.9408%2016.7845%2014.8344%2016.8642%2014.7147%2016.9185C14.5951%2016.9729%2014.465%2017.0007%2014.3336%2017H8.91423Z%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var senticon = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M17.6377%207L9.87922%2016.3095L6%2013.3697%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var errorIcon = "data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2217%22%20viewBox%3D%220%200%2018%2017%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M8.99992%2011C8.96695%2011%208.93473%2011.0098%208.90732%2011.0281C8.87992%2011.0464%208.85855%2011.0724%208.84594%2011.1029C8.83332%2011.1333%208.83002%2011.1669%208.83645%2011.1992C8.84289%2011.2315%208.85876%2011.2612%208.88207%2011.2845C8.90538%2011.3078%208.93507%2011.3237%208.9674%2011.3301C8.99973%2011.3366%209.03324%2011.3333%209.0637%2011.3206C9.09415%2011.308%209.12018%2011.2867%209.1385%2011.2593C9.15681%2011.2319%209.16659%2011.1996%209.16659%2011.1667C9.16659%2011.1225%209.14903%2011.0801%209.11777%2011.0488C9.08651%2011.0176%209.04412%2011%208.99992%2011Z%22%20stroke%3D%22%23ff3b30%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9%209.66667V6%22%20stroke%3D%22%23ff3b30%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4%209C4%2010.3261%204.52678%2011.5979%205.46447%2012.5355C6.40215%2013.4732%207.67392%2014%209%2014C10.3261%2014%2011.5979%2013.4732%2012.5355%2012.5355C13.4732%2011.5979%2014%2010.3261%2014%209C14%207.67392%2013.4732%206.40215%2012.5355%205.46447C11.5979%204.52678%2010.3261%204%209%204C7.67392%204%206.40215%204.52678%205.46447%205.46447C4.52678%206.40215%204%207.67392%204%209V9Z%22%20stroke%3D%22%23ff3b30%22%20stroke-width%3D%221.2%22%2F%3E%3C%2Fsvg%3E";

/**
  * @property {any} subtitleView - Property for subtitle view.
  * @property {any} options - Property for options.
  * @property {boolean} disableUsersPresence - Property to disable user's presence. Default is false.
  * @property {boolean} disableReadReceipt - Property to disable read receipt. Default is false.
  * @property {boolean} disableTyping - Property to disable typing. Default is false.
  * @property {string} deliveredIcon - Property for delivered icon. Default is "assets/message-delivered.svg".
  * @property {string} readIcon - Property for read icon. Default is "assets/message-read.svg".
  * @property {string} waitIcon - Property for wait icon. Default is "assets/wait.svg".
  * @property {string} errorIcon - Property for error icon. Default is "assets/warning-small.svg".
  * @property {DatePatterns} datePattern - Property for date pattern. Default is "DatePatterns.time".
  * @property {ReceiptStyle} receiptStyle - Property for receipt style.
  * @property {string} sentIcon - Property for sent icon. Default is "assets/message-sent.svg".
  * @property {string} privateGroupIcon - Property for private group icon. Default is "assets/Private.svg".
  * @property {string} protectedGroupIcon - Property for protected group icon. Default is "assets/Locked.svg".
  * @property {string} customSoundForMessages - Property for custom sound for messages.
  * @property {CometChat.Conversation} activeConversation - Property for selected conversation. Default is null.
  * @property {string} searchIconURL - Property for search icon URL. Default is "assets/search.svg".
  * @property {boolean} hideSearch - Property to hide search. Default is true.
  * @property {CometChat.ConversationsRequestBuilder} conversationsRequestBuilder - Property for conversation request builder. Default is "new CometChat.ConversationsRequestBuilder().setLimit(30)".
  * @property {any} emptyStateView - Property for empty state view.
  * @property {member:CometChat.Conversation} onSelect - Property for on select.
  * @property {string} loadingIconURL - Property for loading icon URL. Default is "assets/Spinner.svg".
  * @property {any} errorStateView - Property for error state view.
  * @property {any} loadingStateView - Property for loading state view.
  * @property {TitleAlignment} titleAlignment - Property for title alignment. Default is "TitleAlignment.left".
  * @property {any} listItemView - Property for list item view.
  * @property {any} menu - Property for menu.
  * @property {boolean} hideSeparator - Property to hide separator. Default is false.
  * @property {boolean} hideError - Property to hide error. Default is false.
  * @property {SelectionMode} selectionMode - Property for selection mode. Default is "SelectionMode.none".
  * @property {boolean} disableSoundForMessages - Property to disable sound
  * @property {ConfirmDialogStyle} deleteConversationDialogStyle - The style of the dialog that appears when user tries to delete a conversation.
  * @property {BadgeStyle} badgeStyle - The style of the badge that appears on the conversation list items.
  * @property {DateStyle} dateStyle - The style of the date that appears in the conversation list items.
  * @property {ConversationsStyle} conversationsStyle - The style of the conversation list.
  * @property {ListItemStyle} listItemStyle - The style of the conversation list item.
  * @property {BaseStyle} statusIndicatorStyle - The style of the status indicator that appears in the conversation list items.
  * @property {AvatarStyle} avatarStyle - The style of the avatar that appears in the conversation list items.
  */
class ConversationsConfiguration {
    constructor(props) {
        this.disableUsersPresence = false;
        this.disableReceipt = false;
        this.disableTyping = false;
        this.deliveredIcon = deliveredicon;
        this.readIcon = readicon;
        this.waitIcon = loadingIcon;
        this.errorIcon = errorIcon;
        this.datePattern = uikitResources.DatePatterns.time;
        this.receiptStyle = {};
        this.sentIcon = senticon;
        this.privateGroupIcon = privateIcon;
        this.protectedGroupIcon = lockedIcon;
        this.customSoundForMessages = "";
        this.loadingIconURL = LoadingIcon;
        this.titleAlignment = uikitResources.TitleAlignment.left;
        this.hideSeparator = false;
        this.hideError = false;
        this.selectionMode = uikitResources.SelectionMode.none;
        this.disableSoundForMessages = false;
        this.deleteConversationDialogStyle = {};
        this.badgeStyle = {};
        this.dateStyle = {};
        this.conversationsStyle = {};
        this.listItemStyle = {};
        this.statusIndicatorStyle = {};
        this.avatarStyle = {};
        this.backdropStyle = {};
        Object.assign(this, props);
    }
}

/**

CreateGroupConfiguration class represents the configuration options for creating a new group.
@property {closeButtonIconURL} - A string representing the URL of the icon to be used for the close button. Default value is 'closeIcon'.
@property {hideCloseButton} - A boolean indicating whether or not to hide the close button. Default value is false.
@property {createGroupStyle} - An object representing the style options for the create group form. Default value is an empty object.
@property {onError} - A function to be called when an error occurs during group creation. Can be null.
@property {onClose} - A function to be called when the create group form is closed. Can be null.
*/
class CreateGroupConfiguration {
    constructor(props) {
        this.closeButtonIconURL = closeIcon$1;
        this.hideCloseButton = false;
        this.createGroupStyle = {};
        this.createClick = null;
        Object.assign(this, props);
    }
}

var backIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2Fbackbutton%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FBack%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%283.000000%2C%203.250000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2218.75%22%20y1%3D%228.75%22%20x2%3D%220%22%20y2%3D%228.75%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolyline%20id%3D%22Path%22%20points%3D%228.75%200%200%208.75%208.75%2017.5%22%3E%3C%2Fpolyline%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

/**
 AddMembersConfiguration class.
* @property {any} subtitleView
* @property {any} listItemView
* @property {boolean} disableUsersPresence
* @property {any} menu
* @property {CometChatOption[]} options
* @property {string} backButtonIconURL
* @property {string} closeButtonIconURL
* @property {boolean} showBackButton
* @property {boolean} hideSeparator
* @property {SelectionMode} selectionMode
* @property {boolean} hideError
* @property {string} searchIconURL
* @property {boolean} hideSearch
* @property {((error:CometChat.CometChatException)=>void) | null} onError
* @property {(()=>void) | null} onBack
* @property {(()=>void) | null} onClose
* @property {(user:CometChat.User)=>void} onSelect
* @property {any} emptyStateView
* @property {any} errorStateView
* @property {string} loadingIconURL
* @property {boolean} showSectionHeader
* @property {string} sectionHeaderField
* @property {any} loadingStateView
* @property {((guid:string, members:CometChat.User[])=>void) | null} onAddMembersButtonClick
* @property {TitleAlignment} titleAlignment
* @property {any} statusIndicatorStyle
* @property {AvatarStyle} avatarStyle
* @property {AddMembersStyle} addMembersStyle
* @property {ListItemStyle} listItemStyle
*/
class AddMembersConfiguration {
    constructor(props) {
        this.disableUsersPresence = false;
        this.backButtonIconURL = backIcon;
        this.closeButtonIconURL = closeIcon$1;
        this.showBackButton = true;
        this.hideSeparator = false;
        this.selectionMode = uikitResources.SelectionMode.multiple;
        this.hideError = false;
        this.searchIconURL = searchIcon;
        this.hideSearch = false;
        this.onError = (error) => {
            console.log(error);
        };
        this.loadingIconURL = LoadingIcon;
        this.showSectionHeader = false;
        this.sectionHeaderField = "";
        this.titleAlignment = uikitResources.TitleAlignment.center;
        this.usersConfiguration = new UsersConfiguration({});
        this.statusIndicatorStyle = {
            height: "10px",
            width: "10px",
            borderRadius: "16px"
        };
        this.avatarStyle = {};
        this.listItemStyle = {};
        this.addMembersStyle = {};
        Object.assign(this, props);
    }
}

var downarrowIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20%3F%3E%3C!DOCTYPE%20svg%20%20PUBLIC%20%5Ci-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%5Ci%20%20%5Cihttp%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%5Ci%3E%3Csvg%20enable-background%3D%22new%200%200%2032%2032%22%20%20id%3D%22%D0%A1%D0%BB%D0%BE%D0%B9_1%22%20version%3D%221.1%22%20viewBox%3D%220%200%2032%2032%22%20%20xml%3Aspace%3D%22preserve%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Cpath%20d%3D%22M24.285%2C11.284L16%2C19.571l-8.285-8.288c-0.395-0.395-1.034-0.395-1.429%2C0%20%20c-0.394%2C0.395-0.394%2C1.035%2C0%2C1.43l8.999%2C9.002l0%2C0l0%2C0c0.394%2C0.395%2C1.034%2C0.395%2C1.428%2C0l8.999-9.002%20%20c0.394-0.395%2C0.394-1.036%2C0-1.431C25.319%2C10.889%2C24.679%2C10.889%2C24.285%2C11.284z%22%20fill%3D%22%23121313%22%20id%3D%22Expand_More%22%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3Cg%2F%3E%3C%2Fsvg%3E";

/**
 BannedMembersConfiguration class.
* @property {any} subtitleView
* @property {any} listItemView
* @property {boolean} disableUsersPresence
* @property {any} menu
* @property {CometChatOption[]} options
* @property {string} backButtonIconURL
* @property {string} closeButtonIconURL
* @property {boolean} showBackButton
* @property {boolean} hideSeparator
* @property {SelectionMode} selectionMode
* @property {boolean} hideError
* @property {string} searchIconURL
* @property {boolean} hideSearch
* @property {((error:CometChat.CometChatException)=>void) | null} onError
* @property {(()=>void) | null} onBack
* @property {(()=>void) | null} onClose
* @property {(member:CometChat.GroupMember)=>void} onSelect
* @property {any} emptyStateView
* @property {any} errorStateView
* @property {string} loadingIconURL
* @property {any} loadingStateView
* @property {((guid:string, members:CometChat.User[])=>void) | null} onAddMembersButtonClick
* @property {TitleAlignment} titleAlignment
* @property {any} statusIndicatorStyle
* @property {AvatarStyle} avatarStyle
* @property {GroupMemberStyle} groupMemberStyle
* @property {ChangeScopeStyle} groupScopeStyle
* @property {string} dropdownIconURL
* @property {ListItemStyle} listItemStyle
*/
class GroupMembersConfiguration {
    constructor(props) {
        this.disableUsersPresence = false;
        this.backButtonIconURL = backIcon;
        this.closeButtonIconURL = closeIcon$1;
        this.showBackButton = true;
        this.hideSeparator = false;
        this.selectionMode = uikitResources.SelectionMode.none;
        this.hideError = false;
        this.searchIconURL = searchIcon;
        this.dropdownIconURL = downarrowIcon;
        this.hideSearch = false;
        this.onError = (error) => {
            console.log(error);
        };
        this.loadingIconURL = LoadingIcon;
        this.titleAlignment = uikitResources.TitleAlignment.center;
        this.statusIndicatorStyle = {
            height: "10px",
            width: "10px",
            borderRadius: "16px"
        };
        this.avatarStyle = {};
        this.groupMembersStyle = {};
        this.groupScopeStyle = {};
        this.listItemStyle = {};
        this.backdropStyle = {};
        Object.assign(this, props);
    }
}

/**
 BannedMembersConfiguration class.
* @property {any} subtitleView
* @property {any} listItemView
* @property {boolean} disableUsersPresence
* @property {any} menu
* @property {CometChatOption[]} options
* @property {string} backButtonIconURL
* @property {string} closeButtonIconURL
* @property {boolean} showBackButton
* @property {boolean} hideSeparator
* @property {SelectionMode} selectionMode
* @property {boolean} hideError
* @property {string} searchIconURL
* @property {boolean} hideSearch
* @property {((error:CometChat.CometChatException)=>void) | null} onError
* @property {(()=>void) | null} onBack
* @property {(()=>void) | null} onClose
* @property {(member:CometChat.GroupMember)=>void} onSelect
* @property {any} emptyStateView
* @property {any} errorStateView
* @property {string} loadingIconURL
* @property {any} loadingStateView
* @property {((guid:string, members:CometChat.User[])=>void) | null} onAddMembersButtonClick
* @property {TitleAlignment} titleAlignment
* @property {any} statusIndicatorStyle
* @property {AvatarStyle} avatarStyle
* @property {BannedMembersStyle} bannedMembersStyle
* @property {ListItemStyle} listItemStyle
*/
class BannedMembersConfiguration {
    constructor(props) {
        this.disableUsersPresence = false;
        this.backButtonIconURL = backIcon;
        this.closeButtonIconURL = closeIcon$1;
        this.showBackButton = true;
        this.hideSeparator = false;
        this.selectionMode = uikitResources.SelectionMode.none;
        this.hideError = false;
        this.searchIconURL = searchIcon;
        this.hideSearch = false;
        this.onError = (error) => {
            console.log(error);
        };
        this.loadingIconURL = LoadingIcon;
        this.titleAlignment = uikitResources.TitleAlignment.center;
        this.statusIndicatorStyle = {
            height: "10px",
            width: "10px",
            borderRadius: "16px"
        };
        this.avatarStyle = {};
        this.listItemStyle = {};
        this.bannedMembersStyle = {};
        Object.assign(this, props);
    }
}

/**

TransferOwnershipConfiguration class represents the configuration options for transferring ownership of a group.
@property {groupMemberRequestBuilder} - An instance of CometChat.GroupMembersRequestBuilder to fetch group members. Required.
@property {searchRequestBuilder} - An instance of CometChat.GroupMembersRequestBuilder to search for group members. Required.
@property {subtitleView} - The view to be displayed as subtitle for the transfer ownership screen. Can be any.
@property {listItemView} - The view to be used to render individual list items. Can be any.
@property {disableUsersPresence} - A boolean indicating whether or not to disable presence of group members. Default value is false.
@property {options} - An array of CometChatOption objects to be displayed on the transfer ownership screen. Required.
@property {closeButtonIconURL} - A string representing the URL of the icon to be used for the close button. '.
@property {hideSeparator} - A boolean indicating whether or not to hide the separator between the header and body. Default value is false.
@property {searchIconURL} - A string representing the URL of the icon to be used for the search button.
@property {hideSearch} - A boolean indicating whether or not to hide the search bar. Default value is true.
@property {onError} - A function to be called when an error occurs during the transfer ownership process. Default value logs the error to console.
@property {onClose} - A function to be called when the transfer ownership screen is closed. Required.
@property {onTransferOwnership} - A function to be called when the ownership of the group is transferred. Required.
@property {emptyStateView} - The view to be displayed when there are no group members to transfer ownership to. Can be any.
@property {errorStateView} - The view to be displayed when there is an error while fetching group members. Can be any.
@property {loadingIconURL} - A string representing the URL of the icon to be used for the loading indicator. Default value is 'assets/Spinner.svg'.
@property {loadingStateView} - The view to be displayed while fetching group members. Can be any.
@property {statusIndicatorStyle} - An object representing the style options for the status indicator. .
@property {transferOwnershipStyle} - An object representing the style options for the transfer ownership screen. .
@property {avatarStyle} - An object representing the style options for the avatar image. .
@property {groupMemberStyle} - An object representing the style options for the group members list. .
@property {listItemStyle} - An object representing the style options for the individual list items. .
@property {titleAlignment} - an enum which represents the allignment of the title
**/
class TransferOwnershipConfiguration {
    constructor(props) {
        this.disableUsersPresence = false;
        this.closeButtonIconURL = closeIcon$1;
        this.hideSeparator = false;
        this.searchIconURL = searchIcon;
        this.hideSearch = true;
        this.onError = (error) => {
            console.log(error);
        };
        this.loadingIconURL = LoadingIcon;
        this.statusIndicatorStyle = {};
        this.transferOwnershipStyle = {};
        this.avatarStyle = {};
        this.groupMemberStyle = {};
        this.listItemStyle = {};
        this.titleAlignment = uikitResources.TitleAlignment.center;
        Object.assign(this, props);
    }
}

/**

* DetailsConfiguration class represents the configuration options for the details view.
* @property  {closeButtonIconURL} - string: The URL of the icon used for the close button.
* @property {hideProfile} - boolean: If true, the profile of the user/group will be hidden.
* @property {subtitleView} - any: The subtitle view to be displayed in the details view.
* @property {customProfileView} - any: The custom profile view to be displayed in the details view.
* @property {data} - CometChatDetailsTemplate[]: The array of CometChatDetailsTemplate objects to be displayed in the details view.
* @property {disableUsersPresence} - boolean: If true, the presence of users will be disabled in the details view.
* @property {privateGroupIcon} - string: The URL of the icon used for the private group.
* @property {protectedGroupIcon} - string: The URL of the icon used for the protected group.
* @property {onError} - (error: any) => void: The callback function that will be called when an error occurs.
* @property {onClose} - () => void: The callback function that will be called when the details view is closed.
* @property {leaveDialogStyle} - ConfirmDialogStyle: The style configuration options for the leave dialog.
* @property {statusIndicatorStyle} - any: The style configuration options for the status indicator.
* @property {avatarStyle} - AvatarStyle: The style configuration options for the avatar.
* @property {detailsStyle} - DetailsStyle: The style configuration options for the details view.
* @property {listItemStyle} - ListItemStyle: The style configuration options for the list items in the details view.
*/
class DetailsConfiguration {
    constructor(props) {
        this.closeButtonIconURL = closeIcon$1;
        this.hideProfile = false;
        this.data = [];
        this.disableUsersPresence = false;
        this.privateGroupIcon = privateIcon;
        this.protectedGroupIcon = lockedIcon;
        this.addMembersConfiguration = new AddMembersConfiguration({});
        this.groupMembersConfiguration = new GroupMembersConfiguration({});
        this.bannedMembersConfiguration = new BannedMembersConfiguration({});
        this.transferOwnershipConfiguration = new TransferOwnershipConfiguration({});
        this.backdropStyle = {};
        this.onError = (error) => {
            console.log(error);
        };
        this.leaveDialogStyle = {};
        this.statusIndicatorStyle = {
            height: "10px",
            width: "10px",
            borderRadius: "16px",
            border: "",
        };
        this.detailsStyle = {};
        this.avatarStyle = {};
        this.listItemStyle = {};
        Object.assign(this, props);
    }
}

/**
* @class MessageHeaderConfiguration
* @property {any} subtitleView - The view that displays the message header subtitle.
* @property {boolean} disableUsersPresence - Whether the user presence should be disabled or not.
* @property {string} protectedGroupIcon - The URL for the protected group icon.
* @property {string} privateGroupIcon - The URL for the private group icon.
* @property {any} menu - The menu associated with the message header.
* @property {AvatarStyle} avatarStyle - The style for the message header avatar.
* @property {BaseStyle} statusIndicatorStyle - The style for the status indicator in the message header.
* @property {MessageHeaderStyle} messageHeaderStyle - The style for the message header.
* @property {ListItemStyle} listItemStyle - The style for the list item in the message header.
* @property {string} backButtonIconURL - The URL for the back button icon.
* @property {boolean} hideBackIcon - Whether the back icon should be hidden or not.
* @property {any} listItemView - The view for the list item.
* @property {any} onError - The callback function that is triggered in case of an error.
* @property {any} onBack - The callback function that is triggered when the back button is clicked.
*/
class MessageHeaderConfiguration {
    constructor(props) {
        this.subtitleView = null;
        this.disableUsersPresence = false;
        this.protectedGroupIcon = lockedIcon;
        this.privateGroupIcon = privateIcon;
        this.avatarStyle = {};
        this.statusIndicatorStyle = {};
        this.messageHeaderStyle = {};
        this.listItemStyle = {};
        this.backButtonIconURL = backIcon;
        this.hideBackButton = true;
        Object.assign(this, props);
    }
}

/**

JoinGroupConfiguration class represents the configuration options for joining a  group.
@property {joinGroupStyle} - An object representing the style options for the join group form. Default value is an empty object.
@property {onError} - A function to be called when an error occurs during group creation. Can be null.
@property {onClose} - A function to be called when the create group form is closed. Can be null.
*/
class JoinGroupConfiguration {
    constructor(props) {
        this.joinGroupStyle = {};
        this.joinClick = null;
        this.messageHeaderConfiguration = new MessageHeaderConfiguration({});
        Object.assign(this, props);
    }
}

var AIIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%3F%3E%3Csvg%20version%3D%221.0%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100.000000pt%22%20height%3D%22100.000000pt%22%20viewBox%3D%220%200%20100.000000%20100.000000%22%20preserveAspectRatio%3D%22xMidYMid%20meet%22%3E%20%20%3Cg%20transform%3D%22translate%280.000000%2C100.000000%29%20scale%280.100000%2C-0.100000%29%22%20fill%3D%22%23000000%22%20stroke%3D%22none%22%3E%20%20%20%20%3Cpath%20d%3D%22M727%20854%20c-4%20-4%20-7%20-15%20-7%20-24%200%20-21%20-28%20-47%20-55%20-52%20-14%20-2%20-20%20-11%20-20%20-28%200%20-17%206%20-26%2020%20-28%2028%20-6%2053%20-30%2057%20-56%202%20-15%2010%20-21%2028%20-21%2018%200%2026%206%2028%2021%204%2026%2029%2050%2057%2056%2029%205%2028%2052%20-1%2056%20-26%204%20-51%2029%20-56%2057%20-3%2020%20-37%2032%20-51%2019z%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M350%20761%20c-5%20-11%20-10%20-32%20-10%20-48%20-1%20-74%20-86%20-160%20-178%20-178%20-50%20-10%20-57%20-14%20-57%20-36%200%20-20%206%20-25%2042%20-31%20117%20-20%20170%20-76%20198%20-211%2012%20-58%2065%20-38%2065%2025%200%2084%2088%20168%20193%20186%2036%206%2042%2011%2042%2031%200%2022%20-7%2026%20-56%2036%20-91%2018%20-162%2084%20-175%20165%20-12%2076%20-41%20104%20-64%2061z%20m80%20-212%20c14%20-14%2033%20-30%2043%20-35%2015%20-9%2010%20-17%20-40%20-69%20l-58%20-60%20-57%2059%20c-57%2059%20-57%2060%20-35%2075%2030%2020%2087%2082%2088%2095%200%206%208%200%2017%20-14%209%20-14%2028%20-37%2042%20-51z%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M727%20354%20c-4%20-4%20-7%20-15%20-7%20-24%200%20-21%20-28%20-47%20-55%20-52%20-14%20-2%20-20%20-11%20-20%20-28%200%20-17%206%20-26%2020%20-28%2028%20-6%2053%20-30%2057%20-56%204%20-30%2052%20-30%2056%200%204%2026%2029%2050%2057%2056%2029%205%2028%2052%20-1%2056%20-26%204%20-51%2029%20-56%2057%20-3%2020%20-37%2032%20-51%2019z%22%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var SmileysIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%20Extensions%2FStipop%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24-Extensions%2FStipop%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12.5%2C1%20C18.2989899%2C1%2023%2C5.70101013%2023%2C11.5%20C23%2C17.2039245%2018.451858%2C21.8455734%2012.7842951%2C21.9962258%20L12.5%2C22%20L6%2C23%20L6.47908443%2C20.1033393%20C3.77065445%2C18.2043706%202%2C15.0589646%202%2C11.5%20C2%2C5.70101013%206.70101013%2C1%2012.5%2C1%20Z%20M12.5%2C2.5%20C7.52943725%2C2.5%203.5%2C6.52943725%203.5%2C11.5%20C3.5%2C14.3705191%204.85206397%2C17.0112175%207.09635804%2C18.6980916%20L7.34021132%2C18.8751453%20L8.11298335%2C19.416961%20L7.817%2C21.202%20L12.3852902%2C20.5%20L12.5%2C20.5%20C17.4705627%2C20.5%2021.5%2C16.4705627%2021.5%2C11.5%20C21.5%2C6.52943725%2017.4705627%2C2.5%2012.5%2C2.5%20Z%20M13.5%2C12.3%20C13.1666667%2C13.9666667%2012.3333333%2C14.8%2011%2C14.8%20C9.66666667%2C14.8%208.83333333%2C13.9666667%208.5%2C12.3%20L13.5%2C12.3%20Z%20M15.0030662%2C6.67300699%20C15.1656001%2C6.92305919%2015.1180007%2C7.24908483%2014.9043132%2C7.44344192%20L14.826993%2C7.50306617%20L13.632%2C8.279%20L14.8086975%2C8.98550424%20C15.0644308%2C9.13894425%2015.1646368%2C9.45281874%2015.0578342%2C9.72120324%20L15.0144958%2C9.80869745%20C14.8610557%2C10.0644308%2014.5471813%2C10.1646368%2014.2787968%2C10.0578342%20L14.1913025%2C10.0144958%20L12.1913025%2C8.81449576%20C11.8402552%2C8.60386734%2011.8048611%2C8.12100565%2012.0939654%2C7.85785853%20L12.173007%2C7.79693383%20L14.173007%2C6.49693383%20C14.4508428%2C6.31634058%2014.8224729%2C6.39517122%2015.0030662%2C6.67300699%20Z%20M8.1%2C6.7%20C8.92842712%2C6.7%209.6%2C7.37157288%209.6%2C8.2%20C9.6%2C9.02842712%208.92842712%2C9.7%208.1%2C9.7%20C7.27157288%2C9.7%206.6%2C9.02842712%206.6%2C8.2%20C6.6%2C7.37157288%207.27157288%2C6.7%208.1%2C6.7%20Z%22%20id%3D%22Oval%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var heartIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAFAAAAAAnxZisAAACpElEQVQ4Ea1VzUsVURQ/5868UrEg/AMy0NTMRQRBJfIQszKxgh5ByzbVIooiiDbZBwUtXAWJtGgRJW0MQsxnxfhRIbgpsqcQtajoA8uITGfu3Hs6Z+zJU3pq+n4wc+fee87vd+bcM2cQ5mB0Z+0WMuERQNiNgO+UgtYAgs7K7uffM01fVlevyc9391iAo5bsOkT1gPdvlvd4Q5l2mJ68bahdG2rTwvMmB9HV1gKP0WWA3oSWzlc86rsj9qm6mkOuwgsKsMQSgeErxpEYS5oQOpSLp0u7vA9iGwmkdsWLlaGuPKXKJw3TyU4GYizEYG+OFglXAt7gOWomzoRY5TsO+Na+8pEaqpJ97/FeIuFUjX++X+C4jb+ZPBsUi3C0Wvb5OSaRZ0MBi0xY01GxvfYApuprtjkE/ZZAZXeZpkrnczF2Ek9oaKtCi2c4ogXJRUKIFyJP2zmolHLUSZeAGjWXQq4RcpHwMTVxIeCwVEuuIWfGSPGIl/9OcqohnA7QVWUCeMg1PyJ1nCsIl7ZmVIcqqSo97xen6aK8UC4SleZB5VwS7ijs8p7e9sDQLflIlos8R4FPdLs9Gb8rXJEAq5K7YurEpLHeckTEd8rYp77G483QHNXmTOJLuwZ/ukof9I0dWIqI+PjWDFqHEps870c6EzMCslCSfPYVQtzvG9MpDos5E7GZJrc9gfX3buju/5Qml3GWgCyUed7YtwmdYJHrLqqom8r6vyDfT0whsG3bqrzV+6oeD36ZazdvkCN1NYe5nq8xSRHndpYvd14Igca5dZxdn+xtm7WZMZlXQOxe18c3ukQtLLJDc0cUSPsOiJ6AMqfKugdeRItZbgsKiN/Q5s2xwqLCYw7hOWl3/FO5oj+OtVYODwdZeJe2LD+mVDxe/D/efwCuAQs2cnkFkQAAAABJRU5ErkJggg==";

var micIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FMic%402x%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FMic%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%284%2C%201%29%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%228%22%20y1%3D%2218.3333333%22%20x2%3D%228%22%20y2%3D%2222%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%223.5%22%20y%3D%220%22%20width%3D%229%22%20height%3D%2214.9111111%22%20rx%3D%223.91111111%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C8.8%20L0%2C11%20C0%2C15.0500882%203.35786438%2C18.3333333%207.5%2C18.3333333%20L8.5%2C18.3333333%20C12.6421356%2C18.3333333%2016%2C15.0500882%2016%2C11%20L16%2C8.8%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var PlusIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FPlus%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FPlus%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%282.000000%2C%202.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2210%22%20y1%3D%226%22%20x2%3D%2210%22%20y2%3D%2214%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%226%22%20y1%3D%2210%22%20x2%3D%2214%22%20y2%3D%2210%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C10%20C0%2C15.5228475%204.4771525%2C20%2010%2C20%20C15.5228475%2C20%2020%2C15.5228475%2020%2C10%20C20%2C4.4771525%2015.5228475%2C0%2010%2C0%20C4.4771525%2C0%200%2C4.4771525%200%2C10%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var sendIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FSend%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FSend%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%283.000000%2C%203.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0.158865921%2C1.85985859%20C-0.108182698%2C1.38202197%20-0.0332622567%2C0.786017075%200.343741637%2C0.389140701%20C0.72074553%2C-0.00773567366%201.31211969%2C-0.113146836%201.80303259%2C0.129025252%20L17.6480326%2C8.17819192%20C17.857662%2C8.28481329%2017.9896898%2C8.50008892%2017.9896898%2C8.73527525%20C17.9896898%2C8.97046158%2017.857662%2C9.18573721%2017.6480326%2C9.29235859%20L1.80303259%2C17.3523586%20C1.31211969%2C17.5945307%200.72074553%2C17.4891195%200.343741637%2C17.0922431%20C-0.0332622567%2C16.6953668%20-0.108182698%2C16.0993619%200.158865921%2C15.6215253%20L4.37386592%2C8.73485859%20L0.158865921%2C1.85985859%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2217.9896993%22%20y1%3D%228.73485859%22%20x2%3D%224.36969925%22%20y2%3D%228.73485859%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var stopIcon = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2220px%22%20height%3D%2220px%22%3E%3Cpath%20d%3D%22M%2012%202%20C%206.477%202%202%206.477%202%2012%20C%202%2017.523%206.477%2022%2012%2022%20C%2017.523%2022%2022%2017.523%2022%2012%20C%2022%206.477%2017.523%202%2012%202%20z%20M%2012%204%20C%2016.411%204%2020%207.589%2020%2012%20C%2020%2016.411%2016.411%2020%2012%2020%20C%207.589%2020%204%2016.411%204%2012%20C%204%207.589%207.589%204%2012%204%20z%20M%208%208%20L%208%2016%20L%2016%2016%20L%2016%208%20L%208%208%20z%22%2F%3E%3C%2Fsvg%3E";

/**
 * Class representing the configuration options for the message composer.
 *
 * @property {string} text - The initial text for the message composer. Default is an empty string.
 * @property {any} headerView - The view for the header of the message composer.
 * @property {any} onTextChange - The callback function for when the text in the message composer changes.
 * @property {string} attachmentIconURL - The URL of the attachment icon. Default is "assets/Plus.svg".
 * @property {CometChatMessageComposerAction[]} attachmentOptions - The attachment options for the message composer.
 * @property {any} secondaryButtonView - The view for the secondary button of the message composer.
 * @property {any} auxilaryButtonView - The view for the auxiliary button of the message composer.
 * @property {AuxiliaryButtonAlignment} auxiliaryButtonsAlignment - The alignment of the auxiliary buttons. Default is AuxiliaryButtonAlignment.right.
 * @property {any} sendButtonView - The view for the send button of the message composer.
 * @property {boolean} hideLiveReaction - Flag to hide live reaction. Default is false.
 * @property {string} LiveReactionIconURL - The URL of the live reaction icon. Default is "assets/heart-reaction.png".
 * @property {object} messageComposerStyle - The style for the message composer.
 * @property {any} onSendButtonClick - The callback function for when the send button is clicked.
 * @property {any} onError - The callback function for when an error occurs.
 */
class MessageComposerConfiguration {
    constructor(props) {
        this.text = "";
        this.attachmentIconURL = PlusIcon;
        this.auxiliaryButtonsAlignment = uikitResources.AuxiliaryButtonAlignment.right;
        this.sendButtonIconURL = sendIcon;
        this.emojiIconURL = SmileysIcon;
        this.AIIconURL = AIIcon;
        this.hideLayoutMode = false;
        this.hideLiveReaction = false;
        this.LiveReactionIconURL = heartIcon;
        this.messageComposerStyle = {};
        this.actionSheetStyle = {};
        this.AIOptionsStyle = {};
        this.backdropStyle = {};
        this.hideVoiceRecording = false;
        this.mediaRecorderStyle = {};
        this.voiceRecordingCloseIconURL = closeIcon$1;
        this.voiceRecordingStartIconURL = micIcon;
        this.voiceRecordingStopIconURL = stopIcon;
        this.voiceRecordingSubmitIconURL = sendIcon;
        Object.assign(this, props);
    }
}

/**
 * @property {any} emptyStateView - The view to be displayed in case there are no messages.
 * @property {any} errorStateView - The view to be displayed in case of error.
 * @property {any} loadingStateView - The view to be displayed when messages are being fetched.
 * @property {boolean} disableReadReceipt - The flag to enable/disable read receipts.
 * @property {string} readIcon - The icon to be displayed as read receipt.
 * @property {string} deliveredIcon - The icon to be displayed as delivered receipt.
 * @property {string} sentIcon - The icon to be displayed as sent receipt.
 * @property {string} waitIcon - The icon to be displayed as wait receipt.
 * @property {string} errorIcon - The icon to be displayed as error receipt.
 * @property {string} alignment - The alignment of the messages (standard, reverse).
 * @property {boolean} showAvatar - The flag to enable/disable showing avatars.
 * @property {DatePatterns} datePattern - The date pattern for the messages.
 * @property {TimestampAlignment} timestampAlignment - The alignment of the timestamps (top, bottom).
 * @property {DatePatterns} DateSeparatorPattern - The date pattern for the date separators.
 * @property {CometChatMessageTemplate[]} templates - The types of messages to be displayed.
 * @property {any} messagesRequestBuilder - The builder to fetch messages.
 * @property {number} thresholdValue - The threshold value to fetch messages.
 * @property {any} onThreadRepliesClick - The function to be called when thread replies are clicked.
 * @property {any} headerView - The header view to be displayed above the messages.
 * @property {any} footerView - The footer view to be displayed below the messages.
 * @property {BaseStyle} wrapperMessageBubbleStyle - The style for the message bubble.
 * @property {AvatarStyle} avatarStyle - The style for the avatar.
 * @property {DateStyle} dateSeparatorStyle - The style for the date separator.
 * @property {MessageListStyle} messageListStyle - The style for the message list.
 * @property {any} onError - The function to be called in case of error.
 */
class MessageListConfiguration {
    constructor(props) {
        this.disableReceipt = false;
        this.readIcon = readicon;
        this.deliveredIcon = deliveredicon;
        this.sentIcon = senticon;
        this.waitIcon = loadingIcon;
        this.errorIcon = errorIcon;
        this.alignment = uikitResources.MessageListAlignment.standard;
        this.showAvatar = true;
        this.datePattern = uikitResources.DatePatterns.time;
        this.timestampAlignment = uikitResources.TimestampAlignment.bottom;
        this.DateSeparatorPattern = uikitResources.DatePatterns.DayDate;
        this.templates = [];
        this.messageInformationConfiguration = new MessageInformationConfiguration({});
        this.thresholdValue = 1000;
        this.scrollToBottomOnNewMessages = false;
        this.loadingIconURL = LoadingIcon;
        this.avatarStyle = {};
        this.dateSeparatorStyle = {};
        this.messageListStyle = {};
        this.backdropStyle = {};
        Object.assign(this, props);
    }
}

/**
 * @class MessagesConfiguration
 * @param {boolean} hideMessageComposer
 * @param {string} customIncomingMessageSound
 * @param {string} customOutgoingMessageSound
 * @param {boolean} enableSoundForMessages
 * @param {boolean} enableSoundForCalls
 * @param {boolean} enableTypingIndicator
 * @param {object} messageListConfiguration
 * @param {object} messageHeaderConfiguration
 * @param {object} messageComposerConfiguration
 */
class ThreadedMessagesConfiguration {
    constructor(props) {
        this.closeIconURL = closeIcon$1;
        this.messageListConfiguration = new MessageListConfiguration({});
        this.messageComposerConfiguration = new MessageComposerConfiguration({});
        this.threadedMessagesStyle = {};
        Object.assign(this, props);
    }
}

/**
 * @class MessagesConfiguration
 * @param {boolean} hideMessageComposer
 * @param {array} messageTypes
 * @param {string} customIncomingMessageSound
 * @param {string} customOutgoingMessageSound
 * @param {boolean} enableSoundForMessages
 * @param {boolean} enableSoundForCalls
 * @param {boolean} enableTypingIndicator
 * @param {object} messageListConfiguration
 * @param {object} messageHeaderConfiguration
 * @param {object} messageComposerConfiguration
 */
class MessagesConfiguration {
    constructor(props) {
        this.hideMessageComposer = false;
        this.messageHeaderConfiguration = new MessageHeaderConfiguration({});
        this.messageListConfiguration = new MessageListConfiguration({});
        this.messageComposerConfiguration = new MessageComposerConfiguration({});
        this.threadedMessageConfiguration = new ThreadedMessagesConfiguration({});
        this.detailsConfiguration = new DetailsConfiguration({});
        this.messagesStyle = {};
        this.hideMessageHeader = false;
        this.hideDetails = false;
        Object.assign(this, props);
    }
}

var closeIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2Fmoreicon%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FMore%22%20fill%3D%22%23000000%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.5%2C10%20C5.88071187%2C10%207%2C11.1192881%207%2C12.5%20C7%2C13.8807119%205.88071187%2C15%204.5%2C15%20C3.11928813%2C15%202%2C13.8807119%202%2C12.5%20C2%2C11.1192881%203.11928813%2C10%204.5%2C10%20Z%20M12%2C10%20C13.3807119%2C10%2014.5%2C11.1192881%2014.5%2C12.5%20C14.5%2C13.8807119%2013.3807119%2C15%2012%2C15%20C10.6192881%2C15%209.5%2C13.8807119%209.5%2C12.5%20C9.5%2C11.1192881%2010.6192881%2C10%2012%2C10%20Z%20M19.5%2C10%20C20.8807119%2C10%2022%2C11.1192881%2022%2C12.5%20C22%2C13.8807119%2020.8807119%2C15%2019.5%2C15%20C18.1192881%2C15%2017%2C13.8807119%2017%2C12.5%20C17%2C11.1192881%2018.1192881%2C10%2019.5%2C10%20Z%22%20id%3D%22Rectangle-2%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

/**
 * @class MessageBubbleConfiguration
 * @param {BaseStyle} style
 * @param {CometChatMessageOption} options
 * @param {any} leadingView
 * @param {any} headerView
 * @param {any} replyView
 * @param {any} threadView
 *  * @param {string} moreIconURL
 * @param {any} footerView
 *  * @param {number} topMenuSize
 *
 */
class MessageBubbleConfiguration {
    constructor(props) {
        this.messageBubbleStyle = {
            width: "100%",
            height: "auto",
            background: "",
            borderRadius: "12px",
            border: "none"
        };
        this.options = [];
        this.moreIconURL = closeIcon; //Image URL for more icon
        this.topMenuSize = 3;
        Object.assign(this, props);
    }
}

const ExtensionsId = Object.freeze({
    stickers: "stickers",
    reactions: "reactions",
    thumbnailGeneration: "thumbnail-generation",
    linkPreview: "link-preview",
    imageModeration: "image-moderation",
    messageTranslation: "message-translation",
    smartReply: "smart-reply",
    xssFilter: "xss-filter",
    dataMasking: "data-masking",
    polls: "polls",
    whiteboard: "whiteboard",
    document: "document",
    profanityFilter: "profanity-filter"
});

class ExtensionsDataSource {
    enable() {
        chatSdkJavascript.CometChat.isExtensionEnabled(this.getExtensionId())
            .then((isEnabled) => {
            if (isEnabled) {
                this.addExtension();
            }
        })
            .catch((e) => {
            console.error(e);
        });
    }
}

const PollsConstants = Object.freeze({
    polls: "polls",
    post: "POST",
    v2_create: "v2/create",
    v2_vote: "v2/vote",
    extension_poll: "extension_poll",
    injected: "@injected"
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

exports.SmartReplies = class SmartReplies extends lit.LitElement {
    constructor() {
        /**
           * This properties will come from Parent.
           */
        super(...arguments);
        this.smartReplyStyle = {
            height: "",
            width: "",
            border: "",
            borderRadius: "",
            background: "",
            closeIconTint: "grey",
            replyTextColor: "black",
            replyTextFont: "",
            replyBackground: "white",
            boxShadow: "RGBA(20, 20, 20, 0.04) 0 0 0 2px"
        };
        this.replies = [];
        this.closeIconURL = closeIcon$1;
        this.buttonStyles = {
            height: "100%",
            width: "100%",
            border: "none",
            borderRadius: "8px",
            background: ""
        };
        this.closeReplyPreview = () => {
            this.dispatchEvent(new CustomEvent('cc-close-clicked', {
                bubbles: true,
                composed: true,
            }));
        };
    }
    onReplyClick(reply) {
        this.dispatchEvent(new CustomEvent('cc-reply-clicked', {
            bubbles: true,
            composed: true,
            detail: {
                reply: reply
            }
        }));
    }
    closeIconStyle() {
        var _a;
        return {
            height: "24px",
            width: "24px",
            border: "none",
            borderRadius: "0",
            background: "transparent",
            buttonIconTint: (_a = this.smartReplyStyle) === null || _a === void 0 ? void 0 : _a.closeIconTint
        };
    }
    wrapperStyle() {
        var _a, _b, _c, _d, _e;
        return {
            height: (_a = this.smartReplyStyle) === null || _a === void 0 ? void 0 : _a.height,
            width: (_b = this.smartReplyStyle) === null || _b === void 0 ? void 0 : _b.width,
            border: (_c = this.smartReplyStyle) === null || _c === void 0 ? void 0 : _c.border,
            borderRadius: (_d = this.smartReplyStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
            background: (_e = this.smartReplyStyle) === null || _e === void 0 ? void 0 : _e.background,
        };
    }
    render() {
        var _a, _b, _c, _d;
        this.buttonStyles = {
            height: "100%",
            width: "100%",
            border: "none",
            borderRadius: "16px",
            background: (_a = this.smartReplyStyle) === null || _a === void 0 ? void 0 : _a.replyBackground,
            buttonTextFont: (_b = this.smartReplyStyle) === null || _b === void 0 ? void 0 : _b.replyTextFont,
            buttonTextColor: (_c = this.smartReplyStyle) === null || _c === void 0 ? void 0 : _c.replyTextColor,
            boxShadow: (_d = this.smartReplyStyle) === null || _d === void 0 ? void 0 : _d.boxShadow,
            padding: "8px"
        };
        return lit.html `
      <div class="cc-smart-replies" style=${styleMap_js.styleMap(this.wrapperStyle())}>
        <div class="cc-smart-replies__options">
          ${this.replies.map((reply) => lit.html `
                <div class="cc-smart-replies__option">
                  <cometchat-button
                    .text="${reply}"
                    @cc-button-clicked=${() => this.onReplyClick(reply)}
                    .buttonStyle="${this.buttonStyles}"
                  ></cometchat-button>
                </div>
              `)}
        </div>
        ${this.closeIconURL
            ? lit.html `
              <div class="cc-smart-replies__close">
                <cometchat-button
                  @cc-button-clicked=${this.closeReplyPreview}
                  iconURL=${this.closeIconURL}
                  .buttonStyle=${this.closeIconStyle()}
                >
                </cometchat-button>
              </div>
            `
            : lit.nothing}
      </div>
    `;
    }
};
exports.SmartReplies.styles = [
    lit.css `
* {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }
    .cc-smart-replies {
  padding: 7px;
  font-size: 13px;
  display: flex;
  justify-content: flex-start;
  position: relative;
}
.cc-smart-replies__close {
  width: 24px;
  height: 24px;
  margin: auto 0;
  border-radius: 50%;
  cursor: pointer;
}
.cc-smart-replies__options {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  flex-wrap:wrap;
}
.cc-smart-replies__option {
  padding: 4px 8px;
}
  `
];
__decorate([
    decorators_js.property({ type: Object })
], exports.SmartReplies.prototype, "smartReplyStyle", void 0);
__decorate([
    decorators_js.property({ type: Array })
], exports.SmartReplies.prototype, "replies", void 0);
__decorate([
    decorators_js.property()
], exports.SmartReplies.prototype, "closeIconURL", void 0);
exports.SmartReplies = __decorate([
    decorators_js.customElement('smart-replies')
], exports.SmartReplies);

const SmartRepliesConstants = Object.freeze({
    extensions: "extensions",
    metadata: "metadata",
    injected: "@injected",
    smart_reply: "smart-reply",
    reply_positive: "reply_positive",
    reply_neutral: "reply_neutral",
});

class SmartRepliesConfiguration {
    constructor(props) {
        this.SmartRepliesStyle = {};
        Object.assign(this, props);
    }
}

class SmartRepliesStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.replyTextFont = "400 13px Inter, sans-serif";
        this.replyTextColor = "#bcbcbc";
        this.replyBackground = "white";
        this.boxShadow = "RGBA(20, 20, 20, 0.04) 0 0 0 2px";
        this.closeIconTint = "#bcbcbc";
        Object.assign(this, props);
    }
}

const StickersConstants = Object.freeze({
    sticker: "extension_sticker",
    default_stickers: "defaultStickers",
    custom_stickers: "customStickers",
    stickers: "stickers",
    data: "data",
    custom_data: "customData",
    sticker_url: "sticker_url",
    sticker_name: "sticker_name",
    get: "GET",
    v1_fetch: "v1/fetch"
});

exports.StickersKeyboard = class StickersKeyboard extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.errorStateText = uikitResources.localize("SOMETHING_WRONG");
        this.emptyStateText = uikitResources.localize("NO_STICKERS_FOUND");
        this.loadingIconUrl = LoadingIcon;
        this.stickerStyle = {
            width: "100%",
            height: "auto",
            border: "none",
            borderRadius: "8px",
            background: "rgb(245, 245, 245)",
            categoryBackground: "rgb(255,255,255)",
            emptyTextFont: "700 22px Inter,sans-serif",
            emptyTextColor: "rgba(20,20,20, 0.58)",
            errorTextFont: "700 22px Inter,sans-serif",
            errorTextColor: "rgba(20,20,20, 0.58)",
            loadingIconTint: "grey"
        };
        /**
      * Properties for internal use
      */
        this.state = uikitResources.States.loading;
        this.stickerSet = {};
        this.activeStickerList = [];
        this.categoryStickerUrl = [];
        this.keyboardStyles = () => {
            return {
                height: this.stickerStyle.height,
                width: this.stickerStyle.width,
                background: this.stickerStyle.background,
                border: this.stickerStyle.border,
                borderRadius: this.stickerStyle.borderRadius
            };
        };
        this.sectionStyles = () => {
            return {
                background: this.stickerStyle.categoryBackground || "inherit",
                border: this.stickerStyle.border,
                borderRadius: this.stickerStyle.borderRadius
            };
        };
        this.decorateMessageStyles = () => {
            const { state, stickerStyle } = this;
            switch (state) {
                case uikitResources.States.error:
                    return { textColor: stickerStyle.errorTextColor, textFont: stickerStyle.errorTextFont };
                case uikitResources.States.empty:
                    return { textColor: stickerStyle.emptyTextColor, textFont: stickerStyle.emptyTextFont };
                default:
                    return {};
            }
        };
    }
    /**
  * fetching stickers on init
  * @param
  */
    async getStickers() {
        this.state = uikitResources.States.loading;
        try {
            const stickers = await chatSdkJavascript.CometChat.callExtension(StickersConstants.stickers, StickersConstants.get, StickersConstants.v1_fetch);
            let activeStickerSet = null;
            const customStickers = (stickers === null || stickers === void 0 ? void 0 : stickers.customStickers) ? [stickers.customStickers] : [];
            const defaultStickers = stickers.defaultStickers || [];
            defaultStickers.sort((a, b) => a.stickerSetOrder - b.stickerSetOrder);
            customStickers.sort((a, b) => a.stickerSetOrder - b.stickerSetOrder);
            const stickerList = [...defaultStickers, ...customStickers];
            if (stickerList.length === 0) {
                this.state = uikitResources.States.empty;
                this.requestUpdate("state");
            }
            const stickerSet = stickerList.reduce((r, sticker, index) => {
                const { stickerSetName } = sticker;
                if (index === 0) {
                    activeStickerSet = stickerSetName;
                }
                r[stickerSetName] = [...(r[stickerSetName] || []), { ...sticker }];
                return r;
            }, {});
            let activeStickerList = [];
            if (Object.keys(stickerSet).length) {
                Object.keys(stickerSet).forEach((key) => {
                    stickerSet[key].sort((a, b) => a.stickerOrder - b.stickerOrder);
                });
                if (activeStickerSet !== null) {
                    activeStickerList = stickerSet[activeStickerSet];
                }
            }
            this.stickerSet = stickerSet;
            this.activeStickerList = activeStickerList;
            this.requestUpdate("stickerSet");
            if (stickerList.length !== 0) {
                this.state = uikitResources.States.loaded;
                this.requestUpdate("state");
            }
            Object.keys(this.stickerSet).forEach((sectionItem) => {
                const url = this.stickerSet[sectionItem][0];
                this.categoryStickerUrl.push(url);
            });
        }
        catch (error) {
            console.error(error);
            this.state = uikitResources.States.error;
            this.requestUpdate("state");
        }
    }
    /**
     * Gets The sticker collection when sticker category is changed
     * @param
     */
    stickerSetClicked(sectionItem) {
        try {
            const activeStickerList = this.stickerSet[sectionItem];
            this.activeStickerList = activeStickerList;
            this.requestUpdate("activeStickerList");
        }
        catch (error) {
            console.error(error);
        }
    }
    /**
     * Sends Sticker as Message
     * @param
     */
    sendStickerMessage(stickerItem) {
        this.dispatchEvent(new CustomEvent('cc-sticker-clicked', {
            bubbles: true,
            composed: true,
            detail: {
                stickerURL: stickerItem.stickerUrl, stickerName: stickerItem.stickerSetName
            }
        }));
    }
    connectedCallback() {
        super.connectedCallback();
        this.getStickers();
    }
    getStateView() {
        switch (this.state) {
            case uikitResources.States.loading:
                return lit.html `<cometchat-loader .iconURL=${this.loadingIconUrl} .loaderStyle=${this.loaderStyle()}></cometchat-loader>`;
            case uikitResources.States.empty:
                return lit.html `<cometchat-label .text=${this.emptyStateText} .labelStyle=${this.decorateMessageStyles()}></cometchat-label>`;
            case uikitResources.States.error:
                return lit.html `<cometchat-label .text=${this.errorStateText} .labelStyle=${this.decorateMessageStyles()}></cometchat-label>`;
            default:
                return lit.nothing;
        }
    }
    render() {
        const state = this.state;
        const activeStickerList = this.activeStickerList;
        const categoryStickerUrl = this.categoryStickerUrl;
        return lit.html `
    <div class="cc__stickerskeyboard" style=${styleMap_js.styleMap(this.keyboardStyles())}>
      ${state !== uikitResources.States.loaded ? lit.html `
        <div class="decorator__message">
          ${this.getStateView()}
        </div>
      ` : ''}

      <!-- ActiveStickerList -->
      ${state === uikitResources.States.loaded ? lit.html `
        <div class="cc__stickerskeyboard__list">
          ${activeStickerList.map((sticker) => lit.html `
            <div @click=${() => { this.sendStickerMessage(sticker); }}>
              <img src=${sticker.stickerUrl} alt=${sticker.stickerSetName} class="cc__stickerskeyboard__sticker"  />
            </div>
          `)}
        </div>

        <!-- Section Items -->
        <div class="cc__stickerskeyboard__categories" style=${styleMap_js.styleMap(this.sectionStyles())}>
          ${categoryStickerUrl.map((sticker) => lit.html `
            <div @click=${() => { this.stickerSetClicked(sticker.stickerSetName); }}>
              ${sticker.stickerUrl ? lit.html `
                <img src=${sticker.stickerUrl} class="cc__stickerskeyboard__category"  />
              ` : ''}
            </div>
          `)}
        </div>
      ` : ''}
    </div>
  `;
    }
    loaderStyle() {
        return {
            iconTint: this.stickerStyle.loadingIconTint
        };
    }
};
exports.StickersKeyboard.styles = [
    lit.css `
:host {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }
.cc__stickerskeyboard {
  min-height: 230px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.cc__stickerskeyboard__categories {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 16px;
  background: inherit;
}
.cc__stickerskeyboard__categories::-webkit-scrollbar {
    background: transparent;
    height: 8px;
}
.cc__stickerskeyboard__categories::-webkit-scrollbar-thumb {
    background: rgb(232, 229, 229);
    border-radius: 8px;
}
.cc__stickerskeyboard__list::-webkit-scrollbar {
    background: transparent;
    width: 8px;
}
.cc__stickerskeyboard__list::-webkit-scrollbar-thumb {
    background: rgb(232, 229, 229);
    border-radius: 8px;
}
.cc__stickerskeyboard__category {
  height: 35px;
  width: 35px;
  cursor: pointer;
  flex-shrink: 0;
}
.cc__stickerskeyboard__list {
  max-height: calc(100% - 50px);
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
  flex-wrap: wrap;
  background:inherit;
  margin: 0 8px;
}
.cc__stickerskeyboard__sticker {
  min-width: 50px;
  min-height: 50px;
  max-width: 70px;
  cursor: pointer;
  flex-shrink: 0;
  margin-right: 20px;
  height:fit-content;
  width:fit-content;
}
.decorator__message {
 margin:auto;
}
  `
];
__decorate([
    decorators_js.property()
], exports.StickersKeyboard.prototype, "errorStateText", void 0);
__decorate([
    decorators_js.property()
], exports.StickersKeyboard.prototype, "emptyStateText", void 0);
__decorate([
    decorators_js.property()
], exports.StickersKeyboard.prototype, "loadingIconUrl", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.StickersKeyboard.prototype, "stickerStyle", void 0);
exports.StickersKeyboard = __decorate([
    decorators_js.customElement('stickers-keyboard')
], exports.StickersKeyboard);

class StickersConfiguration {
    constructor(props) {
        this.loadingIconUrl = LoadingIcon;
        this.stickerskeyboardstyle = {};
        Object.assign(this, props);
    }
}

class StickersStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.width = '300px';
        this.height = '400px';
        this.stickerButtonWidth = '24px';
        this.sticketButtonHeight = '24px';
        this.stickerButtonIconTint = 'rgba(20, 20, 20, 0.46)';
        this.emptyStateTextFont = "700 22px Inter, sans-serif";
        this.emptyStateTextColor = "#bcbcbc";
        this.errorStateTextFont = "700 22px Inter, sans-serif";
        this.errorStateTextColor = "#bcbcbc";
        this.loadingIconTint = "#bcbcbc";
        this.categoryBackground = "";
        Object.assign(this, props);
    }
}

const MessageTranslationConstants = Object.freeze({
    message_translation: "message-translation",
    v2_translate: "v2/translate",
    translated_message: "translated_message",
    extensions: "extensions",
    metadata: "metadata",
    injected: "@injected",
    post: "POST"
});

class MessageTranslationStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.helpTextFont = "400 11px Inter, sans-serif";
        this.helpTextColor = "RGBA(255, 255, 255, 0.6)";
        this.translatedTextFont = "400 13px Inter, sans-serif";
        this.translatedTextColor = "RGBA(255, 255, 255, 0.8)";
        Object.assign(this, props);
    }
}

exports.MessageTranslationBubble = class MessageTranslationBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.translatedText = "";
        this.messageTranslationStyle = {
            helpTextFont: "400 11px Inter, sans-serif",
            helpTextColor: "RGBA(255, 255, 255, 0.6)",
            translatedTextFont: "400 13px Inter, sans-serif",
            translatedTextColor: "RGBA(255, 255, 255, 0.8)",
        };
        this.alignment = uikitResources.MessageBubbleAlignment.right;
        this.helpText = uikitResources.localize("TRANSLATED_MESSAGE");
        this.translatedMessageStyle = () => {
            return {
                color: this.messageTranslationStyle.helpTextColor,
                font: this.messageTranslationStyle.helpTextFont
            };
        };
        this.translatedMessageTextStyle = () => {
            return {
                color: this.messageTranslationStyle.translatedTextColor,
                font: this.messageTranslationStyle.translatedTextFont
            };
        };
        this.translationAlignment = () => {
            return {
                display: "flex",
                justifyContent: "center",
                alignItems: this.alignment == uikitResources.MessageBubbleAlignment.left ? "flex-start" : "flex-end"
            };
        };
    }
    render() {
        var _a;
        return lit.html `

         ${this.translatedText && ((_a = this.translatedText) === null || _a === void 0 ? void 0 : _a.trim().length) > 0 ? lit.html `  <div class="cc__messagetranslation" style=${styleMap_js.styleMap(this.translationAlignment())} >
                   <slot></slot>
                <div class="cc__messagetranslation_message" style=${styleMap_js.styleMap(this.translatedMessageTextStyle())} > ${this.translatedText} </div>
                <div class="cc__messagetranslation_text"  style=${styleMap_js.styleMap(this.translatedMessageStyle())}>${this.helpText}</div>

            </div>` : ""}

        `;
    }
};
exports.MessageTranslationBubble.styles = [
    lit.css `
.cc__messagetranslation{
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 0 8px;
    width: auto;
    background: transparent;
    gap:2px;
    padding-bottom:8px;
}
.cc__messagetranslation_message{
  padding:0 8px;
}
.cc__messagetranslation_text{
  padding:0 8px;
}
    `
];
__decorate([
    decorators_js.property()
], exports.MessageTranslationBubble.prototype, "translatedText", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.MessageTranslationBubble.prototype, "messageTranslationStyle", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.MessageTranslationBubble.prototype, "alignment", void 0);
__decorate([
    decorators_js.property()
], exports.MessageTranslationBubble.prototype, "helpText", void 0);
exports.MessageTranslationBubble = __decorate([
    decorators_js.customElement('message-translation-bubble')
], exports.MessageTranslationBubble);

class MessageTranslationConfiguration {
    constructor(props) {
        this.MessageTranslationStyle = {};
        Object.assign(this, props);
    }
}

class CollaborativeDocumentStyle extends uikitElements.DocumentBubbleStyle {
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}

class CollaborativeDocumentConfiguration {
    constructor(props) {
        this.documentBubbleStyle = {};
        this.iconURL = "";
        this.ccClicked = null;
        Object.assign(this, props);
    }
}

const CollaborativeDocumentConstants = Object.freeze({
    v1_create: "v1/create",
    extension_document: "extension_document",
    document: "document",
    extensions: "extensions",
    metadata: "metadata",
    injected: "@injected",
    post: "POST"
});

class CollaborativeWhiteboardStyle extends uikitElements.DocumentBubbleStyle {
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}

class CollaborativeWhiteboardConfiguration {
    constructor(props) {
        this.WhiteBoardBubbleStyle = {};
        this.iconURL = "";
        this.ccClicked = null;
        Object.assign(this, props);
    }
}

const CollaborativeWhiteboardConstants = Object.freeze({
    v1_create: "v1/create",
    extension_whiteboard: "extension_whiteboard",
    whiteboard: "whiteboard",
    extensions: "extensions",
    metadata: "metadata",
    injected: "@injected",
    post: "POST"
});

class CreatePollStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.placeholderTextFont = "400 15px Inter";
        this.placeholderTextColor = "RGBA(20, 20, 20, 0.6)";
        this.deleteIconTint = "grey";
        this.titleFont = "700 22px Inter, sans-serif";
        this.titleColor = "rgb(20, 20, 20)";
        this.closeIconTint = "rgb(51, 153, 255)";
        this.questionInputBackground = "rgba(20, 20, 20, 0.08)";
        this.optionInputBackground = "rgba(20, 20, 20, 0.08)";
        this.answerHelpTextFont = "500 12px Inter, sans-serif";
        this.answerHelpTextColor = "rgba(20, 20, 20, 0.58)";
        this.addAnswerIconTint = "rgb(51, 153, 255)";
        this.createPollButtonTextFont = "600 15px Inter, sans-serif";
        this.createPollButtonTextColor = "rgb(255, 255, 255)";
        this.createPollButtonBackground = "rgb(51, 153, 255)";
        this.addAnswerTextFont = "500 15px Inter, sans-serif";
        this.addAnswerTextColor = "rgb(51, 153, 255)";
        this.errorTextFont = "400 15px Inter, sans-serif";
        this.errorTextColor = "rgb(255, 59, 48)";
        this.optionPlaceholderTextFont = "400 15px Inter";
        this.optionPlaceholderTextColor = "RGBA(20, 20, 20, 0.6)";
        this.questionInputTextFont = "400 13px Inter";
        this.questionInputTextColor = "RGBA(20, 20, 20, 0.6)";
        this.optionInputTextFont = "400 13px Inter";
        this.optionInputTextColor = "RGBA(20, 20, 20, 0.6)";
        Object.assign(this, props);
    }
}

exports.CreatePoll = class CreatePoll extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.title = uikitResources.localize("CREATE_POLL");
        this.ccCloseClicked = null;
        this.defaultAnswers = 3;
        this.questionPlaceholderText = uikitResources.localize("QUESTION");
        this.answerPlaceholderText = uikitResources.localize("ANSWER");
        this.answerHelpText = uikitResources.localize("SET_THE_ANSWERS");
        this.addAnswerText = uikitResources.localize("ADD_ANOTHER_ANSWER");
        this.deleteIconURL = DeleteIcon;
        this.closeIconURL = closeIcon$1;
        this.addAnswerIconURL = PlusIcon;
        this.createPollButtonText = uikitResources.localize("CREATE");
        this.createPollStyle = {
            width: "360px",
            height: "620px",
            border: "",
            borderRadius: "8px",
            background: "white",
            placeholderTextFont: "400 15px Inter",
            placeholderTextColor: "RGBA(20, 20, 20, 0.6)",
            deleteIconTint: "grey",
            titleFont: "700 22px Inter, sans-serif",
            titleColor: "rgb(20, 20, 20)",
            closeIconTint: "rgb(51, 153, 255)",
            questionInputBackground: "rgba(20, 20, 20, 0.04)",
            optionInputBackground: "rgba(20, 20, 20, 0.04)",
            questionInputTextFont: "400 13px Inter",
            questionInputTextColor: "RGBA(20, 20, 20, 0.6)",
            optionInputTextFont: "400 13px Inter",
            optionInputTextColor: "RGBA(20, 20, 20, 0.6)",
            answerHelpTextFont: "500 12px Inter, sans-serif",
            answerHelpTextColor: "rgba(20, 20, 20, 0.58)",
            addAnswerIconTint: "rgb(51, 153, 255)",
            createPollButtonTextFont: "600 15px Inter, sans-serif",
            createPollButtonTextColor: "rgb(255, 255, 255)",
            createPollButtonBackground: "rgb(51, 153, 255)",
            addAnswerTextFont: "500 15px Inter, sans-serif",
            addAnswerTextColor: "rgb(51, 153, 255)",
            errorTextFont: "400 15px Inter, sans-serif",
            errorTextColor: "rgb(255, 59, 48)",
            optionPlaceholderTextFont: "400 15px Inter",
            optionPlaceholderTextColor: "RGBA(20, 20, 20, 0.6)"
        };
        /**
      * Properties for internal use
      */
        this.errorText = uikitResources.localize("SOMETHING_WRONG");
        this.inputQuestion = "";
        this.inputOptionItems = [];
        this.isError = false;
        this.type = "";
        //   styling
        this.closeButtonStyle = () => {
            return {
                buttonIconTint: this.createPollStyle.closeIconTint,
                border: "none",
                borderRadius: "8px",
                height: "24px",
                width: "24px",
                background: "transparent"
            };
        };
        this.addIconStyle = () => {
            return {
                buttonIconTint: this.createPollStyle.addAnswerIconTint,
                border: "none",
                borderRadius: "8px",
                height: "24px",
                width: "24px",
                background: "transparent"
            };
        };
        this.removeIconStyle = () => {
            return {
                buttonIconTint: this.createPollStyle.deleteIconTint,
                border: "none",
                borderRadius: "8px",
                height: "24px",
                width: "24px",
                background: "transparent"
            };
        };
        this.titleStyle = () => {
            return {
                textFont: this.createPollStyle.titleFont,
                textColor: this.createPollStyle.titleColor
            };
        };
        this.subtitleStyle = () => {
            return {
                textFont: this.createPollStyle.answerHelpTextFont,
                textColor: this.createPollStyle.answerHelpTextColor
            };
        };
        this.placeHolderStyle = () => {
            return {
                height: "24px",
                width: "100%",
                border: "none",
                textFont: this.createPollStyle.questionInputTextFont,
                textColor: this.createPollStyle.questionInputTextColor,
                placeholderTextFont: this.createPollStyle.placeholderTextFont,
                placeholderTextColor: this.createPollStyle.placeholderTextColor,
                borderRadius: "8px",
                boxShadow: "",
                background: "transparent"
            };
        };
        this.optionPlaceHolderStyle = () => {
            return {
                height: "24px",
                width: "100%",
                border: "none",
                textFont: this.createPollStyle.optionInputTextFont,
                textColor: this.createPollStyle.optionInputTextColor,
                placeholderTextFont: this.createPollStyle.optionPlaceholderTextFont,
                placeholderTextColor: this.createPollStyle.optionPlaceholderTextColor,
                borderRadius: "8px",
                boxShadow: "",
                background: "transparent"
            };
        };
        this.addIconTextStyle = () => {
            return {
                font: this.createPollStyle.addAnswerTextFont,
                color: this.createPollStyle.addAnswerTextColor
            };
        };
        this.buttonTextStyle = () => {
            return {
                buttonTextFont: this.createPollStyle.createPollButtonTextFont,
                buttonTextColor: this.createPollStyle.createPollButtonTextColor,
                background: this.createPollStyle.createPollButtonBackground,
                border: "none",
                borderRadius: "8px",
                height: "36px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            };
        };
        this.createPollWrapperStyle = () => {
            return {
                height: this.createPollStyle.height,
                width: this.createPollStyle.width,
                background: this.createPollStyle.background,
                border: this.createPollStyle.border,
                borderRadius: this.createPollStyle.borderRadius
            };
        };
        this.optionBorderStyle = () => {
            return {
                border: this.createPollStyle.border,
                borderRadius: this.createPollStyle.borderRadius,
                background: this.createPollStyle.optionInputBackground
            };
        };
        this.questionBorderStyle = () => {
            return {
                border: this.createPollStyle.border,
                borderRadius: this.createPollStyle.borderRadius,
                background: this.createPollStyle.questionInputBackground
            };
        };
    }
    closePollView() {
        this.dispatchEvent(new CustomEvent('cc-close-clicked', {
            bubbles: true,
            composed: true,
        }));
    }
    getOptionCount(count) {
        let text = this.answerPlaceholderText + " " + (count + 1);
        return text;
    }
    updated(_changedProperties) {
        if (_changedProperties.has('user') || _changedProperties.has('group')) {
            this.inputOptionItems = [];
            let arr = Array(this.defaultAnswers);
            for (let i = 0; i < arr.length; i++) {
                this.addPollOption();
            }
            this.requestUpdate("inputOptionItems");
            if (this.user) {
                this.type = uikitResources.CometChatUIKitConstants.MessageReceiverType.user;
            }
            else if (this.group) {
                this.type = uikitResources.CometChatUIKitConstants.MessageReceiverType.group;
            }
        }
    }
    connectedCallback() {
        super.connectedCallback();
        let arr = Array(this.defaultAnswers);
        for (let i = 0; i < arr.length; i++) {
            this.addPollOption();
        }
    }
    /**
   * Used to add an extra option
   * @param
   */
    addPollOption() {
        try {
            this.inputOptionItems.push({
                key: '',
                value: ''
            });
            this.requestUpdate("inputOptionItems");
        }
        catch (error) {
            console.log(error);
        }
    }
    /**
     * Used to remove an extra option
     * @param number index
     */
    removePollOption(index) {
        try {
            this.inputOptionItems.splice(index, 1);
            this.requestUpdate("inputOptionItems");
        }
        catch (error) {
            console.log(error);
        }
    }
    /**
   * Creates the poll
   */
    createPoll() {
        var _a, _b;
        try {
            let inputValue = this.inputOptionItems
                .map(item => item.value)
                .filter(value => value !== undefined && value !== '');
            if (this.inputQuestion.trim().length === 0) {
                this.isError = true;
                this.requestUpdate("isError");
                return false;
            }
            this.isError = false;
            this.requestUpdate("isError");
            let receiverId;
            let receiverType = this.type;
            if (this.type === chatSdkJavascript.CometChat.RECEIVER_TYPE.USER) {
                receiverId = this.user instanceof chatSdkJavascript.CometChat.User ? (_a = this.user) === null || _a === void 0 ? void 0 : _a.getUid() : this.user.uid;
            }
            else if (this.type === chatSdkJavascript.CometChat.RECEIVER_TYPE.GROUP) {
                receiverId = this.group instanceof chatSdkJavascript.CometChat.Group ? (_b = this.group) === null || _b === void 0 ? void 0 : _b.getGuid() : this.group.guid;
            }
            let optionList = [
                ...inputValue
            ];
            chatSdkJavascript.CometChat.callExtension(PollsConstants.polls, PollsConstants.post, PollsConstants.v2_create, {
                question: this.inputQuestion,
                options: optionList,
                receiver: receiverId,
                receiverType: receiverType,
            })
                .then((response) => {
                this.isError = false;
                if (response && response.hasOwnProperty("success") && response["success"] === true) {
                    this.closePollView();
                }
            })
                .catch((error) => {
                this.isError = true;
                this.requestUpdate("isError");
            })
                .finally(() => {
            });
        }
        catch (error) {
            console.log(error);
        }
        return true;
    }
    render() {
        return lit.html `
 <div class="cc__createpoll" style=${styleMap_js.styleMap(this.createPollWrapperStyle())}>
    <div class="cc__createpoll__close"  >
   <cometchat-button @cc-button-clicked=${() => this.closePollView()} .buttonStyle=${this.closeButtonStyle()} .iconURL=${this.closeIconURL}></cometchat-button>
</div>
    <div class="cc__createpoll__body">
      <div class="cc__pollcaption" >
        <cometchat-label .text=${this.title} .labelStyle=${this.titleStyle()}></cometchat-label>
      </div>
      <div class="cc__createpoll__content">
        <div class="cc__error__body" ?hidden=${!this.isError}>
          <div class="cc__polldata">
            <cometchat-label .text=${this.errorText} >
            </cometchat-label>
          </div>
        </div>
        <div class="cc__pollrow" style=${styleMap_js.styleMap(this.questionBorderStyle())}>
          <div class="cc__polldata">
            <cometchat-input class="cc__polldata__input" .type=${"text"}
              .placeholderText =${this.questionPlaceholderText} .value=${this.inputQuestion} .inputStyle=${this.placeHolderStyle()}
              @cc-input-changed=${(e) => this.inputQuestion = e.target.value}></cometchat-input>
          </div>
        </div>
        <!--  Answers list  -->
        <div class="cc__pollrow cc__addoption__row">
          <div class="icon__wrapper cc__polldata cc__helpertext__wrapper">
            <cometchat-label class="add__answer__text" .labelStyle=${this.subtitleStyle()} .text=${this.answerHelpText}>  </cometchat-label>
          </div>
        </div>
        ${this.inputOptionItems.map((option, i) => lit.html `
          <div class="cc__pollrow" style=${styleMap_js.styleMap(this.optionBorderStyle())}>
            <div class="cc__polldata">
                <cometchat-input class="cc__polldata__input" .type=${"text"}
              .placeholderText =${this.getOptionCount(i)} .value=${option.value} .inputStyle=${this.optionPlaceHolderStyle()}
              @cc-input-changed=${(e) => {
            this.inputOptionItems[i].value = e.target.value;
        }} ></cometchat-input>
            </div>
            ${i > 1 ? lit.html `
            <div class="icon__remove cc__polldata">
                <cometchat-button class="cc__removeicon" @cc-button-clicked=${() => this.removePollOption(i)} .buttonStyle=${this.removeIconStyle()} .iconURL=${this.deleteIconURL}></cometchat-button>
            </div>
            ` : lit.nothing}
          </div>
        `)}
      </div>
          <!--  POLL OPTION VIEW ABOVE -->
          <div class="cc__pollrow cc__addoption__row">
          <div class="icon__wrapper cc__polldata cc__addicon__wrapper">
            <!-- Add Icon -->
            <cometchat-button class="option__icon add__icon" @cc-button-clicked=${() => this.addPollOption()} .buttonStyle=${this.addIconStyle()} .iconURL=${this.addAnswerIconURL}></cometchat-button>
            <span class="add__answer__text" style=${styleMap_js.styleMap(this.addIconTextStyle())}>${this.addAnswerText} </span>
          </div>
        </div>
    </div>
    <div class="cc__createpoll-button">
        <cometchat-button  @cc-button-clicked=${() => this.createPoll()} .buttonStyle=${this.buttonTextStyle()} .text=${this.createPollButtonText}></cometchat-button>
      </div>
  </div>
    `;
    }
};
exports.CreatePoll.styles = [
    lit.css `
   *{
    box-sizing:border-box;
       margin:0;
       padding:0;
   }
   .option__icon {
  background-size: 28px 28px;
  cursor: pointer;
  display: block;
  height: 28px;
  width: 28px;
  z-index: 1000;
  margin-right: 10px;
}
.add__icon {
  background-size: 24px 24px;
  cursor: pointer;
  display: block;
  height: 24px;
  width: 24px;
}
.add__answer__text {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cc__removeicon {
  cursor: pointer;
  display: block;
  height: 24px;
  width: 24px;
}
.icon__wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.icon__remove {
  width: fit-content !important;
  display: flex;
  justify-content: flex-end;
  padding-right:16px !important;
}
.cc__createpoll {
  display: block;
  z-index: 10;
  margin: 0 auto;
  border-radius: 8px;
  display: flex;
    flex-direction: column;
    position:relative;
}
input {
  outline: none;
}
.cc__createpoll__close {
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  top: 8px;
    right: 14px;
  cursor: pointer;
}
.cc__createpoll__body {
  padding: 8px;
  width: 100%;
  height: 100%;
 display:flex;
 flex-direction:column;
 justify-content: flex-start;
  margin: 0;
}
.decorator__message--error {
  text-align: center;
}
.cc__error__body {
  border: none !important;
}
.cc__pollcaption {
  margin-bottom: 15px;
  text-align: center;
}
.cc__createpoll__content{
  display: block;
  overflow-x:auto;
}
.cc__polldata {
  padding: 8px;
  width: 100%;
  background: inherit;
  border-radius:inherit;
}
.cc__polldata__width {
  width: 110px;
}
.cc__addoption__row {
  border: none !important;
  margin: 10px 0;
}
.cc__helpertext__wrapper{
  padding: 6px 0 !important;
}
.cc__addicon__wrapper {
  padding: 16px 0 !important;
}
.cc__pollrow {
  display: flex;
  margin: 8px 0;
  justify-content:space-between;
  position:relative;
}
.cc__polldata__input {
  padding: 6px 0;
  background: transparent;
  width: 100%;
  border: none;
}
.cc__polldata__label:focus {
  outline: none;
}
.cc__polldata__label {
  padding: 6px 12px;
}
.cc__createpoll-button {
  display: block;
  width: 100%;
  padding:16px 8px;
}
    `
];
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "title", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CreatePoll.prototype, "user", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CreatePoll.prototype, "group", void 0);
__decorate([
    decorators_js.property({ attribute: false })
], exports.CreatePoll.prototype, "ccCloseClicked", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.CreatePoll.prototype, "defaultAnswers", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "questionPlaceholderText", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "answerPlaceholderText", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "answerHelpText", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "addAnswerText", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "deleteIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "closeIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "addAnswerIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CreatePoll.prototype, "createPollButtonText", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CreatePoll.prototype, "createPollStyle", void 0);
exports.CreatePoll = __decorate([
    decorators_js.customElement('create-poll')
], exports.CreatePoll);

var optionBackgroundIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FCheckmark%20Empty%402x%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FCheckmark-Empty%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%283.000000%2C%203.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C9%20C0%2C13.9705627%204.02943725%2C18%209%2C18%20C13.9705627%2C18%2018%2C13.9705627%2018%2C9%20C18%2C4.02943725%2013.9705627%2C0%209%2C0%20C4.02943725%2C0%200%2C4.02943725%200%2C9%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

exports.PollsBubble = class PollsBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
        this.pollQuestion = "";
        this.pollId = "";
        this.senderUid = "";
        this.pollStyle = {
            width: "100%",
            height: "auto",
            border: "0 none",
            borderRadius: "12px",
            background: "#ededed",
            votePercentTextFont: "",
            votePercentTextColor: "",
            pollQuestionTextFont: "500 12px Inter, sans-serif",
            pollQuestionTextColor: "#39f",
            pollOptionTextFont: "400 15px Inter,sans-serif",
            pollOptionTextColor: "#39f",
            pollOptionBackground: "#fff",
            pollOptionBorder: "",
            pollOptionBorderRadius: "",
            optionsIconTint: "rgba(20, 20, 20, 0.58)",
            totalVoteCountTextFont: "400 13px Inter,sans-serif",
            totalVoteCountTextColor: "#fff",
            selectedPollOptionBackground: "grey",
            userSelectedOptionBackground: "lightblue"
        };
        this.pollOptions = [];
        this.totalVotes = 0;
        this.pollExtensionData = {};
        this.messageContainer = () => {
            return {
                background: "transparent",
                height: this.pollStyle.height,
                width: this.pollStyle.width,
            };
        };
        this.setvotePercentageStyle = () => {
            return {
                font: this.pollStyle.votePercentTextFont,
                color: this.pollStyle.votePercentTextColor,
            };
        };
        this.setPollOptionStyle = () => {
            return {
                font: this.pollStyle.pollOptionTextFont,
                color: this.pollStyle.pollOptionTextColor,
            };
        };
        this.pollResultStyle = () => {
            return {
                textFont: this.pollStyle.totalVoteCountTextFont,
                textColor: this.pollStyle.totalVoteCountTextColor,
            };
        };
        this.pollOptionStyle = (option) => {
            var _a, _b, _c, _d, _e, _f;
            if (option.selectedByLoggedInUser) {
                return {
                    background: `linear-gradient(to right, ${this.pollStyle.userSelectedOptionBackground} ${option.percent}, white 0%)`,
                    border: (_a = this.pollStyle) === null || _a === void 0 ? void 0 : _a.pollOptionBorder,
                    borderRadius: ((_b = this.pollStyle) === null || _b === void 0 ? void 0 : _b.pollOptionBorderRadius) || "8px"
                };
            }
            else if ((option === null || option === void 0 ? void 0 : option.percent) != "0%") {
                return {
                    background: `linear-gradient(to right, ${this.pollStyle.selectedPollOptionBackground} ${option.percent}, white 0%)`,
                    border: (_c = this.pollStyle) === null || _c === void 0 ? void 0 : _c.pollOptionBorder,
                    borderRadius: ((_d = this.pollStyle) === null || _d === void 0 ? void 0 : _d.pollOptionBorderRadius) || "8px"
                };
            }
            else {
                return {
                    background: this.pollStyle.pollOptionBackground,
                    border: (_e = this.pollStyle) === null || _e === void 0 ? void 0 : _e.pollOptionBorder,
                    borderRadius: ((_f = this.pollStyle) === null || _f === void 0 ? void 0 : _f.pollOptionBorderRadius) || "8px"
                };
            }
        };
        this.checkIconStyle = (option) => {
            var _a;
            return option.percent === '0%' ? {
                width: "24px",
                height: "24px",
                iconTint: (_a = this.pollStyle) === null || _a === void 0 ? void 0 : _a.optionsIconTint,
            } : {};
        };
        this.pollStyles = () => {
            var _a, _b, _c, _d, _e;
            return {
                width: (_a = this.pollStyle) === null || _a === void 0 ? void 0 : _a.width,
                height: (_b = this.pollStyle) === null || _b === void 0 ? void 0 : _b.height,
                border: (_c = this.pollStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.pollStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.pollStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
        this.pollTitleStyle = () => {
            var _a, _b;
            return {
                textFont: (_a = this.pollStyle) === null || _a === void 0 ? void 0 : _a.pollQuestionTextFont,
                textColor: (_b = this.pollStyle) === null || _b === void 0 ? void 0 : _b.pollQuestionTextColor,
            };
        };
    }
    /**
     * Displays the poll component , only if it is enabled
     */
    /**
     * Sets Poll Data
     * @param
     */
    setPollExtensionData() {
        var _a, _b, _c, _d, _e, _f;
        try {
            let pollsData = this.metadata[PollsConstants.injected] ? (_b = (_a = this.metadata[PollsConstants.injected]) === null || _a === void 0 ? void 0 : _a.extensions) === null || _b === void 0 ? void 0 : _b.polls : {};
            this.pollExtensionData = pollsData;
            this.pollId = this.pollId;
            this.totalVotes = (_d = (_c = this.pollExtensionData) === null || _c === void 0 ? void 0 : _c.results) === null || _d === void 0 ? void 0 : _d.total;
            let optionKeys = Object.keys((_e = this.pollExtensionData) === null || _e === void 0 ? void 0 : _e.options);
            let optionList = [];
            optionKeys.forEach((currentItem) => {
                var _a, _b, _c, _d, _e;
                const optionData = (_b = (_a = this.pollExtensionData) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.options[currentItem];
                const vote = optionData["count"];
                let calculatedPercent = 0;
                if (this.totalVotes > 0) {
                    calculatedPercent = Math.round((vote / this.totalVotes) * 100);
                }
                let selectedByLoggedInUser = false;
                if (optionData === null || optionData === void 0 ? void 0 : optionData.hasOwnProperty("voters")) {
                    if ((_c = optionData === null || optionData === void 0 ? void 0 : optionData.voters) === null || _c === void 0 ? void 0 : _c.hasOwnProperty((_d = this.loggedInUser) === null || _d === void 0 ? void 0 : _d.uid)) {
                        selectedByLoggedInUser = true;
                    }
                }
                optionList.push({
                    id: currentItem,
                    percent: calculatedPercent + "%",
                    text: (_e = this.pollExtensionData) === null || _e === void 0 ? void 0 : _e.options[currentItem],
                    selectedByLoggedInUser,
                });
            });
            this.pollOptions = ((_f = this.options) === null || _f === void 0 ? void 0 : _f.length) > 0 ? this.options : [...optionList];
            this.requestUpdate("pollOptions");
        }
        catch (error) {
            console.warn(error);
        }
    }
    updated(_changedProperties) {
        if (_changedProperties.has('metadata')) {
            this.setPollExtensionData();
        }
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return lit.html `
<div class="cc__pollsbubble__wrapper" style=${styleMap_js.styleMap(this.pollStyles())}>
        <div class="cc__pollsbubble">
          <cometchat-label .text=${this.pollQuestion} class="cc__pollsbubble__question" .labelStyle=${this.pollTitleStyle()}></cometchat-label>
          <ul class="cc__pollsbubble__options">
            <!-- Options -->
            ${this.pollOptions.map((option) => lit.html `
                <li
                  @click=${() => this.answerPollQuestion(option)}
                  class="cc__pollsbubble__option ${(option === null || option === void 0 ? void 0 : option.selectedByLoggedInUser) ? 'cc__pollsbubble__checked' : 'cc__pollsbubble__unchecked'}"
                  style=${styleMap_js.styleMap(this.pollOptionStyle(option))}
                >
                    <div class="cc__pollsbubble__option-data">
                     ${option.percent == '0%' ? lit.html ` <cometchat-icon class="cc__pollsbubble__option-icon" .iconStyle=${this.checkIconStyle(option)} .URL=${optionBackgroundIcon}></cometchat-icon>` : lit.nothing}
                      <span style=${styleMap_js.styleMap(this.setPollOptionStyle())}>${option === null || option === void 0 ? void 0 : option.text}</span>
                      </div>
                    ${this.totalVotes ? lit.html `<span style=${styleMap_js.styleMap(this.setvotePercentageStyle())}>${option === null || option === void 0 ? void 0 : option.percent}</span>` : lit.nothing}
                </li>
              `)}
            <!-- Options -->
          </ul>
          ${((_b = (_a = this.pollExtensionData) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.total) && ((_d = (_c = this.pollExtensionData) === null || _c === void 0 ? void 0 : _c.results) === null || _d === void 0 ? void 0 : _d.total) === 1 ? lit.html `<cometchat-label class="cc__pollsbubble__total-count" .labelStyle=${this.pollResultStyle()} .text=${((_f = (_e = this.pollExtensionData) === null || _e === void 0 ? void 0 : _e.results) === null || _f === void 0 ? void 0 : _f.total) + " " + uikitResources.localize("VOTE")}></cometchat-label>` : ''}
          ${((_h = (_g = this.pollExtensionData) === null || _g === void 0 ? void 0 : _g.results) === null || _h === void 0 ? void 0 : _h.total) && ((_k = (_j = this.pollExtensionData) === null || _j === void 0 ? void 0 : _j.results) === null || _k === void 0 ? void 0 : _k.total) !== 1 ? lit.html `<cometchat-label class="cc__pollsbubble__total-count" .labelStyle=${this.pollResultStyle()} .text=${((_m = (_l = this.pollExtensionData) === null || _l === void 0 ? void 0 : _l.results) === null || _m === void 0 ? void 0 : _m.total) + " " + uikitResources.localize("VOTES")}></cometchat-label>` : ''}
        </div>
      </div>
      `;
    }
    /**
     * sends the  answer selected by the user for the  the poll question
     * @param Any selectedOption
     */
    answerPollQuestion(selectedOption) {
        var _a;
        try {
            if (((_a = this.loggedInUser) === null || _a === void 0 ? void 0 : _a.uid) != this.senderUid) {
                this.selectedOption = selectedOption;
                this.requestUpdate("selectedOption");
                chatSdkJavascript.CometChat.callExtension(PollsConstants.polls, PollsConstants.post, PollsConstants.v2_vote, {
                    vote: selectedOption.id,
                    id: this.pollId,
                });
            }
            else {
                return;
            }
        }
        catch (error) {
            console.error(error);
        }
    }
};
exports.PollsBubble.styles = [
    lit.css `
    *{
      box-sizing:border-box;
      margin:0;
      padding:0;
    }
.cc__pollsbubble__wrapper {
  width: 100%;
  min-width:100px;
  flex: 1 1;
  align-self: flex-start;
  display: flex;
}
.cc__pollsbubble {
  display: inline-block;
  background: transparent;
  padding: 8px;
  align-self: flex-start;
    width: 100%;
}
.cc__pollsbubble__question {
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: left;
  width: 100%;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
}
.cc__pollsbubble__option-data {
  display: flex;
  align-items: center;
}
.cc__pollsbubble__option-icon {
  display: block;
  margin-right:8px;
}
.cc__pollsbubble__options {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.cc__pollsbubble__options>li {
  margin: 10px 0;
  display: flex;
  width: 100%;
  cursor: pointer;
  position: relative;
}
.cc__pollsbubble__total-count {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content:flex-start;
}
.poll__percent__style {
  max-width: 100%;
  width: 100%;
  min-height: 35px;
  height: 100%;
  position: absolute;
  z-index: 1;
}
.cc__pollsbubble__option{
  width: 100%;
  justify-content: space-between;
  padding:0 4px;
}
.cc__pollsbubble__unchecked {
  display: flex;
  align-items: center;
  min-height: 35px;
  padding:0 4px;
  height: 100%;
  span {
    width: max-content;
    padding: 6px;
    display: inline-block;
  }
}
.cc__pollsbubble__checked {
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 35px;
  height: 100%;
  /* z-index: 2; */
  padding:0 4px;
  span {
    width: max-content;
    padding: 6px;
    display: inline-block;
  }
}
    `
];
__decorate([
    decorators_js.property({ type: Array })
], exports.PollsBubble.prototype, "options", void 0);
__decorate([
    decorators_js.property()
], exports.PollsBubble.prototype, "pollQuestion", void 0);
__decorate([
    decorators_js.property()
], exports.PollsBubble.prototype, "pollId", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.PollsBubble.prototype, "loggedInUser", void 0);
__decorate([
    decorators_js.property()
], exports.PollsBubble.prototype, "senderUid", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.PollsBubble.prototype, "metadata", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.PollsBubble.prototype, "pollStyle", void 0);
exports.PollsBubble = __decorate([
    decorators_js.customElement('polls-bubble')
], exports.PollsBubble);

class PollsBubbleStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.votePercentTextFont = "";
        this.votePercentTextColor = "";
        this.pollQuestionTextFont = "500 12px Inter, sans-serif";
        this.pollQuestionTextColor = "#39f";
        this.pollOptionTextFont = "400 15px Inter,sans-serif";
        this.pollOptionTextColor = "#39f";
        this.pollOptionBackground = "#fff";
        this.optionsIconTint = "rgba(20, 20, 20, 0.58)";
        this.totalVoteCountTextFont = "400 13px Inter,sans-serif";
        this.totalVoteCountTextColor = "#fff";
        this.selectedPollOptionBackground = "#39f";
        this.userSelectedOptionBackground = "";
        this.pollOptionBorderRadius = "";
        this.pollOptionBorder = "";
        Object.assign(this, props);
    }
}

exports.LinkPreview = class LinkPreview extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.linkPreviewStyle = {
            height: "100%",
            width: "100%",
            border: "",
            borderRadius: "8px",
            background: "RGB(248, 248, 248)",
            titleFont: "600 15px Inter",
            titleColor: "RGB(20, 20, 20)",
            descriptionFont: "400 13px Inter",
            descriptionColor: "RGBA(20, 20, 20, 0.6)",
        };
        this.URL = "";
        this.description = "";
        this.title = "";
        this.image = "";
        this.favIconURL = "";
        this.showFavIcon = false;
        this.linkClicked = () => {
            this.dispatchEvent(new CustomEvent('cc-link-clicked', {
                bubbles: true,
                composed: true,
                detail: { url: this.URL }
            }));
            // window.open(this.URL, '_blank');
        };
        // styles
        this.linkPreviewTitleStyle = () => {
            return {
                font: this.linkPreviewStyle.titleFont,
                color: this.linkPreviewStyle.titleColor,
            };
        };
        this.detailsStyle = () => {
            return {
                justifyContent: this.title ? "flex-end" : "center"
            };
        };
        this.linkPreviewContentStyle = () => {
            return {
                height: this.image && this.image != "" ? "50%" : "100%",
                alignItems: this.title ? "initial" : "center"
            };
        };
        this.linkPreviewDescriptionStyle = () => {
            return {
                font: this.linkPreviewStyle.descriptionFont,
                color: this.linkPreviewStyle.descriptionColor,
            };
        };
        this.linkPreviewContainer = () => {
            var _a, _b, _c, _d, _e;
            return {
                width: (_a = this.linkPreviewStyle) === null || _a === void 0 ? void 0 : _a.width,
                height: (_b = this.linkPreviewStyle) === null || _b === void 0 ? void 0 : _b.height,
                border: (_c = this.linkPreviewStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.linkPreviewStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.linkPreviewStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
    }
    firstUpdated(_changedProperties) {
        try {
            const img = new Image();
            img.src = this.favIconURL;
            img.onload = () => {
                this.showFavIcon = true;
                this.requestUpdate("showFavIcon");
            };
            img.onerror = () => {
                this.showFavIcon = false;
            };
        }
        catch (error) {
        }
    }
    render() {
        return lit.html `
       <div class="cc__linkpreview" style=${styleMap_js.styleMap(this.linkPreviewContainer())}>
        ${this.image
            ? lit.html `
              <img class="cc__linkpreview-image" src="${this.image}" alt="${this.title}" />
            `
            :
                lit.nothing}
        <div class="cc__linkpreview-content" style=${styleMap_js.styleMap(this.linkPreviewContentStyle())}>
   <div class="cc__linkpreview-details" style=${styleMap_js.styleMap(this.detailsStyle())}> <div class="cc__linkpreview-title" style=${styleMap_js.styleMap(this.linkPreviewTitleStyle())}>${this.title}</div>
          <div class="cc__linkpreview-description" style=${styleMap_js.styleMap(this.linkPreviewDescriptionStyle())}>${this.description}</div>
       <div class="cc__linkpreview-childview" @click=${this.linkClicked}>
       <slot></slot>
       </div>

        </div>
          ${this.favIconURL && this.showFavIcon && !this.image
            ? lit.html `
           <div class="cc__linkpreview-favicon">
                       <img
                       class="cc__favicon"
            src="${this.favIconURL}"
            alt="icon"
          />
          </div>
            `
            :
                lit.nothing}
        </div>
      </div>
      `;
    }
};
exports.LinkPreview.styles = [
    lit.css `
.cc__linkpreview {
        display: flex;
        flex-direction: column;
        min-width: 210px;
    min-height: 60px;
    max-width: 280px;
    max-height: 260px;
    padding: 2px;
      }
      .cc__linkpreview-image {
        width: 100%;
    height: 50%;
    object-fit: cover;
      }
      .cc__linkpreview-content {
        padding: 8px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    height: 50%;
    text-align: left;
      }
      .cc__linkpreview-title {
        margin-bottom: 2px;
        width: 90%;
        white-space: break-spaces;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
        max-height: 22px;
      }
      .cc__linkpreview-description {
        white-space: break-spaces;
    /* height: 65px; */
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width:100%;
      }
      .cc__linkpreview-text {
        margin-top: auto;
      }
      .cc__linkpreview-favicon {
        margin-left: auto;
        width: 38px;
        height: 38px;
        object-fit: contain;
      }
      .cc__linkpreview-childview{
        cursor:pointer;
        margin:0 -8px;
      }
      .cc__favicon{
        height:100%;
        width:100%;
      }
      .cc__linkpreview-details{
        text-align: left;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
      }
    `
];
__decorate([
    decorators_js.property({ type: Object })
], exports.LinkPreview.prototype, "linkPreviewStyle", void 0);
__decorate([
    decorators_js.property()
], exports.LinkPreview.prototype, "URL", void 0);
__decorate([
    decorators_js.property()
], exports.LinkPreview.prototype, "description", void 0);
__decorate([
    decorators_js.property()
], exports.LinkPreview.prototype, "title", void 0);
__decorate([
    decorators_js.property()
], exports.LinkPreview.prototype, "image", void 0);
__decorate([
    decorators_js.property()
], exports.LinkPreview.prototype, "favIconURL", void 0);
exports.LinkPreview = __decorate([
    decorators_js.customElement('link-preview')
], exports.LinkPreview);

/**
 * LinkPreviewStyle class represents the styles for popover. It extends BaseStyle.
 *
 * @property {string} boxShadow - boxshadow for popover.
 *  @extends {BaseStyle}
 */
class LinkPreviewStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleFont = "600 15px Inter, sans-serif";
        this.titleColor = "rgb(20, 20, 20)";
        this.descriptionFont = "400 13px Inter, sans-serif";
        this.descriptionColor = "rgba(20, 20, 20, 0.58)";
        Object.assign(this, props);
    }
}

var addReaction = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%20Extensions%2FReactions%20Add%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24-Extensions%2FReactions-Add%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12%2C1.25%20C13.2547515%2C1.25%2014.4810955%2C1.46534515%2015.6383943%2C1.88154366%20C16.0281686%2C2.02171794%2016.2305095%2C2.45132619%2016.0903352%2C2.84110054%20C15.9501609%2C3.2308749%2015.5205527%2C3.43321574%2015.1307783%2C3.29304146%20C14.1357379%2C2.9351958%2013.0810879%2C2.75%2012%2C2.75%20C6.89136606%2C2.75%202.75%2C6.89136606%202.75%2C12%20C2.75%2C17.1086339%206.89136606%2C21.25%2012%2C21.25%20C17.1086339%2C21.25%2021.25%2C17.1086339%2021.25%2C12%20C21.25%2C11.2729266%2021.1662576%2C10.5573695%2021.0020875%2C9.8629795%20C20.906785%2C9.45987863%2021.1563049%2C9.05584287%2021.5594058%2C8.96054036%20C21.9625066%2C8.86523784%2022.3665424%2C9.11475771%2022.4618449%2C9.51785857%20C22.6527043%2C10.3251362%2022.75%2C11.1565032%2022.75%2C12%20C22.75%2C17.9370611%2017.9370611%2C22.75%2012%2C22.75%20C6.06293894%2C22.75%201.25%2C17.9370611%201.25%2C12%20C1.25%2C6.06293894%206.06293894%2C1.25%2012%2C1.25%20Z%20M17.6586667%2C13.25%20C18.1185754%2C13.25%2018.5498402%2C13.4733153%2018.8153335%2C13.8488361%20C19.0808092%2C14.2243322%2019.1475058%2C14.7053253%2018.9944111%2C15.1383417%20C17.9483179%2C18.1044405%2015.1451634%2C20.0881971%2012%2C20.0881971%20C8.85483662%2C20.0881971%206.05168206%2C18.1044405%205.00578211%2C15.1388889%20C4.85249421%2C14.7053253%204.91919084%2C14.2243322%205.18466653%2C13.8488361%20C5.45015977%2C13.4733153%205.88142461%2C13.25%206.34133333%2C13.25%20L6.34133333%2C13.25%20Z%20M17.558%2C14.695%20L17.538%2C14.749%20L6.461%2C14.749%20L6.50827179%2C14.8734156%20C7.3732069%2C17.0322917%209.42640021%2C18.4853104%2011.750045%2C18.5829516%20L11.750045%2C18.5829516%20L12%2C18.5881971%20C14.5090629%2C18.5881971%2016.7452873%2C17.0056497%2017.5800043%2C14.6388889%20L17.558%2C14.695%20Z%20M8.11422222%2C8.58288148%20C9.2798673%2C8.58288148%2010.3188817%2C9.31776232%2010.7071667%2C10.4168361%20C10.8451443%2C10.8073935%2010.6403879%2C11.2358557%2010.2498306%2C11.3738333%20C9.89181964%2C11.5003128%209.50195808%2C11.3388005%209.33318946%2C11.0101749%20L9.29283333%2C10.9164972%20C9.11634015%2C10.4169182%208.6440609%2C10.0828815%208.11422222%2C10.0828815%20C7.62853677%2C10.0828815%207.19121722%2C10.3635651%206.98575875%2C10.7951488%20L6.93561111%2C10.9164972%20C6.79763351%2C11.3070546%206.36917126%2C11.5118109%205.97861389%2C11.3738333%20C5.58805653%2C11.2358557%205.38330017%2C10.8073935%205.52127778%2C10.4168361%20C5.90956279%2C9.31776232%206.94857714%2C8.58288148%208.11422222%2C8.58288148%20Z%20M15.8857778%2C8.58288148%20C17.0514229%2C8.58288148%2018.0904372%2C9.31776232%2018.4787222%2C10.4168361%20C18.6166998%2C10.8073935%2018.4119435%2C11.2358557%2018.0213861%2C11.3738333%20C17.6633752%2C11.5003128%2017.2735136%2C11.3388005%2017.104745%2C11.0101749%20L17.0643889%2C10.9164972%20C16.8878957%2C10.4169182%2016.4156165%2C10.0828815%2015.8857778%2C10.0828815%20C15.4000923%2C10.0828815%2014.9627728%2C10.3635651%2014.7573143%2C10.7951488%20L14.7071667%2C10.9164972%20C14.5691891%2C11.3070546%2014.1407268%2C11.5118109%2013.7501694%2C11.3738333%20C13.3596121%2C11.2358557%2013.1548557%2C10.8073935%2013.2928333%2C10.4168361%20C13.6811183%2C9.31776232%2014.7201327%2C8.58288148%2015.8857778%2C8.58288148%20Z%20M19.5%2C0.25%20C19.8796958%2C0.25%2020.193491%2C0.532153882%2020.2431534%2C0.898229443%20L20.25%2C1%20L20.25%2C4.25%20L23%2C4.25%20C23.4142136%2C4.25%2023.75%2C4.58578644%2023.75%2C5%20C23.75%2C5.37969577%2023.4678461%2C5.69349096%2023.1017706%2C5.74315338%20L23%2C5.75%20L20.25%2C5.75%20L20.25%2C9%20C20.25%2C9.41421356%2019.9142136%2C9.75%2019.5%2C9.75%20C19.1203042%2C9.75%2018.806509%2C9.46784612%2018.7568466%2C9.10177056%20L18.75%2C9%20L18.75%2C5.75%20L16%2C5.75%20C15.5857864%2C5.75%2015.25%2C5.41421356%2015.25%2C5%20C15.25%2C4.62030423%2015.5321539%2C4.30650904%2015.8982294%2C4.25684662%20L16%2C4.25%20L18.75%2C4.25%20L18.75%2C1%20C18.75%2C0.585786438%2019.0857864%2C0.25%2019.5%2C0.25%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

const ReactionsConstants = Object.freeze({
    reactions: "reactions",
    post: "POST",
    v1: "v1/react",
    metadata: "metadata",
    injected: "@injected",
    extensions: "extensions"
});

// change folder structure
class CometChatUIKitUtility {
    /**
   * Creates a deep copy of the value provided
   *
   * @remarks
   * This function cannot copy truly private properties (those that start with a "#" symbol inside a class block).
   * Functions are copied by reference and additional properties on the array objects are ignored
   *
   * @param arg - Any value
   * @returns A deep copy of `arg`
   */
    static clone(arg) {
        /*
            If there are additional properties attached to a function or an array object other than the standard properties,
                those properties will be ignored
            Cannot copy private properties (those that start with a "#" symbol inside a class block)
            Functions are copied by reference
        */
        if (typeof arg !== "object" || !arg) {
            return arg;
        }
        let res;
        if (Array.isArray(arg)) {
            // arg is an array, there's no hatch to fool the Array.isArray method, so lets create an array
            res = [];
            for (const value of arg) {
                res.push(CometChatUIKitUtility.clone(value));
            }
            return res;
        }
        else {
            // arg is an object
            res = {};
            const descriptor = Object.getOwnPropertyDescriptors(arg);
            for (const k of Reflect.ownKeys(descriptor)) {
                const curDescriptor = descriptor[k];
                if (curDescriptor.hasOwnProperty("value")) {
                    // Property is a data property
                    Object.defineProperty(res, k, {
                        ...curDescriptor,
                        value: CometChatUIKitUtility.clone(curDescriptor["value"])
                    });
                }
                else {
                    // Property is an accessor property
                    Object.defineProperty(res, k, curDescriptor);
                }
            }
            Object.setPrototypeOf(res, Object.getPrototypeOf(arg));
        }
        return res;
    }
    static getExtensionData(messageObject) {
        var _a;
        let messageText;
        //xss extensions data
        const xssData = CometChatUIKitUtility.checkMessageForExtensionsData(messageObject, "xss-filter");
        if (xssData && CometChatUIKitUtility.checkHasOwnProperty(xssData, "sanitized_text") && CometChatUIKitUtility.checkHasOwnProperty(xssData, "hasXSS") && xssData.hasXSS === "yes") {
            messageText = xssData === null || xssData === void 0 ? void 0 : xssData.sanitized_text;
        }
        //datamasking extensions data
        const maskedData = CometChatUIKitUtility.checkMessageForExtensionsData(messageObject, "data-masking");
        if (maskedData && CometChatUIKitUtility.checkHasOwnProperty(maskedData, "data") && CometChatUIKitUtility.checkHasOwnProperty(maskedData.data, "sensitive_data") && CometChatUIKitUtility.checkHasOwnProperty(maskedData.data, "message_masked") && maskedData.data.sensitive_data === "yes") {
            messageText = (_a = maskedData === null || maskedData === void 0 ? void 0 : maskedData.data) === null || _a === void 0 ? void 0 : _a.message_masked;
        }
        //profanity extensions data
        const profaneData = CometChatUIKitUtility.checkMessageForExtensionsData(messageObject, "profanity-filter");
        if (profaneData && CometChatUIKitUtility.checkHasOwnProperty(profaneData, "profanity") && CometChatUIKitUtility.checkHasOwnProperty(profaneData, "message_clean") && profaneData.profanity === "yes") {
            messageText = profaneData === null || profaneData === void 0 ? void 0 : profaneData.message_clean;
        }
        return messageText || messageObject.text;
    }
}
CometChatUIKitUtility.checkHasOwnProperty = (obj = {}, key) => {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
CometChatUIKitUtility.ID = () => {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return '_' + Math.random().toString(36).substr(2, 9);
};
CometChatUIKitUtility.getUnixTimestamp = () => {
    return Math.round(+new Date() / 1000);
};
CometChatUIKitUtility.checkMessageForExtensionsData = (message, extensionKey) => {
    try {
        let output = [];
        if (message.hasOwnProperty("metadata")) {
            const metadata = message["metadata"];
            const injectedObject = metadata["@injected"];
            if (injectedObject && injectedObject.hasOwnProperty("extensions")) {
                const extensionsObject = injectedObject["extensions"];
                if (extensionsObject && extensionsObject.hasOwnProperty(extensionKey)) {
                    output = extensionsObject[extensionKey];
                }
            }
        }
        return output;
    }
    catch (error) {
    }
};

const ReactionNameStyle = (reactionStyle) => {
    return {
        fontSize: reactionStyle.reactionEmojiFontSize
    };
};
const ReactionCountStyle = (showOutline, reactionsStyle) => {
    let fontStyle = {};
    if (showOutline) {
        fontStyle = {
            color: reactionsStyle === null || reactionsStyle === void 0 ? void 0 : reactionsStyle.activeReactionCountTextColor,
            font: reactionsStyle === null || reactionsStyle === void 0 ? void 0 : reactionsStyle.activeReactionCountTextFont,
        };
    }
    else {
        fontStyle = {
            color: reactionsStyle === null || reactionsStyle === void 0 ? void 0 : reactionsStyle.reactionCountTextColor,
            font: reactionsStyle === null || reactionsStyle === void 0 ? void 0 : reactionsStyle.reactionCountTextFont,
        };
    }
    return {
        ...fontStyle,
    };
};
const addReactionButtonStyle = (reactionsStyle) => {
    return {
        height: "22px",
        width: "30px",
        borderRadius: "12px",
        border: "none",
        background: reactionsStyle === null || reactionsStyle === void 0 ? void 0 : reactionsStyle.addReactionIconBackground,
        buttonIconTint: reactionsStyle === null || reactionsStyle === void 0 ? void 0 : reactionsStyle.addReactionIconTint,
        iconHeight: "16px",
        iconWidth: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    };
};
const highlightBackground = (showOutline, count, reactionsStyle) => {
    let style = {};
    if (showOutline) {
        style = {
            background: reactionsStyle === null || reactionsStyle === void 0 ? void 0 : reactionsStyle.activeReactionBackground,
            border: reactionsStyle === null || reactionsStyle === void 0 ? void 0 : reactionsStyle.activeReactionBorder
        };
    }
    else {
        style = {
            background: reactionsStyle === null || reactionsStyle === void 0 ? void 0 : reactionsStyle.reactionBackground,
            border: reactionsStyle === null || reactionsStyle === void 0 ? void 0 : reactionsStyle.reactionBorder
        };
    }
    return {
        ...style,
        display: count ? "inline-flex" : "none",
        borderRadius: reactionsStyle === null || reactionsStyle === void 0 ? void 0 : reactionsStyle.reactionBorderRadius,
        padding: "1px 4px",
        width: "fit-content",
        height: "fit-content",
    };
};

exports.ReactionsView = class ReactionsView extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.reactionsStyle = {
            height: "100%",
            width: "100%",
            border: "",
            borderRadius: "",
            background: "",
            addReactionIconTint: "rgba(20, 20, 20, 0.69)",
            addReactionIconBackground: "rgba(20, 20, 20, 0.08)",
            reactionBorderRadius: "11px",
            reactionBorder: "1px solid rgba(20, 20, 20, 0.08)",
            reactionBackground: "transparent",
            activeReactionBorder: "1px solid rgb(255, 255, 255)",
            activeReactionBackground: "rgb(255, 255, 255)",
            reactionEmojiFontSize: "12px",
            reactionCountTextFont: "500 12px Inter, sans-serif",
            reactionCountTextColor: "rgba(20, 20, 20, 0.69)",
            activeReactionCountTextFont: "500 12px Inter, sans-serif",
            activeReactionCountTextColor: "rgb(51, 153, 255)"
        };
        this.alignment = uikitResources.MessageBubbleAlignment.right;
        this.addReactionIconURL = addReaction;
        this.messageReactions = [];
        this.addNewReaction = (event) => {
            var _a, _b;
            if (this.childElement) {
                (_a = this.childElement) === null || _a === void 0 ? void 0 : _a.openContentView(event);
            }
            this.reactToMessages((_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.id);
        };
    }
    checkReaction() {
        try {
            this.extensionData = CometChatUIKitUtility.checkMessageForExtensionsData(this.messageObject, ReactionsConstants.reactions);
            if (this.extensionData) {
                this.getMessageReactions(this.extensionData);
            }
        }
        catch (error) {
            console.log(error);
        }
    }
    render() {
        var _a, _b, _c;
        this.checkReaction();
        return lit.html `
      <div class="cc-reactions">
        ${((_a = this.messageReactions) === null || _a === void 0 ? void 0 : _a.length) > 0 && this.alignment == uikitResources.MessageBubbleAlignment.right
            ? lit.html `<cometchat-popover .placement=${uikitResources.Placement.left}>
<cometchat-emoji-keyboard @cc-emoji-clicked = ${this.addNewReaction} slot="content"></cometchat-emoji-keyboard>
<cometchat-button slot="children" class="cc-reactions__add-reaction" .buttonStyle="${addReactionButtonStyle(this.reactionsStyle)}" .iconURL="${this.addReactionIconURL}"></cometchat-button>
</cometchat-popover>`
            : ''}
        ${(_b = this.messageReactions) === null || _b === void 0 ? void 0 : _b.map((reaction) => lit.html `
            <button @click=${() => { this.reactToMessages(reaction === null || reaction === void 0 ? void 0 : reaction.reactionName); }} class="cc-reactions__button"  style="${styleMap_js.styleMap(highlightBackground(reaction === null || reaction === void 0 ? void 0 : reaction.showBlueOutline, reaction === null || reaction === void 0 ? void 0 : reaction.reactionCount, this.reactionsStyle))}">
            <span class="cc-reactions__name" style="${styleMap_js.styleMap(ReactionNameStyle(this.reactionsStyle))}">${reaction === null || reaction === void 0 ? void 0 : reaction.reactionName}</span>
            <span class="cc-reactions__count" style="${styleMap_js.styleMap(ReactionCountStyle(reaction === null || reaction === void 0 ? void 0 : reaction.showBlueOutline, this.reactionsStyle))}">${reaction === null || reaction === void 0 ? void 0 : reaction.reactionCount}</span>
            </button>
        `)}
        ${((_c = this.messageReactions) === null || _c === void 0 ? void 0 : _c.length) > 0 && this.alignment == uikitResources.MessageBubbleAlignment.left
            ? lit.html `
          <cometchat-popover .placement=${uikitResources.Placement.right}>
            <cometchat-emoji-keyboard slot="content" @cc-emoji-clicked=${this.addNewReaction}></cometchat-emoji-keyboard>
            <cometchat-button slot="children" class="cc-reactions__add-reaction" .buttonStyle="${addReactionButtonStyle(this.reactionsStyle)}" .iconURL="${this.addReactionIconURL}"></cometchat-button>
          </cometchat-popover>`
            : ''}
      </div>
    `;
    }
    getMessageReactions(reaction) {
        if (reaction === null) {
            return null;
        }
        let messageReactions = [];
        Object.keys(reaction).map((data, key) => {
            const reactionData = reaction[data];
            const reactionCount = Object.keys(reactionData).length;
            let showBlueOutline = false;
            if (reactionData.hasOwnProperty(this.loggedInUser.getUid())) {
                showBlueOutline = true;
            }
            const reactionName = data;
            let messageReaction;
            const userList = [];
            let reactionTitle = "";
            for (const user in reactionData) {
                userList.push(reactionData[user]["name"]);
            }
            if (userList.length) {
                reactionTitle = userList.join(", ");
                reactionTitle = reactionTitle.concat(` ${"reacted"}`);
            }
            if (reactionCount) {
                messageReaction = {
                    reactionName,
                    reactionCount,
                    reactionTitle,
                    showBlueOutline,
                };
            }
            else {
                messageReaction = { reactionName, reactionTitle, showBlueOutline };
            }
            messageReactions.push(messageReaction);
        });
        this.messageReactions = messageReactions;
        this.requestUpdate("messageReactions");
        return;
    }
    reactToMessages(emoji) {
        var _a, _b, _c, _d, _e, _f;
        let removeEmoji = false;
        let reactionObject = {};
        let msgObject = this.messageObject;
        const userObject = {};
        if ((_a = this.loggedInUser) === null || _a === void 0 ? void 0 : _a.getAvatar()) {
            userObject["avatar"] = (_b = this.loggedInUser) === null || _b === void 0 ? void 0 : _b.getAvatar();
        }
        if ((_c = this.loggedInUser) === null || _c === void 0 ? void 0 : _c.getName()) {
            userObject["name"] = (_d = this.loggedInUser) === null || _d === void 0 ? void 0 : _d.getName();
        }
        let uid = (_e = this.loggedInUser) === null || _e === void 0 ? void 0 : _e.getUid();
        const emojiObject = {
            [emoji]: {
                [uid]: userObject,
            },
        };
        const reactionExtensionsData = CometChatUIKitUtility.checkMessageForExtensionsData(this.messageObject, ReactionsConstants.reactions);
        if (reactionExtensionsData) {
            if (reactionExtensionsData[emoji]) {
                //if the reactions metadata has the selected emoji/reaction for the loggedin user
                if (reactionExtensionsData[emoji][uid]) {
                    delete reactionExtensionsData[emoji];
                    removeEmoji = true;
                }
                else {
                    let data = msgObject[ReactionsConstants.metadata][ReactionsConstants.injected][ReactionsConstants.extensions][ReactionsConstants.reactions];
                    data[emoji][uid] = userObject;
                    reactionObject = {
                        ...data,
                    };
                }
            }
            else {
                if (!msgObject.hasOwnProperty(ReactionsConstants.metadata)) {
                    msgObject[ReactionsConstants.metadata] = {};
                }
                if (!msgObject[ReactionsConstants.metadata].hasOwnProperty(ReactionsConstants.injected)) {
                    msgObject[ReactionsConstants.metadata][ReactionsConstants.injected] = {};
                }
                if (!msgObject[ReactionsConstants.metadata][ReactionsConstants.injected].hasOwnProperty(ReactionsConstants.extensions)) {
                    msgObject[ReactionsConstants.metadata][ReactionsConstants.injected][ReactionsConstants.extensions] = {};
                }
                if (!msgObject[ReactionsConstants.metadata][ReactionsConstants.injected][ReactionsConstants.extensions].hasOwnProperty(ReactionsConstants.reactions)) {
                    msgObject[ReactionsConstants.metadata][ReactionsConstants.injected][ReactionsConstants.extensions][ReactionsConstants.reactions] = {};
                }
                let data = msgObject[ReactionsConstants.metadata][ReactionsConstants.injected][ReactionsConstants.extensions][ReactionsConstants.reactions];
                reactionObject = { ...data, ...emojiObject };
            }
        }
        else {
            if (!msgObject.hasOwnProperty(ReactionsConstants.metadata)) {
                msgObject[ReactionsConstants.metadata] = {};
            }
            if (!msgObject[ReactionsConstants.metadata].hasOwnProperty(ReactionsConstants.injected)) {
                msgObject[ReactionsConstants.metadata][ReactionsConstants.injected] = {};
            }
            if (!msgObject[ReactionsConstants.metadata][ReactionsConstants.injected].hasOwnProperty(ReactionsConstants.extensions)) {
                msgObject[ReactionsConstants.metadata][ReactionsConstants.injected][ReactionsConstants.extensions] = {};
            }
            if (!msgObject[ReactionsConstants.metadata][ReactionsConstants.injected][ReactionsConstants.extensions].hasOwnProperty(ReactionsConstants.reactions)) {
                msgObject[ReactionsConstants.metadata][ReactionsConstants.injected][ReactionsConstants.extensions][ReactionsConstants.reactions] = {};
            }
            reactionObject = {
                ...emojiObject,
            };
        }
        var metadataObject;
        if (removeEmoji) {
            metadataObject = {
                ...msgObject[ReactionsConstants.metadata],
            };
        }
        else {
            metadataObject = {
                ...msgObject[ReactionsConstants.metadata],
                [ReactionsConstants.injected]: {
                    ...msgObject[ReactionsConstants.metadata][ReactionsConstants.injected],
                    extensions: {
                        ...msgObject[ReactionsConstants.metadata][ReactionsConstants.injected][ReactionsConstants.extensions],
                        reactions: {
                            ...reactionObject,
                        },
                    },
                },
            };
        }
        this.messageObject.metadata = metadataObject;
        this.requestUpdate("messageObject");
        try {
            chatSdkJavascript.CometChat.callExtension(ReactionsConstants.reactions, ReactionsConstants.post, ReactionsConstants.v1, {
                msgId: (_f = this.messageObject) === null || _f === void 0 ? void 0 : _f.getId(),
                emoji: emoji,
            })
                .then((response) => {
            })
                .catch((error) => {
                console.log(error);
            });
        }
        catch (error) {
            console.log(error);
        }
    }
};
exports.ReactionsView.styles = [
    lit.css `
    *{
      box-sizing:border-box;
    }
    .cc-reactions__add-reaction {
      outline: 0;
      border: 0;
      border-radius: 10px;
      align-items: center;
      display: inline-flex;
      justify-content: center;
      position: relative;
      cursor: pointer;
    }
    .cc-reactions {
      display: flex;
      flex-flow: wrap;
      padding: 4px 8px;
      gap:6px;
    }
    .cc-reactions__button{
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 12px;
      cursor: pointer;
      gap:6px
    }
    `
];
__decorate([
    decorators_js.query('cometchat-popover')
], exports.ReactionsView.prototype, "childElement", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.ReactionsView.prototype, "messageObject", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.ReactionsView.prototype, "loggedInUser", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.ReactionsView.prototype, "reactionsStyle", void 0);
__decorate([
    decorators_js.property({ type: Number })
], exports.ReactionsView.prototype, "alignment", void 0);
__decorate([
    decorators_js.property({ type: String })
], exports.ReactionsView.prototype, "addReactionIconURL", void 0);
exports.ReactionsView = __decorate([
    decorators_js.customElement('reactions-view')
], exports.ReactionsView);

class ReactionsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.addReactionIconTint = "grey";
        this.addReactionIconBackground = "";
        this.reactionBorderRadius = "12px";
        this.reactionBorder = "1px solid lightgrey";
        this.reactionBackground = "transparent";
        this.activeReactionBorder = "1px solid lightgrey";
        this.activeReactionBackground = "white";
        this.reactionEmojiFontSize = "12px";
        this.reactionCountTextFont = "500 12px Inter, sans-serif";
        this.reactionCountTextColor = "";
        this.activeReactionCountTextFont = "";
        this.activeReactionCountTextColor = "";
        Object.assign(this, props);
    }
}

var UnsafeIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2238px%22%20height%3D%2248px%22%20viewBox%3D%220%200%2038%2048%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EGroup%3C%2Ftitle%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cfilter%20id%3D%22filter-1%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3CfeColorMatrix%20in%3D%22SourceGraphic%22%20type%3D%22matrix%22%20values%3D%220%200%200%200%201.000000%200%200%200%200%201.000000%200%200%200%200%201.000000%200%200%200%200.710000%200%22%3E%3C%2FfeColorMatrix%3E%20%20%20%20%20%20%20%20%3C%2Ffilter%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Symbols-v2%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Chat-View%2FMessage-Received-%26amp%3B-Sent%2FImage-Unsafe%22%20transform%3D%22translate%28-94.000000%2C%20-67.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Container%22%20transform%3D%22translate%280.000000%2C%2022.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%2865.500000%2C%2047.000000%29%22%20id%3D%22Group%22%20filter%3D%22url%28%23filter-1%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%2830.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M28.8088262%2C9.42577596%20C28.8506963%2C7.71756102%2030.2287536%2C6.35502688%2031.9140264%2C6.35555433%20L31.9140264%2C6.35555433%20C32.7358141%2C6.35553806%2033.5236653%2C6.6878709%2034.102944%2C7.27888759%20C34.6822226%2C7.86990427%2035.0050758%2C8.67078232%2035%2C9.50399817%20L35%2C33.2639936%20C35.0072404%2C36.1086013%2033.896766%2C38.8390036%2031.9140264%2C40.8515477%20L31.9140264%2C40.8515477%20C29.9286819%2C42.8636021%2027.2377305%2C43.9957583%2024.4306868%2C44%20L18.393869%2C44%20C14.2477742%2C44.0048704%2010.374426%2C41.9054223%208.07534666%2C38.4071037%20L0.534146186%2C26.9279948%20C-0.178048729%2C25.8443886%20-0.178048729%2C24.432935%200.534146186%2C23.3493288%20L0.534146186%2C23.3493288%20C1.0299224%2C22.6000068%201.81249566%2C22.0953997%202.69202609%2C21.9579171%20C3.57155651%2C21.8204345%204.46768176%2C22.0626382%205.16301604%2C22.6257734%20L10.216199%2C26.7128837%20L10.216199%2C6.35555433%20C10.216199%2C4.62751705%2011.5978094%2C3.22666604%2013.3021122%2C3.22666604%20L13.3021122%2C3.22666604%20C15.009563%2C3.22663265%2016.3967071%2C4.62435858%2016.4073124%2C6.35555433%20L16.4073124%2C3.14844384%20C16.4067922%2C1.43970153%2017.750612%2C0.0424531456%2019.4353648%2C0%20L19.4353648%2C0%20C21.1503195%2C0%2022.540565%2C1.40960632%2022.540565%2C3.14844384%20L22.540565%2C6.35555433%20C22.540565%2C4.62751705%2023.9221754%2C3.22666604%2025.6264782%2C3.22666604%20L25.6264782%2C3.22666604%20C26.4599777%2C3.20564838%2027.2667977%2C3.525368%2027.8653523%2C4.11386759%20C28.4639069%2C4.70236719%2028.8039053%2C5.51020079%2028.8088262%2C6.35555433%20L28.8088262%2C9.42577596%20Z%22%20id%3D%22Path%22%20stroke%3D%22%23000000%22%20stroke-width%3D%223%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2216.4073124%22%20y1%3D%226.27733212%22%20x2%3D%2216.4073124%22%20y2%3D%2218.8515519%22%20id%3D%22Path%22%20stroke%3D%22%23000000%22%20stroke-width%3D%223%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2222.6177128%22%20y1%3D%226.27733212%22%20x2%3D%2222.6177128%22%20y2%3D%2218.8515519%22%20id%3D%22Path%22%20stroke%3D%22%23000000%22%20stroke-width%3D%223%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2228.8088262%22%20y1%3D%2218.8515519%22%20x2%3D%2228.8088262%22%20y2%3D%229.42577596%22%20id%3D%22Path%22%20stroke%3D%22%23000000%22%20stroke-width%3D%223%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

const ImageModerationConstants = Object.freeze({
    metadata: "metadata",
    injected: "@injected",
    image_moderation: "image-moderation"
});

exports.ImageModeration = class ImageModeration extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.imageModerationStyle = {
            height: "100%",
            width: "100%",
            border: "",
            borderRadius: "",
            background: "",
            warningTextFont: "",
            warningTextColor: "",
            filterColor: ""
        };
        this.warningText = "Unsafe Content";
        this.unsafeIconURL = UnsafeIcon;
        this.isUnsafe = false;
        this.removeWarning = () => {
            this.isUnsafe = false;
            this.requestUpdate("isUnsafe");
        };
        this.imageBubbleStyle = () => {
            var _a, _b, _c, _d, _e;
            return {
                height: (_a = this.imageModerationStyle) === null || _a === void 0 ? void 0 : _a.height,
                width: (_b = this.imageModerationStyle) === null || _b === void 0 ? void 0 : _b.width,
                border: (_c = this.imageModerationStyle) === null || _c === void 0 ? void 0 : _c.border,
                borderRadius: (_d = this.imageModerationStyle) === null || _d === void 0 ? void 0 : _d.borderRadius,
                background: (_e = this.imageModerationStyle) === null || _e === void 0 ? void 0 : _e.background,
            };
        };
    }
    updated(changedProperties) {
        if (changedProperties.has('message')) {
            this.isUnsafeContent();
        }
    }
    setFilterStyle() {
        var _a, _b, _c;
        const imageModerationEl = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".cc__imagemoderation");
        if (imageModerationEl instanceof Element) {
            const beforeElement = window.getComputedStyle(imageModerationEl, '::before');
            beforeElement === null || beforeElement === void 0 ? void 0 : beforeElement.setProperty('background-color', (_c = (_b = this.imageModerationStyle) === null || _b === void 0 ? void 0 : _b.filterColor) !== null && _c !== void 0 ? _c : "RGBA(20, 20, 20, 0.68)");
            // use the computed style of the ::before pseudo-element here
        }
    }
    isUnsafeContent() {
        var _a, _b, _c, _d;
        var data = (_a = this.message) === null || _a === void 0 ? void 0 : _a.getData();
        if (((_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.metadata) === null || _b === void 0 ? void 0 : _b[ImageModerationConstants.injected]) === null || _c === void 0 ? void 0 : _c.extensions) === null || _d === void 0 ? void 0 : _d[ImageModerationConstants.image_moderation]) &&
            data.metadata[ImageModerationConstants.injected].extensions[ImageModerationConstants.image_moderation].unsafe == 'yes' &&
            Number(data.metadata[ImageModerationConstants.injected].extensions[ImageModerationConstants.image_moderation].confidence) > 50) {
            this.isUnsafe = true;
            this.requestUpdate("isUnsafe");
            this.setFilterStyle();
        }
        else {
            this.isUnsafe = false;
            this.requestUpdate("isUnsafe");
        }
    }
    _handleWarningClick() {
        this.dispatchEvent(new CustomEvent('cc-show-dialog', {
            bubbles: true,
            composed: true,
            detail: {
                message: this.message,
                onConfirm: this.removeWarning
            }
        }));
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        if (this.isUnsafe) {
            this.setFilterStyle();
        }
    }
    render() {
        if (this.isUnsafe) {
            return lit.html `
        <div class="cc__imagemoderation" style=${styleMap_js.styleMap(this.imageBubbleStyle())}>
          <slot></slot>
          <div class="cc__imagemoderation__warning" @click="${this._handleWarningClick}">
          <img src=${this.unsafeIconURL} style=${styleMap_js.styleMap(this.warningTextStyle())} />
           <div style=${styleMap_js.styleMap(this.warningTextStyle())}>${this.warningText}</div>
        </div>
        </div>
      `;
        }
        else {
            return lit.html `<slot></slot>`;
        }
    }
    warningTextStyle() {
        var _a, _b;
        return {
            font: (_a = this.imageModerationStyle) === null || _a === void 0 ? void 0 : _a.warningTextFont,
            color: (_b = this.imageModerationStyle) === null || _b === void 0 ? void 0 : _b.warningTextColor
        };
    }
};
exports.ImageModeration.styles = [
    lit.css `
.childview{
    height: 100%;
        width: 100%;
}
.cc__imagemoderation {
        position: relative;
        overflow: hidden;
        height: 100%;
        width: 100%;
      }
      .cc__imagemoderation::before {
        content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      backdrop-filter: blur(10px);
      background-color: RGBA(20, 20, 20, 0.68);
      z-index: 1;
      }
      .cc__imagemoderation__warning {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 24px;
        font-weight: bold;
        color: white;
        z-index: 1;
        cursor: pointer;
        display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
      }
    `
];
__decorate([
    decorators_js.property({ type: Object })
], exports.ImageModeration.prototype, "message", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.ImageModeration.prototype, "imageModerationStyle", void 0);
__decorate([
    decorators_js.property()
], exports.ImageModeration.prototype, "warningText", void 0);
__decorate([
    decorators_js.property()
], exports.ImageModeration.prototype, "unsafeIconURL", void 0);
exports.ImageModeration = __decorate([
    decorators_js.customElement('image-moderation')
], exports.ImageModeration);

class ImageModerationConfiguration {
    constructor(props) {
        this.imageModerationStyle = {};
        this.unsafeIconURL = UnsafeIcon;
        Object.assign(this, props);
    }
}

class ImageModerationStyle extends BaseStyle {
    constructor() {
        super(...arguments);
        this.warningTextFont = "500 15px Inter";
        this.warningTextColor = "white";
        this.filterColor = "";
    }
}

const ThumbnailGenerationConstants = Object.freeze({
    metadata: "metadata",
    injected: "@injected",
    extensions: "extensions",
    thumbnail_generation: "thumbnail-generation"
});

const LinkPreviewConstants = Object.freeze({
    metadata: "metadata",
    injected: "@injected",
    extensions: "extensions",
    link_preview: "link-preview",
    links: "links"
});

class CometChatUIKitHelper {
    //---------- Message Events ----------
    ///[onMessageSent] is used to inform the listeners
    ///when the logged-in user is sending a message
    static onMessageSent(message, status) {
        uikitResources.CometChatMessageEvents.ccMessageSent.next({ message, status });
    }
    ///[onMessageEdited] is used to inform the listeners
    ///when the logged-in user is editing a message
    static onMessageEdited(message, status) {
        uikitResources.CometChatMessageEvents.ccMessageEdited.next({ message, status });
    }
    ///[onMessageDeleted] is used to inform the listeners
    ///when the logged-in user has deleted a message
    static onMessageDeleted(message) {
        uikitResources.CometChatMessageEvents.ccMessageDeleted.next(message);
    }
    ///[onMessageRead] is used to inform the listeners
    ///when the logged-in user has read a message
    static onMessageRead(message) {
        uikitResources.CometChatMessageEvents.ccMessageRead.next(message);
    }
    ///[onLiveReaction] is used to inform the listeners
    ///when the logged-in user sends a transient message (live reaction)
    static onLiveReaction(reaction) {
        uikitResources.CometChatMessageEvents.ccLiveReaction.next(reaction);
    }
    //---------- User Events ----------
    ///[onUserBlocked] is used to inform the listeners
    ///when the logged-in user blocks another user
    static onUserBlocked(user) {
        uikitResources.CometChatUserEvents.ccUserBlocked.next(user);
    }
    ///[onUserUnblocked] is used to inform the listeners
    ///when the logged-in user unblocks a blocked user
    static onUserUnblocked(user) {
        uikitResources.CometChatUserEvents.ccUserUnblocked.next(user);
    }
    //---------- Group Events ----------
    ///[onGroupCreated] is used to inform the listeners
    ///when the logged-in user creates a Group
    static onGroupCreated(group) {
        uikitResources.CometChatGroupEvents.ccGroupCreated.next(group);
    }
    ///[onGroupDeleted] is used to inform the listeners
    ///when the logged-in user deletes a Group
    static onGroupDeleted(group) {
        uikitResources.CometChatGroupEvents.ccGroupDeleted.next(group);
    }
    ///[onGroupLeft] is used to inform the listeners
    ///when the logged-in user leaves a Group
    static onGroupLeft(message, leftUser, leftGroup) {
        uikitResources.CometChatGroupEvents.ccGroupLeft.next({
            message: message,
            userLeft: leftUser,
            leftGroup: leftGroup
        });
    }
    ///[onGroupMemberScopeChanged] is used to inform the listeners
    ///when the logged-in user changes the scope of a group member
    ///in a group
    static onGroupMemberScopeChanged(message, updatedUser, scopeChangedTo, scopeChangedFrom, group) {
        uikitResources.CometChatGroupEvents.ccGroupMemberScopeChanged.next({
            message,
            updatedUser,
            scopeChangedTo,
            scopeChangedFrom,
            group
        });
    }
    /**
    * [onGroupMemberBanned] is used to inform the listeners
    * when the logged-in user bans a group member
    */
    static onGroupMemberBanned(message, bannedUser, bannedBy, bannedFrom) {
        uikitResources.CometChatGroupEvents.ccGroupMemberBanned.next({
            message,
            kickedUser: bannedUser,
            kickedBy: bannedBy,
            kickedFrom: bannedFrom,
        });
    }
    /**
     * [onGroupMemberKicked] is used to inform the listeners
     * when the logged-in user kicks a group member from a group
     */
    static onGroupMemberKicked(message, kickedUser, kickedBy, kickedFrom) {
        uikitResources.CometChatGroupEvents.ccGroupMemberKicked.next({
            message,
            kickedUser: kickedUser,
            kickedBy: kickedBy,
            kickedFrom: kickedFrom,
        });
    }
    /**
     * [onGroupMemberUnbanned] is used to inform the listeners
     * when the logged-in user unbans a banned user of a group
     */
    static onGroupMemberUnbanned(message, unbannedUser, unbannedBy, unbannedFrom) {
        uikitResources.CometChatGroupEvents.ccGroupMemberUnbanned.next({
            message,
            unbannedBy: unbannedBy,
            unbannedFrom: unbannedFrom,
            unbannedUser: unbannedUser
        });
    }
    /**
     * [onGroupMemberJoined] is used to inform the listeners
     * when the logged-in user joins a group
     */
    static onGroupMemberJoined(joinedUser, joinedGroup) {
        uikitResources.CometChatGroupEvents.ccGroupMemberJoined.next({
            joinedUser, joinedGroup
        });
    }
    /**
     * [onGroupMemberAdded] is used to inform the listeners
     * when the logged-in user adds users to a group
     */
    static onGroupMemberAdded(messages, usersAdded, groupAddedIn, addedBy) {
        uikitResources.CometChatGroupEvents.ccGroupMemberAdded.next({
            messages: messages,
            userAddedBy: addedBy,
            usersAdded: usersAdded,
            userAddedIn: groupAddedIn
        });
    }
    /**
     * [onOwnershipChanged] is used to inform the listeners
     * when the logged-in user transfers their ownership to some other group member
     */
    static onOwnershipChanged(group, newOwner) {
        uikitResources.CometChatGroupEvents.ccOwnershipChanged.next({
            newOwner: newOwner,
            group: group,
        });
    }
    /**
     * [onConversationDeleted] is used to inform the listeners
     * when the logged-in user deletes a conversation
     */
    static onConversationDeleted(conversation) {
        uikitResources.CometChatConversationEvents.ccConversationDeleted.next(conversation);
    }
    //---------- CometChat UI Events ----------
    /**
     * [showPanel] used to reveal a panel above message composer
     */
    static showPanel(child) {
        uikitResources.CometChatUIEvents.ccShowPanel.next({
            child: child
        });
    }
    /**
     * [hidePanel] used to hide the panel above message composer
     */
    static hidePanel() {
        uikitResources.CometChatUIEvents.ccHidePanel.next();
    }
    static onActiveChatChanged(user, group, message) {
        uikitResources.CometChatUIEvents.ccActiveChatChanged.next({ user, group, message });
    }
}

class UIKitSettings {
    constructor(builder) {
        var _a;
        this.appId = builder.appId;
        this.region = builder.region;
        this.subscriptionType = builder.subscriptionType;
        this.autoEstablishSocketConnection = (_a = builder.autoEstablishSocketConnection) !== null && _a !== void 0 ? _a : true;
        this.authKey = builder.authKey;
        this.deviceToken = builder.deviceToken;
        this.googleApiKey = builder.googleApiKey;
        this.disableCalling = builder.disableCalling;
        this.adminHost = builder.adminHost;
        this.clientHost = builder.clientHost;
        this.extensions = builder.extensions;
        this.aiFeatures = builder.aiFeatures;
    }
    static fromBuilder(builder) {
        return new UIKitSettings(builder);
    }
    getAppId() {
        return this.appId;
    }
    getRegion() {
        return this.region;
    }
    getRoles() {
        return this.roles;
    }
    getSubscriptionType() {
        return this.subscriptionType;
    }
    getAuthKey() {
        return this.authKey;
    }
    isAutoEstablishSocketConnection() {
        return this.autoEstablishSocketConnection;
    }
    getAdminHost() {
        return this.adminHost;
    }
    getClientHost() {
        return this.clientHost;
    }
    getExtensions() {
        return this.extensions;
    }
    getAiFeatures() {
        return this.aiFeatures;
    }
}
class UIKitSettingsBuilder {
    constructor() {
        this.disableCalling = false;
    }
    build() {
        return UIKitSettings.fromBuilder(this);
    }
    setAppId(appId) {
        this.appId = appId;
        return this;
    }
    setRegion(region) {
        this.region = region;
        return this;
    }
    subscribePresenceForAllUsers() {
        this.subscriptionType = 'ALL_USERS';
        return this;
    }
    subscribePresenceForRoles(roles) {
        this.subscriptionType = 'ROLES';
        this.roles = roles;
        return this;
    }
    subscribePresenceForFriends() {
        this.subscriptionType = 'FRIENDS';
        return this;
    }
    setRoles(roles) {
        this.roles = roles;
        return this;
    }
    setAutoEstablishSocketConnection(autoEstablishSocketConnection) {
        this.autoEstablishSocketConnection = autoEstablishSocketConnection;
        return this;
    }
    setAuthKey(authKey) {
        this.authKey = authKey;
        return this;
    }
    setAdminHost(adminHost) {
        this.adminHost = adminHost;
        return this;
    }
    setClientHost(clientHost) {
        this.clientHost = clientHost;
        return this;
    }
    setExtensions(extensions) {
        this.extensions = extensions;
        return this;
    }
    setAiFeatures(aiFeatures) {
        this.aiFeatures = aiFeatures;
        return this;
    }
}

class StorageUtils {
}
StorageUtils.attachChangeDetection = (callback) => {
    window.addEventListener("storage", callback);
};
StorageUtils.detachChangeDetection = (callback) => {
    window.removeEventListener("storage", callback);
};
StorageUtils.setItem = (storageKey, storageValue) => {
    localStorage.setItem(storageKey, JSON.stringify(storageValue));
};
StorageUtils.getItem = (storageKey) => {
    return JSON.parse(localStorage.getItem(storageKey));
};
StorageUtils.removeItem = (storageKey) => {
    localStorage.removeItem(storageKey);
};

class CallingDetailsUtils {
    static isSentByMe(call, loggedInUser) {
        var _a;
        const senderUid = (_a = call.getSender()) === null || _a === void 0 ? void 0 : _a.getUid();
        return !senderUid || senderUid === (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.getUid());
    }
    static isMissedCall(call, loggedInUser) {
        const callStatus = call.getStatus();
        if (CallingDetailsUtils.isSentByMe(call, loggedInUser)) {
            return callStatus === uikitResources.CometChatUIKitConstants.calls.unanswered;
        }
        else {
            return [uikitResources.CometChatUIKitConstants.calls.busy, uikitResources.CometChatUIKitConstants.calls.unanswered, uikitResources.CometChatUIKitConstants.calls.rejected, uikitResources.CometChatUIKitConstants.calls.cancelled].includes(callStatus);
        }
    }
    static getCallStatus(call, loggedInUser) {
        const callStatus = call.getStatus();
        const isSentByMe = CallingDetailsUtils.isSentByMe(call, loggedInUser);
        const isMissedCall = CallingDetailsUtils.isMissedCall(call, loggedInUser);
        if (isSentByMe) {
            switch (callStatus) {
                case uikitResources.CometChatUIKitConstants.calls.initiated:
                    return uikitResources.localize("OUTGOING_CALL");
                case uikitResources.CometChatUIKitConstants.calls.cancelled:
                    return uikitResources.localize("CALL_CANCELLED");
                case uikitResources.CometChatUIKitConstants.calls.rejected:
                case uikitResources.CometChatUIKitConstants.calls.busy:
                    return uikitResources.localize("CALL_REJECTED");
                case uikitResources.CometChatUIKitConstants.calls.ended:
                    return uikitResources.localize("CALL_ENDED");
                case uikitResources.CometChatUIKitConstants.calls.ongoing:
                    return uikitResources.localize("CALL_ACCEPTED");
                case uikitResources.CometChatUIKitConstants.calls.unanswered:
                    return uikitResources.localize("CALL_UNANSWERED");
                default:
                    return uikitResources.localize("OUTGOING_CALL");
            }
        }
        else {
            if (isMissedCall) {
                return uikitResources.localize("MISSED_CALL");
            }
            else if (callStatus === uikitResources.CometChatUIKitConstants.calls.ended) {
                return uikitResources.localize("CALL_ENDED");
            }
            else if (callStatus === uikitResources.CometChatUIKitConstants.calls.ongoing) {
                return uikitResources.localize("CALL_ACCEPTED");
            }
            else {
                return uikitResources.localize("INCOMING_CALL");
            }
        }
    }
}
CallingDetailsUtils.getDefaultMessageTypes = () => {
    return [uikitResources.CometChatUIKitConstants.MessageTypes.audio, uikitResources.CometChatUIKitConstants.MessageTypes.video, uikitResources.CometChatUIKitConstants.calls.meeting];
};
CallingDetailsUtils.getDefaultCategories = () => {
    return [uikitResources.CometChatUIKitConstants.MessageCategory.call, uikitResources.CometChatUIKitConstants.MessageCategory.custom];
};

/**
 * OutgoingCallStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} subtitleTextFont - Font for subTitle text.
 * @property {string} subtitleTextColor - Color for subTitle text.
 * @property {string} titleTextFont - Font for title text.
 * @property {string} titleTextColor - Color for title text.
 */
class OutgoingCallStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "700 22px Inter, sans-serif";
        this.titleTextColor = "black";
        this.subtitleTextFont = "400 13px Inter, sans-serif";
        this.subtitleTextColor = "RGBA(20, 20, 20, 0.58)";
        this.declineButtonTextFont = "400 12px Inter";
        this.declineButtonTextColor = "RGBA(20, 20, 20, 0.58)";
        this.declineButtonIconTint = "RGBA";
        this.declineButtonIconBackground = "red";
        Object.assign(this, props);
    }
}

/**
  * @property {string} declineButtonIconURL - close icon to cancel call.
  * @property {(error:CometChat.CometChatException)=>void} onError - callback for error.
  * @property {(()=>void) | null} onCloseClicked - The callback on select.
  * @property {any} customView - The view for outgoingCall.
  * @property {AvatarStyle} avatarStyle - The style for avatar.
  * @property {OutgoingCallStyle} outgoingCallStyle - The style for outgoingCall.
  */
class OutgoingCallConfiguration {
    constructor(props) {
        this.declineButtonIconURL = closeIcon$1;
        this.avatarStyle = {};
        this.disableSoundForCalls = false;
        this.customSoundForCalls = "";
        this.outgoingCallStyle = {};
        this.onDeclineButtonClicked = null;
        Object.assign(this, props);
    }
}

/**
 * CallButtonsStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} subtitleTextFont - Font for subTitle text.
 * @property {string} subtitleTextColor - Color for subTitle text.
 * @property {string} titleTextFont - Font for title text.
 * @property {string} titleTextColor - Color for title text.
 */
class CallButtonsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.voiceCallIconTint = "RGB(51, 153, 255)";
        this.videoCallIconTint = "RGB(51, 153, 255)";
        this.voiceCallIconTextFont = "400 12px Inter";
        this.videoCallIconTextFont = "400 12px Inter";
        this.voiceCallIconTextColor = "RGB(51, 153, 255)";
        this.videoCallIconTextColor = "RGB(51, 153, 255)";
        this.buttonBackground = "";
        this.buttonBorder = "";
        this.buttonBorderRadius = "";
        this.buttonPadding = "";
        Object.assign(this, props);
    }
}

var AudioCallIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FCall%402x%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FCall%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22streamline-icon-phone-actions-voice-mail%4024x24%22%20transform%3D%22translate%283.000000%2C%203.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0.0679824131%2C6.18726899%20L1.15322891%2C7.27252708%20C1.71745406%2C7.8368527%202.48276427%2C8.15389548%203.28076591%2C8.15389548%20C4.07876755%2C8.15389548%204.84407776%2C7.8368527%205.40830291%2C7.27252708%20L7.00415829%2C5.67746515%20C7.28631808%2C5.39534955%207.44483777%2C5.01269036%207.44483777%2C4.61368527%20C7.44483777%2C4.21468018%207.28631808%2C3.83202099%207.00415829%2C3.5499054%20L3.90079098%2C0.446504908%20C3.59388219%2C0.136593264%203.16773676%2C-0.025114152%202.73249452%2C0.00317689658%20C2.29725227%2C0.0314679452%201.89562592%2C0.246981102%201.63141818%2C0.594015717%20C-1.61783738%2C5.00961401%200.349222543%2C9.660257%204.34493966%2C13.6552063%20C8.34065677%2C17.6501557%2012.9904395%2C19.6180471%2017.4059906%2C16.3687568%20C17.7530215%2C16.1045463%2017.9685324%2C15.7029156%2017.9968231%2C15.2676687%20C18.0251139%2C14.8324218%2017.8634082%2C14.4062718%2017.5534999%2C14.0993598%20L14.450943%2C10.9959593%20C14.1688305%2C10.7137965%2013.7861754%2C10.5552751%2013.3871745%2C10.5552751%20C12.9881737%2C10.5552751%2012.6055186%2C10.7137965%2012.323406%2C10.9959593%20L10.7275507%2C12.5918317%20C10.1632311%2C13.1560629%209.8461917%2C13.9213813%209.8461917%2C14.7193915%20C9.8461917%2C15.5174016%2010.1632311%2C16.28272%2010.7275507%2C16.8469512%20L11.8249545%2C17.9443668%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var VideoCallIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FVideo%402x%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FVideo%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%282.000000%2C%206.500000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1.79471961%2C-7.25088203e-17%20L11.9552804%2C7.25088203e-17%20C12.5793435%2C-4.21297127e-17%2012.8056439%2C0.0649779267%2013.033792%2C0.186992889%20C13.2619401%2C0.309007852%2013.4409921%2C0.488059851%2013.5630071%2C0.716207995%20C13.6850221%2C0.94435614%2013.75%2C1.1706565%2013.75%2C1.79471961%20L13.75%2C9.20528039%20C13.75%2C9.8293435%2013.6850221%2C10.0556439%2013.5630071%2C10.283792%20C13.4409921%2C10.5119401%2013.2619401%2C10.6909921%2013.033792%2C10.8130071%20C12.8056439%2C10.9350221%2012.5793435%2C11%2011.9552804%2C11%20L1.79471961%2C11%20C1.1706565%2C11%200.94435614%2C10.9350221%200.716207995%2C10.8130071%20C0.488059851%2C10.6909921%200.309007852%2C10.5119401%200.186992889%2C10.283792%20C0.0649779267%2C10.0556439%209.39485689e-17%2C9.8293435%20-1.61693481e-16%2C9.20528039%20L4.83392135e-17%2C1.79471961%20C-2.80864751e-17%2C1.1706565%200.0649779267%2C0.94435614%200.186992889%2C0.716207995%20C0.309007852%2C0.488059851%200.488059851%2C0.309007852%200.716207995%2C0.186992889%20C0.94435614%2C0.0649779267%201.1706565%2C4.21297127e-17%201.79471961%2C-7.25088203e-17%20Z%22%20id%3D%22Rectangle%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M17.2599167%2C8.63041667%20L19.6304167%2C9.81475%20C19.8435282%2C9.92114296%2020.096526%2C9.90964554%2020.299109%2C9.78436146%20C20.5016921%2C9.65907738%2020.625%2C9.43785985%2020.625%2C9.19966667%20L20.625%2C1.80033333%20C20.625%2C1.56214015%2020.5016921%2C1.34092262%2020.299109%2C1.21563854%20C20.096526%2C1.09035446%2019.8435282%2C1.07885704%2019.6304167%2C1.18525%20L17.2599167%2C2.36958333%20C16.7940465%2C2.60259636%2016.4998441%2C3.07885646%2016.4999999%2C3.59975%20L16.4999999%2C7.40025%20C16.4998441%2C7.92114354%2016.7940465%2C8.39740364%2017.2599167%2C8.63041667%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

/**
  * @property {string} voiceCallIconURL - audio call icon.
    * @property {string} videoCallIconURL - video call icon.
  * @property {(error:CometChat.CometChatException)=>void} onError - callback for error.
  * @property {((user:CometChat.User,group:CometChat.Group)=>void) | null} onVoiceCallClick - The callback to initiate voice call.
   * @property {((user:CometChat.User,group:CometChat.Group)=>void) | null} onVideoCallClick - The callback to initiate video call.
  * @property {CallButtonsStyle} callButtonsStyle - The style for outgoingCall.
  */
class CallButtonsConfiguration {
    constructor(props) {
        this.voiceCallIconURL = AudioCallIcon;
        this.videoCallIconURL = VideoCallIcon;
        this.callButtonsStyle = {};
        Object.assign(this, props);
    }
}

var IncreaseSizeIcon = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M10.2%2013.8L3%2021%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M21%208.4V3H15.6%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M3%2015.6V21H8.4%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M21%203L13.8%2010.2%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var ReduceSizeIcon = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M21%203L13.8%2010.2%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.2%2019.2V13.8H4.80005%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.8%204.8V10.2H19.2%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.2%2013.8L3%2021%22%20stroke%3D%22%23808080%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

/**
  * @property {string} minimizeIconURL - reduce size icon.
    * @property {string} maximizeIconURL - increase size icon.
  * @property {CometChat.CallSettingsBuilder} callSettingsBuilder - request builder for calls.
  * @property {CallscreenStyle} ongoingCallStyle - The style for outgoingCall.
  */
class CallScreenConfiguration {
    constructor(props) {
        this.minimizeIconURL = ReduceSizeIcon;
        this.maximizeIconURL = IncreaseSizeIcon;
        this.ongoingCallStyle = {};
        Object.assign(this, props);
    }
}

/**
 * IncomingCallStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} subtitleTextFont - Font for subTitle text.
 * @property {string} subtitleTextColor - Color for subTitle text.
 * @property {string} titleTextFont - Font for title text.
 * @property {string} titleTextColor - Color for title text.
  * @property {string} acceptButtonTextFont - Font for button text.
 * @property {string} acceptButtonTextColor - Color for button text.
 * @property {string} acceptButtonBackground - Background for button text.
 * @property {string} acceptButtonBorderRadius - BorderRadius for button text.
  * @property {string} acceptButtonBorder - Border for button text.
    * @property {string} declineButtonTextFont - Font for button text.
 * @property {string} declineButtonTextColor - Color for button text.
 * @property {string} declineButtonBackground - Background for button text.
 * @property {string} declineButtonBorderRadius - BorderRadius for button text.
  * @property {string} declineButtonBorder - Border for button text.
 */
class IncomingCallStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "600 15px Inter";
        this.titleTextColor = "black";
        this.subtitleTextFont = "400 13px Inter";
        this.subtitleTextColor = "lightgrey";
        this.acceptButtonTextFont = "500 15px Inter";
        this.acceptButtonTextColor = "white";
        this.acceptButtonBackground = "rgba(51, 153, 255)";
        this.acceptButtonBorderRadius = "8px";
        this.acceptButtonBorder = "none";
        this.declineButtonTextFont = "500 15px Inter";
        this.declineButtonTextColor = "white";
        this.declineButtonBackground = "red";
        this.declineButtonBorderRadius = "8px";
        this.declineButtonBorder = "none";
        Object.assign(this, props);
    }
}

/**
 * CallLogHistoryStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} headingFont - Font of the heading.
 * @property {string} headingColor - Color of the heading.
 * @property {string} emptyStateTextColor - Color of the empty state text.
 * @property {string} emptyStateTextFont - Font of the empty state text.
 * @property {string} errorStateTextColor - Color of the error state text.
 * @property {string} errorStateTextFont - Font of the error state text.
 * @property {string} loadingIconTint - Tint of the loading icon.
 * @property {string} backIconTint - Tint of the back icon.
 * @property {string} dateTextFont - Font of the date text.
 * @property {string} dateTextColor - Color of the date text.
 * @property {string} dateSeparatorTextFont - Font of the date separator text.
 * @property {string} dateSeparatorTextColor - Color of the date separator text.
 * @property {string} callDurationTextFont - Font of the call duration text.
 * @property {string} callDurationTextColor - Color of the call duration text.
 * @property {string} callStatusTextFont - Font of the call status text.
 * @property {string} callStatusTextColor - Color of the call status text.
 * @property {string} dividerColor - Color of the divider.
 */
class CallLogHistoryStyle extends BaseStyle {
    constructor(style) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.emptyStateTextColor = "";
        this.emptyStateTextFont = "";
        this.errorStateTextColor = "";
        this.errorStateTextFont = "";
        this.loadingIconTint = "";
        this.backIconTint = "";
        this.dateTextFont = "";
        this.dateTextColor = "";
        this.dateSeparatorTextFont = "";
        this.dateSeparatorTextColor = "";
        this.callDurationTextFont = "";
        this.callDurationTextColor = "";
        this.callStatusTextFont = "";
        this.callStatusTextColor = "";
        this.dividerColor = "";
        Object.assign(this, style);
    }
}

/**
 * CallLogParticipantsStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} headingFont - Font of the heading.
 * @property {string} headingColor - Color of the heading.
 * @property {string} backIconTint - Tint of the back icon.
 * @property {string} callStatusFont - Font of the call status text.
 * @property {string} callStatusColor - Color of the call status text.
 * @property {string} dateTextFont - Font of the date text.
 * @property {string} dateTextColor - Color of the date text.
 */
class CallLogParticipantsStyle extends BaseStyle {
    constructor(style) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.backIconTint = "";
        this.callStatusFont = "";
        this.callStatusColor = "";
        this.dateTextFont = "";
        this.dateTextColor = "";
        Object.assign(this, style);
    }
}

/**
 * CallLogRecordingsStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} headingFont - Font of the heading.
 * @property {string} headingColor - Color of the heading.
 * @property {string} closeIconTint - Tint of the close icon.
 * @property {string} recordingDurationFont - Font of the recording duration text.
 * @property {string} recordingDurationColor - Color of the recording duration text.
 * @property {string} dateTextFont - Font of the date text.
 * @property {string} dateTextColor - Color of the date text.
 */
class CallLogRecordingsStyle extends BaseStyle {
    constructor(style) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.backIconTint = "";
        this.downloadIconTint = "";
        this.recordingDurationFont = "";
        this.recordingDurationColor = "";
        this.dateTextFont = "";
        this.dateTextColor = "";
        Object.assign(this, style);
    }
}

/**
 * CallLogStyle class represents the styles for users. It extends BaseStyle.
 *
 * @property {string} headingFont - Font of the heading.
 * @property {string} headingColor - Color of the heading.
 * @property {string} emptyStateTextColor - Color of the empty state text.
 * @property {string} emptyStateTextFont - Font of the empty state text.
 * @property {string} errorStateTextColor - Color of the error state text.
 * @property {string} errorStateTextFont - Font of the error state text.
 * @property {string} loadingIconTint - Tint of the loading icon.
 * @property {string} closeIconTint - Tint of the close icon.
 * @property {string} infoIconTint - Tint of the info icon.
 * @property {string} missedCallIconTint - Tint of the missed call icon.
 * @property {string} outgoingCallIconTint - Tint of the outgoing call icon.
 * @property {string} incomingCallIconTint - Tint of the incoming call icon.
 * @property {string} callStatusTextFont - Font of the call status text.
 * @property {string} callStatusTextColor - Color of the call status text.
 * @property {string} dateTextFont - Font of the date text.
 * @property {string} dateTextColor - Color of the date text.
 * @property {string} dateSeparatorTextFont - Font of the date separator text.
 * @property {string} dateSeparatorTextColor - Color of the date separator text.
 */
class CallLogsStyle extends BaseStyle {
    constructor(style) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.emptyStateTextColor = "";
        this.emptyStateTextFont = "";
        this.errorStateTextColor = "";
        this.errorStateTextFont = "";
        this.loadingIconTint = "";
        this.infoIconTint = "";
        this.missedCallIconTint = "";
        this.outgoingCallIconTint = "";
        this.incomingCallIconTint = "";
        this.callStatusTextFont = "";
        this.callStatusTextColor = "";
        this.dateTextFont = "";
        this.dateTextColor = "";
        this.dateSeparatorTextFont = "";
        this.dateSeparatorTextColor = "";
        Object.assign(this, style);
    }
}

/**
 * CallLogDetailStyle class represents the styles for users. It extends BaseStyle.
 *
 */
class CallLogDetailsStyle extends BaseStyle {
    constructor(style) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.nameTextFont = "";
        this.nameTextColor = "";
        this.backIconTint = "";
        Object.assign(this, style);
    }
}

/**
 * WithDetailsStyle
 *
 * @property {string} height - The height of the component.
 * @property {string} width - The width of the component.
 * @property {string} border - The border of the component.
 * @property {string} borderRadius - The border radius of the component.
 * @property {string} background - The background color of the component.
 * @property {string} messageTextColor - The messageText color of the component.
 * @property {string} messageTextFont - The messageText font of the component.
 */
class WithDetailsStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.messageTextColor = "";
        this.messageTextFont = "";
        Object.assign(this, props);
    }
}

var IncomingAudioCallIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.78531%209.33083L4.34856%209.89458C4.64141%2010.1873%205.03856%2010.3518%205.45265%2010.3518C5.86675%2010.3518%206.2639%2010.1873%206.55675%209.89458L7.38496%209.06639C7.45752%208.99388%207.51508%208.90778%207.55435%208.81301C7.59362%208.71825%207.61383%208.61667%207.61383%208.51409C7.61383%208.41151%207.59362%208.30993%207.55435%208.21517C7.51508%208.1204%207.45752%208.0343%207.38496%207.96179L5.77488%206.35123C5.69603%206.27169%205.601%206.21005%205.49623%206.17048C5.39146%206.13091%205.27941%206.11434%205.16767%206.1219C5.05593%206.12945%204.94713%206.16095%204.84864%206.21426C4.75015%206.26757%204.66428%206.34145%204.59686%206.43087C2.90974%208.72127%203.93211%2011.1335%206.00548%2013.2073C8.07886%2015.2812%2010.4927%2016.3025%2012.7847%2014.6154C12.8739%2014.5477%2012.9475%2014.4617%2013.0005%2014.3631C13.0536%2014.2645%2013.0848%2014.1556%2013.092%2014.0439C13.0993%2013.9322%2013.0824%2013.8202%2013.0426%2013.7155C13.0028%2013.6109%2012.9409%2013.516%2012.8612%2013.4374L11.2506%2011.8268C11.1781%2011.7543%2011.092%2011.6967%2010.9972%2011.6574C10.9025%2011.6182%2010.8009%2011.598%2010.6983%2011.598C10.5957%2011.598%2010.4941%2011.6182%2010.3994%2011.6574C10.3046%2011.6967%2010.2185%2011.7543%2010.146%2011.8268L9.31778%2012.655C9.17274%2012.8%209.05768%2012.9722%208.97918%2013.1617C8.90068%2013.3512%208.86028%2013.5543%208.86028%2013.7594C8.86028%2013.9645%208.90068%2014.1676%208.97918%2014.357C9.05768%2014.5465%209.17274%2014.7187%209.31778%2014.8637L9.89039%2015.4332%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.3872%208.82531L15.4626%203.75%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.5105%208.82517H10.3872V5.7019%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var IncomingVideoCallIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.43018%2015.8583C2.56723%2015.8583%201.86768%2015.1588%201.86768%2014.2958V5.70435C1.86768%204.8414%202.56723%204.14185%203.43018%204.14185H12.1884C13.0513%204.14185%2013.7509%204.8414%2013.7509%205.70435V14.2958C13.7509%2015.1588%2013.0513%2015.8583%2012.1884%2015.8583H3.43018Z%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.1571%2011.9541C13.9068%2011.817%2013.7512%2011.5543%2013.7512%2011.2689V8.73246C13.7512%208.44707%2013.9068%208.18437%2014.1571%208.04726L16.9754%206.50343C17.4961%206.21822%2018.132%206.59497%2018.132%207.18861V12.8128C18.132%2013.4064%2017.4961%2013.7832%2016.9754%2013.4979L14.1571%2011.9541Z%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.41384%2012.5186H5.1875V9.29224%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.3776%207.31396L5.28149%2012.41%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var InfoIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FInfo%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FInfo%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22streamline-icon-information-circle%4024x24%22%20transform%3D%22translate%282.000000%2C%202.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12%2C14%20L11.3333333%2C14%20C10.5969537%2C14%2010%2C13.4030463%2010%2C12.6666667%20L10%2C9.33333333%20C10%2C8.9651435%209.70152317%2C8.66666667%209.33333333%2C8.66666667%20L8.66666667%2C8.66666667%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9.66666667%2C5.33333333%20C9.48257175%2C5.33333333%209.33333333%2C5.48257175%209.33333333%2C5.66666667%20C9.33333333%2C5.85076158%209.48257175%2C6%209.66666667%2C6%20C9.85076158%2C6%2010%2C5.85076158%2010%2C5.66666667%20C10%2C5.48257175%209.85076158%2C5.33333333%209.66666667%2C5.33333333%20L9.66666667%2C5.33333333%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C10%20C0%2C15.5228475%204.4771525%2C20%2010%2C20%20C15.5228475%2C20%2020%2C15.5228475%2020%2C10%20C20%2C4.4771525%2015.5228475%2C0%2010%2C0%20C4.4771525%2C0%200%2C4.4771525%200%2C10%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var MissedAudioCallIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.78531%209.33083L4.34854%209.89458C4.64139%2010.1873%205.03853%2010.3518%205.45262%2010.3518C5.86671%2010.3518%206.26385%2010.1873%206.5567%209.89458L7.38488%209.06639C7.45744%208.99388%207.515%208.90778%207.55427%208.81301C7.59354%208.71825%207.61376%208.61667%207.61376%208.51409C7.61376%208.41151%207.59354%208.30993%207.55427%208.21517C7.515%208.1204%207.45744%208.0343%207.38488%207.96179L5.77484%206.35123C5.69599%206.27169%205.60096%206.21005%205.4962%206.17048C5.39143%206.13091%205.27938%206.11434%205.16764%206.1219C5.05591%206.12945%204.9471%206.16095%204.84862%206.21426C4.75013%206.26757%204.66426%206.34145%204.59684%206.43087C2.90976%208.72127%203.93211%2011.1335%206.00544%2013.2073C8.07877%2015.2812%2010.4925%2016.3025%2012.7845%2014.6154C12.8737%2014.5477%2012.9473%2014.4617%2013.0003%2014.3631C13.0534%2014.2645%2013.0846%2014.1556%2013.0918%2014.0439C13.0991%2013.9322%2013.0822%2013.8202%2013.0424%2013.7155C13.0026%2013.6109%2012.9407%2013.516%2012.861%2013.4374L11.2504%2011.8268C11.1779%2011.7543%2011.0918%2011.6967%2010.9971%2011.6574C10.9023%2011.6182%2010.8007%2011.598%2010.6982%2011.598C10.5956%2011.598%2010.494%2011.6182%2010.3992%2011.6574C10.3045%2011.6967%2010.2184%2011.7543%2010.1459%2011.8268L9.31767%2012.655C9.17263%2012.8%209.05757%2012.9722%208.97908%2013.1617C8.90058%2013.3512%208.86018%2013.5543%208.86018%2013.7594C8.86018%2013.9645%208.90058%2014.1676%208.97908%2014.357C9.05757%2014.5465%209.17263%2014.7187%209.31767%2014.8637L9.89027%2015.4332%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M15.4622%204.53082L12.3389%207.65409L8.43481%203.75%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.43481%206.09245V3.75H10.7773%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var MissedVideoCallIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M14.1573%2011.9539C13.907%2011.8167%2013.7515%2011.5541%2013.7515%2011.2687V8.73221C13.7515%208.44682%2013.907%208.18413%2014.1573%208.04701L16.9757%206.50318C17.4963%206.21798%2018.1322%206.59473%2018.1322%207.18836V12.8125C18.1322%2013.4061%2017.4963%2013.7829%2016.9757%2013.4977L14.1573%2011.9539Z%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.3834%209.1351L8.17601%2012.3425L4.16675%208.33325%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.16675%2010.7388V8.33325H6.5723%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M3.22925%2015.883C2.3663%2015.883%201.66675%2015.1834%201.66675%2014.3205V5.729C1.66675%204.86606%202.3663%204.1665%203.22925%204.1665H11.9874C12.8503%204.1665%2013.5499%204.86606%2013.5499%205.729V14.3205C13.5499%2015.1834%2012.8503%2015.883%2011.9874%2015.883H3.22925Z%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var OutgoingAudioCallIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.78531%209.33083L4.34854%209.89458C4.64139%2010.1873%205.03853%2010.3518%205.45262%2010.3518C5.86671%2010.3518%206.26385%2010.1873%206.5567%209.89458L7.38488%209.06639C7.45744%208.99388%207.515%208.90778%207.55427%208.81301C7.59354%208.71825%207.61376%208.61667%207.61376%208.51409C7.61376%208.41151%207.59354%208.30993%207.55427%208.21517C7.515%208.1204%207.45744%208.0343%207.38488%207.96179L5.77484%206.35123C5.69599%206.27169%205.60096%206.21005%205.4962%206.17048C5.39143%206.13091%205.27938%206.11434%205.16764%206.1219C5.05591%206.12945%204.9471%206.16095%204.84862%206.21426C4.75013%206.26757%204.66426%206.34145%204.59684%206.43087C2.90976%208.72127%203.93211%2011.1335%206.00544%2013.2073C8.07877%2015.2812%2010.4925%2016.3025%2012.7845%2014.6154C12.8737%2014.5477%2012.9473%2014.4617%2013.0003%2014.3631C13.0534%2014.2645%2013.0846%2014.1556%2013.0918%2014.0439C13.0991%2013.9322%2013.0822%2013.8202%2013.0424%2013.7155C13.0026%2013.6109%2012.9407%2013.516%2012.861%2013.4374L11.2504%2011.8268C11.1779%2011.7543%2011.0918%2011.6967%2010.9971%2011.6574C10.9023%2011.6182%2010.8007%2011.598%2010.6982%2011.598C10.5956%2011.598%2010.494%2011.6182%2010.3992%2011.6574C10.3045%2011.6967%2010.2184%2011.7543%2010.1459%2011.8268L9.31767%2012.655C9.17263%2012.8%209.05757%2012.9722%208.97908%2013.1617C8.90058%2013.3512%208.86018%2013.5543%208.86018%2013.7594C8.86018%2013.9645%208.90058%2014.1676%208.97908%2014.357C9.05757%2014.5465%209.17263%2014.7187%209.31767%2014.8637L9.89027%2015.4332%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M15.4623%203.75L10.387%208.82531%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12.3391%203.75H15.4624V6.87327%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var OutgoingVideoCallIcon = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.43018%2015.8583C2.56723%2015.8583%201.86768%2015.1588%201.86768%2014.2958V5.70435C1.86768%204.8414%202.56723%204.14185%203.43018%204.14185H12.1884C13.0513%204.14185%2013.7509%204.8414%2013.7509%205.70435V14.2958C13.7509%2015.1588%2013.0513%2015.8583%2012.1884%2015.8583H3.43018Z%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.1571%2011.9541C13.9068%2011.817%2013.7512%2011.5543%2013.7512%2011.2689V8.73246C13.7512%208.44707%2013.9068%208.18437%2014.1571%208.04726L16.9754%206.50343C17.4961%206.21822%2018.132%206.59497%2018.132%207.18861V12.8128C18.132%2013.4064%2017.4961%2013.7832%2016.9754%2013.4979L14.1571%2011.9541Z%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.15111%207.31395H10.3774V10.5403%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M5.18738%2012.5186L10.2834%207.42248%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

class CallLogsConfiguration {
    constructor(config) {
        this.titleAlignment = uikitResources.TitleAlignment.left;
        this.listItemView = null;
        this.subtitleView = null;
        this.tailView = null;
        this.loadingIconURL = LoadingIcon;
        this.onItemClick = null;
        this.onError = null;
        this.listItemStyle = {};
        this.infoIconUrl = InfoIcon;
        this.onInfoClick = null;
        this.datePattern = uikitResources.DatePatterns.time;
        this.dateSeparatorPattern = uikitResources.DatePatterns.DayDate;
        this.incomingAudioCallIconUrl = IncomingAudioCallIcon;
        this.incomingVideoCallIconUrl = IncomingVideoCallIcon;
        this.outgoingAudioCallIconUrl = OutgoingAudioCallIcon;
        this.outgoingVideoCallIconUrl = OutgoingVideoCallIcon;
        this.missedAudioCallIconUrl = MissedAudioCallIcon;
        this.missedVideoCallIconUrl = MissedVideoCallIcon;
        this.callLogsStyle = {};
        this.avatarStyle = {};
        this.hideSeparator = false;
        this.outgoingCallConfiguration = new OutgoingCallConfiguration({});
        Object.assign(this, config);
    }
}

class CallLogHistoryConfiguration {
    constructor(config) {
        this.loadingIconURL = LoadingIcon;
        this.subtitleView = null;
        this.tailView = null;
        this.onItemClick = null;
        this.backIconUrl = backIcon;
        this.onBackClick = null;
        this.listItemStyle = {};
        this.datePattern = uikitResources.DatePatterns.time;
        this.dateSeparatorPattern = uikitResources.DatePatterns.DayDate;
        this.callLogHistoryStyle = {};
        this.onError = null;
        Object.assign(this, config);
    }
}

class CallLogParticipantsConfiguration {
    constructor(config) {
        this.backIconUrl = backIcon;
        this.onBackClick = null;
        this.avatarStyle = {};
        this.onItemClick = null;
        this.datePattern = uikitResources.DatePatterns.time;
        this.listItemStyle = {};
        this.callLogParticipantsStyle = {};
        this.listItemView = null;
        this.subtitleView = null;
        this.tailView = null;
        Object.assign(this, config);
    }
}

var DownloadIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EIcons%2F24%2FDownload%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Icons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icons%2F24%2FDownload%22%20stroke%3D%22%23000000%22%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolyline%20id%3D%22Path%22%20points%3D%227.33333333%2013.2%2011%2016.8666667%2014.6666667%2013.2%22%3E%3C%2Fpolyline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%2211%22%20y1%3D%225.86666667%22%20x2%3D%2211%22%20y2%3D%2216.8666667%22%20id%3D%22Path%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C11%20C0%2C17.0751322%204.92486775%2C22%2011%2C22%20C17.0751322%2C22%2022%2C17.0751322%2022%2C11%20C22%2C4.92486775%2017.0751322%2C0%2011%2C0%20C4.92486775%2C0%200%2C4.92486775%200%2C11%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

class CallLogRecordingsConfiguration {
    constructor(config) {
        this.backIconUrl = backIcon;
        this.onBackClick = null;
        this.onItemClick = null;
        this.datePattern = uikitResources.DatePatterns.time;
        this.listItemStyle = {};
        this.callLogRecordingsStyle = {};
        this.downloadIconUrl = DownloadIcon;
        this.hideDownloadButton = false;
        this.onDownloadClick = null;
        this.listItemView = null;
        this.subtitleView = null;
        this.tailView = null;
        Object.assign(this, config);
    }
}

class CallLogDetailsConfiguration {
    constructor(config) {
        this.backIconUrl = backIcon;
        this.avatarStyle = {};
        this.onBackClick = null;
        this.data = null;
        this.callLogHistoryConfiguration = new CallLogHistoryConfiguration({});
        this.callLogParticipantsConfiguration = new CallLogParticipantsConfiguration({});
        this.callLogRecordingsConfiguration = new CallLogRecordingsConfiguration({});
        this.callLogDetailsStyle = {};
        Object.assign(this, config);
    }
}

var CometChatUIKitCalls = (function() {try{if(require('@cometchat/calls-sdk-javascript')){return require('@cometchat/calls-sdk-javascript').CometChatCalls}}catch(e){return null}})();

class FormBubbleStyle extends uikitElements.BaseStyle {
    constructor(props) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.wrapperBackground = "";
        this.wrapperBorderRadius = "";
        this.wrapperPadding = "";
        this.goalCompletionTextFont = "";
        this.goalCompletionTextColor = "";
        Object.assign(this, props);
    }
}

const textStyle = new uikitElements.InputStyle({
    width: "100%",
    height: "30px",
    border: "1px solid #ccc",
    borderRadius: "3px",
    padding: "0px 0px 0px 5px",
    placeholderTextColor: "#bcbcbc",
    placeholderTextFont: "500 13px Inter, sans-serif",
    textFont: "400 14px Inter, sans-serif",
});
const labelStyle = new uikitElements.LabelStyle({
    textFont: "400 16px Inter, sans-serif",
    textColor: "black",
});
const radioButtonStyle = new uikitElements.RadioButtonStyle({
    height: "16px",
    width: "16px",
    border: "none",
    labelTextFont: "400 14px Inter, sans-serif",
    labelTextColor: "grey",
    borderRadius: "4px",
    background: "",
});
const checkboxStyle = new uikitElements.CheckboxStyle({
    height: "16px",
    width: "16px",
    border: "none",
    borderRadius: "4px",
    background: "",
    labelTextColor: "grey",
    labelTextFont: "400 14px Inter, sans-serif",
});
const dropdownStyle = new uikitElements.DropdownStyle({
    height: "35px",
    width: "100%",
    background: "white",
    border: "1px solid #e2e2e2",
    borderRadius: "12px",
    activeTextFont: "400 15px Inter, sans-serif",
    activeTextColor: "#141414",
    arrowIconTint: "grey",
    textFont: "400 15px Inter, sans-serif",
    textColor: "#141414",
    optionBackground: "white",
    optionBorder: "1px solid #e2e2e2",
    optionHoverBorder: "1px solid #e2e2e2",
    hoverTextFont: "400 15px Inter, sans-serif",
    hoverTextColor: "#141414",
    hoverTextBackground: "#efefef",
});
const buttonStyle$1 = {
    height: "40px",
    width: "100%",
    background: "#3399FF",
    border: "1px solid #e2e2e2",
    borderRadius: "12px",
    buttonTextFont: "400 15px Inter, sans-serif",
    buttonTextColor: "white",
    justifyContent: "center",
};
const quickViewStyle = new uikitElements.QuickViewStyle({
    background: "RGBA(20, 20, 20, 0.04)",
    height: "fit-content",
    width: "100%",
    titleFont: "600 13px Inter, sans-serif",
    titleColor: "#3399FF",
    subtitleFont: "400 13px Inter, sans-serif",
    subtitleColor: "grey",
    leadingBarTint: "#3399FF",
    leadingBarWidth: "4px",
    borderRadius: "8px",
});
const singleSelectStyle = new uikitElements.SingleSelectStyle({
    height: "100%",
    width: "100%",
    background: "#efefef",
    border: "none",
    borderRadius: "12px",
    activeTextFont: "400 15px Inter, sans-serif",
    activeTextColor: "#141414",
    textFont: "400 15px Inter, sans-serif",
    textColor: "grey",
    optionBackground: "white",
    optionBorder: "1px solid #e2e2e2",
    optionBorderRadius: "2px",
    hoverTextFont: "400 15px Inter, sans-serif",
    hoverTextColor: "#141414",
    hoverTextBackground: "#efefef",
});
exports.CometChatFormBubble = class CometChatFormBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.hasCustomCallback = false;
        this.formBubbleStyle = new FormBubbleStyle({
            width: "fit-content",
            height: "fit-content",
            border: "none",
            background: "RGBA(20, 20, 20, 0.04)",
            wrapperBackground: "#fff",
            wrapperPadding: "2px",
            borderRadius: "12px",
            wrapperBorderRadius: "12px",
            titleColor: "#141414",
            titleFont: "400 22px Inter, sans-serif",
            goalCompletionTextFont: "400 15px Inter, sans-serif",
            goalCompletionTextColor: "grey",
        });
        this.data = {};
        this.goalCompletionText = uikitResources.localize("FORM_COMPLETION_MESSAGE");
        this.hasInteractionCompleted = false;
        this.showRequired = [];
        this.isLoading = false;
        this.loadingElement = "";
        this.emitEvent = (elementId) => {
            let response = [];
            if (this.data && Object.keys(this.data).length > 0) {
                response = Object.keys(this.data).map((key) => {
                    var _a, _b;
                    const elementType = (_b = (_a = this.formData) === null || _a === void 0 ? void 0 : _a.getFormFields().find((field) => {
                        return field.getElementId() === key;
                    })) === null || _b === void 0 ? void 0 : _b.getElementType();
                    const element = new uikitResources.BaseInputElement(key, elementType || "");
                    element.setResponse(this.data[key]);
                    return element;
                });
            }
            this.dispatchEvent(new CustomEvent("cc-submit-clicked", {
                bubbles: true,
                composed: true,
                detail: {
                    value: {
                        elementId,
                        data: response,
                    },
                },
            }));
        };
        this.markAsInteracted = (elementId) => {
            var _a;
            chatSdkJavascript.CometChat.markAsInteracted((_a = this.message) === null || _a === void 0 ? void 0 : _a.getId(), elementId).then(() => {
                var _a;
                const interaction = new chatSdkJavascript.CometChat.Interaction(elementId, new Date().getTime());
                (_a = this.interactedElements) === null || _a === void 0 ? void 0 : _a.push(interaction);
                this.hasInteractionCompleted = this.checkHasInteractionCompleted();
                this.setLoading(false, elementId);
                this.requestUpdate("hasInteractionCompleted");
            });
        };
        this.removeElementIdFromRequired = (elementId) => {
            if (this.showRequired.includes(elementId)) {
                this.showRequired.splice(this.showRequired.indexOf(elementId), 1);
                this.requestUpdate("showRequired");
            }
        };
        this.interactedBanner = () => {
            var _a, _b, _c;
            const containerStyle = {
                boxSizing: "border-box",
                margin: "5px",
            };
            const paragraphStyle = {
                font: this.formBubbleStyle.goalCompletionTextFont,
                color: this.formBubbleStyle.goalCompletionTextColor,
            };
            return lit.html `
      <div style=${styleMap_js.styleMap(containerStyle)}>
        <cometchat-quick-view
          title=${(_b = (_a = this.message) === null || _a === void 0 ? void 0 : _a.getSender()) === null || _b === void 0 ? void 0 : _b.getName()}
          subtitle=${(_c = this.formData) === null || _c === void 0 ? void 0 : _c.getTitle()}
          quickViewStyle=${JSON.stringify(this.formBubbleStyle.quickViewStyle)}
        ></cometchat-quick-view>
        <span style=${styleMap_js.styleMap(paragraphStyle)}
          >${this.goalCompletionText}</span
        >
      </div>
    `;
        };
        this.isRequired = (field) => {
            return (field === null || field === void 0 ? void 0 : field.optional) ? "" : "*";
        };
        this.filledRequiredFields = () => {
            var _a;
            let filled = true;
            (_a = this.formData) === null || _a === void 0 ? void 0 : _a.getFormFields().forEach((field) => {
                if (field.getElementType() !== uikitResources.ElementType.button &&
                    field.getElementType() !== uikitResources.ElementType.label) {
                    if (field.getOptional()) {
                        return;
                    }
                    if (!this.data[field.getElementId()]) {
                        filled = false;
                        if (!this.showRequired.includes(field.getElementId()))
                            this.showRequired.push(field.getElementId());
                    }
                }
            });
            return filled;
        };
        this.checkHasInteractionCompleted = () => {
            var _a, _b;
            let completed = false;
            let neededInteractionElement = ((_a = this.interactionGoal) === null || _a === void 0 ? void 0 : _a.getElementIds()) || [];
            let neededInteractionElementCondition = ((_b = this.interactionGoal) === null || _b === void 0 ? void 0 : _b.getType()) || "";
            let interactedElements = this.interactedElements || [];
            switch (neededInteractionElementCondition) {
                case uikitResources.CometChatUIKitConstants.goalType.anyOf:
                    completed = interactedElements.find((element) => neededInteractionElement.includes(element.getElementId()))
                        ? true
                        : false;
                    break;
                case uikitResources.CometChatUIKitConstants.goalType.anyAction:
                    completed = interactedElements.length > 0 ? true : false;
                    break;
                case uikitResources.CometChatUIKitConstants.goalType.allOf:
                    completed = neededInteractionElement.every((element) => interactedElements.find((interaction) => interaction.getElementId() === element))
                        ? true
                        : false;
                    break;
                case uikitResources.CometChatUIKitConstants.goalType.none:
                    completed = false;
                    break;
                default:
                    completed = false;
                    break;
            }
            return completed;
        };
        this.bubbleStyle = () => {
            var _a, _b, _c, _d, _e, _f;
            return {
                width: ((_a = this.formBubbleStyle) === null || _a === void 0 ? void 0 : _a.width) || "fit-content",
                height: ((_b = this.formBubbleStyle) === null || _b === void 0 ? void 0 : _b.height) || "fit-content",
                border: ((_c = this.formBubbleStyle) === null || _c === void 0 ? void 0 : _c.border) || "none",
                background: ((_d = this.formBubbleStyle) === null || _d === void 0 ? void 0 : _d.background) || "RGBA(20, 20, 20, 0.04)",
                borderRadius: ((_e = this.formBubbleStyle) === null || _e === void 0 ? void 0 : _e.borderRadius) || "12px",
                padding: ((_f = this.formBubbleStyle) === null || _f === void 0 ? void 0 : _f.wrapperPadding) || "2px",
            };
        };
        this.titleStyle = () => {
            var _a, _b;
            return {
                color: ((_a = this.formBubbleStyle) === null || _a === void 0 ? void 0 : _a.titleColor) || "#141414",
                font: ((_b = this.formBubbleStyle) === null || _b === void 0 ? void 0 : _b.titleFont) || "400 18px Inter, sans-serif",
            };
        };
        this.wrapperBubbleStyle = () => {
            var _a, _b;
            return {
                background: ((_a = this.formBubbleStyle) === null || _a === void 0 ? void 0 : _a.wrapperBackground) || "#fff",
                borderRadius: ((_b = this.formBubbleStyle) === null || _b === void 0 ? void 0 : _b.wrapperBorderRadius) || "8px",
            };
        };
    }
    render() {
        var _a, _b, _c, _d, _e;
        if (!this.loggedInUser) {
            chatSdkJavascript.CometChat.getLoggedinUser()
                .then((user) => {
                if (user)
                    this.loggedInUser = user;
            })
                .catch((error) => {
                console.log(error);
            });
        }
        if (!this.formBubbleStyle.textInputStyle) {
            this.formBubbleStyle.textInputStyle = textStyle;
        }
        if (!this.formBubbleStyle.labelStyle) {
            this.formBubbleStyle.labelStyle = labelStyle;
        }
        if (!this.formBubbleStyle.radioButtonStyle) {
            this.formBubbleStyle.radioButtonStyle = radioButtonStyle;
        }
        if (!this.formBubbleStyle.checkboxStyle) {
            this.formBubbleStyle.checkboxStyle = checkboxStyle;
        }
        if (!this.formBubbleStyle.dropdownStyle) {
            this.formBubbleStyle.dropdownStyle = dropdownStyle;
        }
        if (!this.formBubbleStyle.buttonStyle) {
            this.formBubbleStyle.buttonStyle = buttonStyle$1;
        }
        if (!this.formBubbleStyle.quickViewStyle) {
            this.formBubbleStyle.quickViewStyle = quickViewStyle;
        }
        if (!this.formBubbleStyle.singleSelectStyle) {
            this.formBubbleStyle.singleSelectStyle = singleSelectStyle;
        }
        if (!this.formData) {
            this.formData = this.message;
            this.goalCompletionText =
                ((_a = this === null || this === void 0 ? void 0 : this.formData) === null || _a === void 0 ? void 0 : _a.getGoalCompletionText()) || this.goalCompletionText;
            this.interactedElements = ((_b = this.message) === null || _b === void 0 ? void 0 : _b.getInteractions()) || [];
            this.interactionGoal = ((_c = this.message) === null || _c === void 0 ? void 0 : _c.getInteractionGoal()) || undefined;
            this.hasInteractionCompleted = this.checkHasInteractionCompleted();
        }
        return this.message
            ? lit.html `
          <div style=${styleMap_js.styleMap(this.bubbleStyle())} class="cc__form_bubble">
            ${this.hasInteractionCompleted
                ? this.interactedBanner()
                : lit.html `<div
                  class="cc__form_bubble__wrapper"
                  style=${styleMap_js.styleMap(this.wrapperBubbleStyle())}
                >
                  <h3 style=${styleMap_js.styleMap(this.titleStyle())}>
                    ${(_d = this.formData) === null || _d === void 0 ? void 0 : _d.getTitle()}
                  </h3>
                  ${(_e = this.formData) === null || _e === void 0 ? void 0 : _e.getFormFields().map((field) => lit.html `
                          <div class="cc_form-field_wrapper">
                            ${this._renderFormField(field)}
                          </div>
                        `)}
                  <div class="cc_flex__column cc_dynamic-form_button-group">
                    ${this._renderSubmitElement(this.formData.getSubmitElement())}
                  </div>
                </div>`}
          </div>
        `
            : lit.nothing;
    }
    _renderFormField(field) {
        switch (field.getElementType()) {
            case uikitResources.ElementType.label:
                return this._renderLabelField(field);
            case uikitResources.ElementType.text:
                return this._renderTextField(field);
            case uikitResources.ElementType.button:
                return this._renderButtonField(field);
            case uikitResources.ElementType.checkbox:
                return this._renderCheckboxField(field);
            case uikitResources.ElementType.dropdown:
                return this._renderDropdownField(field);
            case uikitResources.ElementType.radio:
                return this._renderRadioField(field);
            case uikitResources.ElementType.singleSelect:
                return this._renderSingleSelectField(field);
            default:
                return lit.nothing;
        }
    }
    _renderLabelField(field) {
        const labelStyle = this.formBubbleStyle.labelStyle;
        return lit.html `
      <cometchat-label
        labelStyle=${JSON.stringify(labelStyle)}
        text=${field.getText()}
      ></cometchat-label>
    `;
    }
    _renderTextField(field) {
        const isRequired = this.showRequired.includes(field.getElementId());
        const inputStyle = CometChatUIKitUtility.clone(this.formBubbleStyle.textInputStyle);
        const labelStyle = this.formBubbleStyle.labelStyle;
        const messageInputStyle = new uikitElements.MessageInputStyle({
            ...inputStyle,
            height: "fit-content",
            dividerColor: "transparent",
            inputBackground: inputStyle === null || inputStyle === void 0 ? void 0 : inputStyle.background,
            maxHeight: `${14 * ((field.getMaxLines() || 1) + 1)}px`,
            width: "100%",
        });
        const defaultValue = field.getDefaultValue() || "";
        if (defaultValue) {
            this.data[field.getElementId()] = defaultValue;
        }
        if (isRequired) {
            inputStyle.border = "1px solid red";
            messageInputStyle.border = "1px solid red";
        }
        return lit.html `
      <div class="cc_flex__column cc_flex_align">
        <cometchat-label
          labelStyle=${JSON.stringify(labelStyle)}
          text=${field.getLabel() + this.isRequired(field)}
        ></cometchat-label>
        ${(field.getMaxLines() || 1) > 1
            ? lit.html `
              <cometchat-message-input
                messageInputStyle=${JSON.stringify(messageInputStyle)}
                placeholderText=${field.getPlaceholder()}
                text=${defaultValue}
                @cc-message-input-changed=${(event) => {
                var _a, _b;
                if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) {
                    this.removeElementIdFromRequired(field.getElementId());
                    this.data[field.getElementId()] = (_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.value;
                }
                else
                    delete this.data[field.getElementId()];
            }}
              >
              </cometchat-message-input>
            `
            : lit.html `
              <cometchat-input
                inputStyle=${JSON.stringify(inputStyle)}
                placeholderText=${field.getPlaceholder()}
                value=${defaultValue}
                @cc-input-changed=${(event) => {
                var _a, _b;
                if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) {
                    this.removeElementIdFromRequired(field.getElementId());
                    this.data[field.getElementId()] = (_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.value;
                }
                else
                    delete this.data[field.getElementId()];
            }}
              ></cometchat-input>
            `}
      </div>
    `;
    }
    _renderSubmitElement(field) {
        return this._renderButtonField(field, true);
    }
    _renderButtonField(field, isSubmitElement = false) {
        var _a, _b, _c;
        let disabled;
        const isLoading = this.isLoading && this.loadingElement === field.getElementId();
        const text = isLoading ? "" : field.getButtonText();
        const buttonStyle = this.formBubbleStyle.buttonStyle;
        const backdropStyle = new uikitElements.BackdropStyle({
            background: buttonStyle.background,
            borderRadius: buttonStyle.borderRadius,
        });
        const loaderStyle = new uikitElements.LoaderStyle({
            height: "24px",
            width: "24px",
            border: "",
            borderRadius: "",
            background: "",
            iconTint: buttonStyle.buttonTextColor,
        });
        if (field.getDisableAfterInteracted()) {
            disabled = (_a = this.interactedElements) === null || _a === void 0 ? void 0 : _a.some((element) => element.getElementId() === field.getElementId());
        }
        if (!((_b = this.message) === null || _b === void 0 ? void 0 : _b.getIsSenderInteractionAllowed(false))) {
            let messageUID = (_c = this.message) === null || _c === void 0 ? void 0 : _c.getSender().getUid();
            let loggedInUserUID = "";
            if (this.loggedInUser) {
                loggedInUserUID = this.loggedInUser.getUid();
                if (loggedInUserUID === messageUID) {
                    disabled = true;
                }
            }
            else {
                chatSdkJavascript.CometChat.getLoggedinUser()
                    .then((user) => {
                    if (user) {
                        loggedInUserUID = user.getUid();
                        if (loggedInUserUID === messageUID) {
                            disabled = true;
                            this.requestUpdate();
                        }
                    }
                })
                    .catch((error) => {
                    console.log(error);
                });
            }
        }
        if (isLoading) {
            disabled = true;
        }
        return lit.html `
      <div style="position:relative">
        ${isLoading
            ? lit.html `
              <cometchat-backdrop
                backdropStyle=${JSON.stringify(backdropStyle)}
              >
                <cometchat-loader
                  loaderStyle=${JSON.stringify(loaderStyle)}
                ></cometchat-loader>
              </cometchat-backdrop>
            `
            : lit.nothing}
        <cometchat-button
          buttonStyle=${JSON.stringify(buttonStyle)}
          text=${text}
          ?disabled=${disabled}
          @cc-button-clicked=${() => {
            if (isSubmitElement) {
                if (this.filledRequiredFields()) {
                    if (this.hasCustomCallback) {
                        this.emitEvent(field.getElementId());
                    }
                    else {
                        this._handleButtonClick(field.getAction(), field.getElementId());
                    }
                }
                else {
                    this.requestUpdate("showRequired");
                }
            }
            else {
                this._handleButtonClick(field.getAction(), field.getElementId());
            }
        }}
        ></cometchat-button>
      </div>
    `;
    }
    _renderCheckboxField(field) {
        const labelStyle = this.formBubbleStyle.labelStyle;
        const checkboxStyle = CometChatUIKitUtility.clone(this.formBubbleStyle.checkboxStyle);
        const isRequired = this.showRequired.includes(field.getElementId());
        if (field.getDefaultValue() &&
            Array.isArray(field.getDefaultValue()) &&
            (field.getDefaultValue() || []).length > 0) {
            const key = field.getElementId();
            this.data[key] = field.getDefaultValue();
        }
        if (isRequired) {
            checkboxStyle.border = "1px solid red";
        }
        return lit.html `
      <div class="cc_flex__column cc_flex_align">
        <cometchat-label
          labelStyle=${JSON.stringify(labelStyle)}
          text=${field.getLabel() + this.isRequired(field)}
        ></cometchat-label>
        <div class="cc_form_group">
          ${field.getOptions().map((option) => {
            var _a;
            return lit.html `
              <div class="cc_flex cc_flex_align">
                <cometchat-checkbox
                  name=${field.getElementId()}
                  labelText=${option.getLabel()}
                  labelAlignment=${uikitResources.LabelAlignment.right}
                  dir="rtl"
                  checkboxStyle=${JSON.stringify(checkboxStyle)}
                  ?checked=${(_a = field
                .getDefaultValue()) === null || _a === void 0 ? void 0 : _a.includes(option.getValue())}
                  @cc-checkbox-changed="${(event) => {
                var _a;
                if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.checked) {
                    this.removeElementIdFromRequired(field.getElementId());
                    if (this.data[field.getElementId()] &&
                        Array.isArray(this.data[field.getElementId()])) {
                        this.data[field.getElementId()].push(option.getValue());
                    }
                    else {
                        this.data[field.getElementId()] = [option.getValue()];
                    }
                }
                else {
                    if (this.data[field.getElementId()] &&
                        Array.isArray(this.data[field.getElementId()])) {
                        this.data[field.getElementId()].splice(this.data[field.getElementId()].indexOf(option.getValue()), 1);
                        if (this.data[field.getElementId()].length === 0) {
                            delete this.data[field.getElementId()];
                        }
                    }
                }
            }}"
                />
              </div>
            `;
        })}
        </div>
      </div>
    `;
    }
    _renderDropdownField(field) {
        const labelStyle = this.formBubbleStyle.labelStyle;
        const dropdownStyle = CometChatUIKitUtility.clone(this.formBubbleStyle.dropdownStyle);
        const isRequired = this.showRequired.includes(field.getElementId());
        let selectedOption = "None";
        const options = field.getOptions().map((option) => {
            return option.getLabel();
        });
        if (field.getDefaultValue()) {
            field.getOptions().forEach((option) => {
                if (option.getValue() === field.getDefaultValue()) {
                    this.data[field.getElementId()] = option.getValue();
                    selectedOption = option.getLabel();
                }
            });
        }
        if (isRequired) {
            dropdownStyle.border = "1px solid red";
        }
        return lit.html `
      <div class="cc_flex__column cc_flex_align">
        <cometchat-label
          labelStyle=${JSON.stringify(labelStyle)}
          text=${field.getLabel() + this.isRequired(field)}
        ></cometchat-label>
        <cometchat-dropdown
          dropdownStyle=${JSON.stringify(dropdownStyle)}
          @cc-dropdown-changed=${(event) => {
            var _a;
            if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) {
                this.removeElementIdFromRequired(field.getElementId());
                const option = field.getOptions().find((option) => {
                    var _a;
                    return option.getLabel() === ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value);
                });
                this.data[field.getElementId()] = option === null || option === void 0 ? void 0 : option.getValue();
            }
            else
                delete this.data[field.getElementId()];
        }}
          options=${JSON.stringify(options)}
          selectedOption=${selectedOption}
        ></cometchat-dropdown>
      </div>
    `;
    }
    _renderRadioField(field) {
        const labelStyle = this.formBubbleStyle.labelStyle;
        const radioButtonStyle = this.formBubbleStyle.radioButtonStyle;
        if (field.getDefaultValue()) {
            if (field.getOptions() && field.getOptions().length > 0) {
                field.getOptions().forEach((option) => {
                    if (option.getValue() === field.getDefaultValue()) {
                        this.data[field.getElementId()] = option.getValue();
                    }
                });
            }
        }
        return lit.html `
    <div class="cc_flex__column cc_flex_align">
    <cometchat-label labelStyle=${JSON.stringify(labelStyle)} text=${field.getLabel() + this.isRequired(field)}></cometchat-label>
    <div class="cc_form_group">
    ${field.getOptions().map((o) => {
            return lit.html `
        <cometchat-radio-button
          radioButtonStyle=${JSON.stringify(radioButtonStyle)}
          name=${field.getElementId()}
          labelText=${o.getLabel()}
          labelAlignment=${uikitResources.LabelAlignment.right}
          ?checked=${o.getValue() === field.getDefaultValue()}
          @cc-radio-button-changed=${(event) => {
                var _a;
                this.removeElementIdFromRequired(field.getElementId());
                if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.checked)
                    this.data[field.getElementId()] = o.getValue();
                else
                    delete this.data[field.getElementId()];
            }}
        />
      `;
        })}
    </div>
    </div
    `;
    }
    _renderSingleSelectField(field) {
        const labelStyle = this.formBubbleStyle.labelStyle;
        const singleSelectStyle = CometChatUIKitUtility.clone(this.formBubbleStyle.singleSelectStyle);
        const isRequired = this.showRequired.includes(field.getElementId());
        let selectedOption = "";
        if (field.getDefaultValue()) {
            if (field.getOptions() && field.getOptions().length > 0) {
                field.getOptions().forEach((option) => {
                    if (option.getValue() === field.getDefaultValue()) {
                        this.data[field.getElementId()] = option.getValue();
                        selectedOption = option.getLabel();
                    }
                });
            }
        }
        const options = field.getOptions().map((option) => {
            return option.getLabel();
        });
        if (isRequired) {
            singleSelectStyle.optionBorder = "1px solid red";
        }
        return lit.html `
    <div class="cc_flex__column cc_flex_align">
    <cometchat-label labelStyle=${JSON.stringify(labelStyle)} text=${field.getLabel() + this.isRequired(field)}></cometchat-label>
    <div class="cc_form_group" style="width:100%">
    <cometchat-single-select
    selectStyle=${JSON.stringify(singleSelectStyle)}
      options=${JSON.stringify(options)}
      selectedOption=${selectedOption}
      @cc-single-select-changed=${(event) => {
            var _a;
            this.removeElementIdFromRequired(field.getElementId());
            if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) {
                const option = field.getOptions().find((option) => {
                    var _a;
                    return option.getLabel() === ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value);
                });
                this.data[field.getElementId()] = option === null || option === void 0 ? void 0 : option.getValue();
            }
            else
                delete this.data[field.getElementId()];
        }}
    ></cometchat-single-select>
    </div>
    </div
    `;
    }
    _handleButtonClick(action, elementId) {
        this.setLoading(true, elementId);
        InteractiveMessageUtils.actionHandler(action, {
            elementId: elementId,
            data: this.data,
            loggedInUser: this.loggedInUser,
        })
            .then((response) => {
            if (response) {
                this.markAsInteracted(elementId);
            }
        })
            .catch(() => {
            this.setLoading(false, elementId);
        });
    }
    setLoading(isLoading, elementId) {
        this.isLoading = isLoading;
        if (isLoading) {
            this.loadingElement = elementId;
        }
        else {
            this.loadingElement = "";
        }
        this.requestUpdate("isLoading");
    }
    updated(_changedProperties) {
        var _a, _b, _c;
        if (_changedProperties.has('message')) {
            this.formData = this.message;
            this.goalCompletionText =
                ((_a = this === null || this === void 0 ? void 0 : this.formData) === null || _a === void 0 ? void 0 : _a.getGoalCompletionText()) || this.goalCompletionText;
            this.interactedElements = ((_b = this.message) === null || _b === void 0 ? void 0 : _b.getInteractions()) || [];
            this.interactionGoal = ((_c = this.message) === null || _c === void 0 ? void 0 : _c.getInteractionGoal()) || undefined;
            this.hasInteractionCompleted = this.checkHasInteractionCompleted();
            this.requestUpdate("formData");
        }
    }
};
exports.CometChatFormBubble.styles = [
    lit.css `
      .cc_flex {
        display: flex;
      }

      .cc_flex__column {
        display: flex;
        flex-direction: column;
        gap: 5px;
      }

      .cc_flex_align {
        text-align: start;
      }

      .cc__form_bubble {
        position: relative;
        padding: 10px;
        max-width: 100%;
        min-width: 210px;
        min-height: 100px;
        box-sizing: border-box;
        overflow: hidden;
      }

      .cc__form_bubble__wrapper {
        display: flex;
        flex-direction: column;
        text-align: start;
        padding: 8px;
        max-width: 100%;
        background-color: #fff;
        border-radius: 8px;
      }

      .cc_form-field_wrapper {
        margin-bottom: 15px;
      }

      .cc_form_group {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: space-evenly;
        width: max-content;
      }

      .cc_dynamic-form_button-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    `,
];
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatFormBubble.prototype, "message", void 0);
__decorate([
    decorators_js.property({ type: Boolean })
], exports.CometChatFormBubble.prototype, "hasCustomCallback", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatFormBubble.prototype, "formBubbleStyle", void 0);
exports.CometChatFormBubble = __decorate([
    decorators_js.customElement("cometchat-form-bubble")
], exports.CometChatFormBubble);

class CardBubbleStyle extends uikitElements.BaseStyle {
    constructor(props) {
        super({});
        this.wrapperBackground = "";
        this.wrapperBorderRadius = "";
        this.wrapperPadding = "";
        this.imageHeight = "";
        this.imageWidth = "";
        this.imageRadius = "";
        this.imageBackgroundColor = "";
        this.descriptionFontColor = "";
        this.descriptionFont = "";
        this.dividerTintColor = "";
        this.disabledButtonColor = "";
        Object.assign(this, props);
    }
}

const buttonStyle = {
    height: "40px",
    width: "100%",
    background: "transparent",
    border: "none",
    borderRadius: "0px",
    buttonTextFont: "400 15px Inter, sans-serif",
    buttonTextColor: "#3399FF",
    justifyContent: "center",
};
exports.CometChatCardBubble = class CometChatCardBubble extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.cardBubbleStyle = new CardBubbleStyle({
            background: "#f1f5f8",
            wrapperBackground: "white",
            wrapperPadding: "2px",
            borderRadius: "8px",
            wrapperBorderRadius: "8px",
            height: "fit-content",
            width: "300px",
            imageHeight: "auto",
            imageWidth: "100%",
            imageRadius: "8px",
            dividerTintColor: "#f1f5f8",
            imageBackgroundColor: "transparent",
            descriptionFontColor: "#000000",
            descriptionFont: "400 15px 'Inter', sans-serif",
            buttonStyle: buttonStyle,
            disabledButtonColor: "#000000",
        });
        this.showFullScreen = false;
        this.isLoading = false;
        this.loadingElement = "";
        this.markAsInteracted = (elementId) => {
            var _a;
            chatSdkJavascript.CometChat.markAsInteracted((_a = this.message) === null || _a === void 0 ? void 0 : _a.getId(), elementId)
                .then(() => {
                var _a;
                const interaction = new chatSdkJavascript.CometChat.Interaction(elementId, new Date().getTime());
                (_a = this.interactedElements) === null || _a === void 0 ? void 0 : _a.push(interaction);
                this.setLoading(false, elementId);
                this.requestUpdate("interactedElements");
            })
                .catch((error) => {
                console.log(error);
            });
        };
        this.wrapperBubbleStyle = () => {
            var _a, _b;
            return {
                background: ((_a = this.cardBubbleStyle) === null || _a === void 0 ? void 0 : _a.wrapperBackground) || "#fff",
                borderRadius: ((_b = this.cardBubbleStyle) === null || _b === void 0 ? void 0 : _b.wrapperBorderRadius) || "8px",
            };
        };
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        if (!this.message) {
            return lit.nothing;
        }
        if (!this.loggedInUser) {
            chatSdkJavascript.CometChat.getLoggedinUser()
                .then((user) => {
                if (user) {
                    this.loggedInUser = user;
                    this.requestUpdate();
                }
            })
                .catch((error) => {
                console.log(error);
            });
        }
        if (!this.cardData) {
            this.cardData = this.message;
        }
        if (!this.interactedElements) {
            this.interactedElements = this.message.getInteractions() || [new chatSdkJavascript.CometChat.Interaction("submitButton1", new Date().getTime())];
        }
        return lit.html `
        <div
          class="cc__card_bubble"
          style=${styleMap_js.styleMap(this.getContainerStyle())}
        >
        <div
        class="cc__card_bubble__wrapper"
        style=${styleMap_js.styleMap(this.wrapperBubbleStyle())}
      >
          <div class="cc__card_bubble__details">
            ${((_a = this.cardData) === null || _a === void 0 ? void 0 : _a.getImageUrl())
            ? lit.html ` <div class="cc__card_bubble__image">
                  ${this.showFullScreen
                ? lit.html ` <cometchat-full-screen-viewer
                        @cc-close-clicked=${() => {
                    this.showFullScreen = false;
                    this.requestUpdate("showFullScreen");
                }}
                        URL=${(_b = this.cardData) === null || _b === void 0 ? void 0 : _b.getImageUrl()}
                        fullScreenViewerStyle=${JSON.stringify(this.fullScreenViewStyle())}
                        closeIconUrl=${closeIcon$1}
                      ></cometchat-full-screen-viewer>`
                : lit.nothing}
                  <cometchat-image-bubble
                    imageStyle=${JSON.stringify(this.getImageStyle())}
                    src=${(_c = this.cardData) === null || _c === void 0 ? void 0 : _c.getImageUrl()}
                    @cc-image-clicked=${() => {
                this.showFullScreen = true;
                this.requestUpdate("showFullScreen");
            }}
                  ></cometchat-image-bubble>
                </div>`
            : lit.nothing}
            <div
              class="cc__card_bubble__description"
              style=${styleMap_js.styleMap(this.getDescriptionStyle())}
            >
              <p>${(_d = this.cardData) === null || _d === void 0 ? void 0 : _d.getText()}</p>
            </div>
          </div>
          <div class="cc__card_bubble__buttons">
            ${(_f = (_e = this.cardData) === null || _e === void 0 ? void 0 : _e.getCardActions()) === null || _f === void 0 ? void 0 : _f.map((button) => {
            return this._renderButtonField(button);
        })}
          </div>
        </div>
        </div>
      </div>
    `;
    }
    _renderButtonField(field) {
        var _a, _b, _c, _d, _e;
        const isLoading = this.isLoading && (this.loadingElement === field.getElementId());
        const text = isLoading ? "" : field.getButtonText();
        const buttonStyle = this.cardBubbleStyle.buttonStyle;
        const backdropStyle = new uikitElements.BackdropStyle({
            background: buttonStyle.background,
            borderRadius: buttonStyle.borderRadius
        });
        const loaderStyle = new uikitElements.LoaderStyle({
            height: "24px",
            width: "24px",
            border: "",
            borderRadius: "",
            background: "",
            iconTint: buttonStyle.buttonTextColor
        });
        const dividerStyle = {
            height: "2px",
            width: "100%",
            background: (_a = this.cardBubbleStyle) === null || _a === void 0 ? void 0 : _a.dividerTintColor,
        };
        let disabled;
        if (field.getDisableAfterInteracted()) {
            disabled = (_b = this.interactedElements) === null || _b === void 0 ? void 0 : _b.some((element) => element.getElementId() === field.getElementId());
        }
        if (!((_c = this.message) === null || _c === void 0 ? void 0 : _c.getIsSenderInteractionAllowed(false))) {
            let messageUID = (_d = this.message) === null || _d === void 0 ? void 0 : _d.getSender().getUid();
            let loggedInUserUID = "";
            if (this.loggedInUser) {
                loggedInUserUID = this.loggedInUser.getUid();
                if (loggedInUserUID === messageUID) {
                    disabled = true;
                }
            }
            else {
                chatSdkJavascript.CometChat.getLoggedinUser()
                    .then((user) => {
                    if (user) {
                        loggedInUserUID = user.getUid();
                        if (loggedInUserUID === messageUID) {
                            disabled = true;
                            this.requestUpdate();
                        }
                    }
                })
                    .catch((error) => {
                    console.log(error);
                });
            }
        }
        if (isLoading) {
            disabled = true;
        }
        return lit.html `
      <cometchat-divider
        dividerStyle=${JSON.stringify(dividerStyle)}
      ></cometchat-divider>
      <div style='position:relative'>
      ${isLoading ? lit.html `
        <cometchat-backdrop
        backdropStyle=${JSON.stringify(backdropStyle)}
        >
      <cometchat-loader
      loaderStyle=${JSON.stringify(loaderStyle)}
      ></cometchat-loader>
      </cometchat-backdrop>
        ` : lit.nothing}
      <cometchat-button
        buttonStyle=${JSON.stringify({ ...buttonStyle, buttonTextColor: disabled ? (_e = this.cardBubbleStyle) === null || _e === void 0 ? void 0 : _e.disabledButtonColor : buttonStyle.buttonTextColor })}
        text=${text}
        ?disabled=${disabled}
        @cc-button-clicked=${() => {
            this._handleButtonClick(field.getAction(), field.getElementId());
        }}
      ></cometchat-button>
      </div>
    `;
    }
    _handleButtonClick(action, elementId) {
        this.setLoading(true, elementId);
        InteractiveMessageUtils.actionHandler(action, {
            elementId: elementId,
            loggedInUser: this.loggedInUser
        }).then((response) => {
            if (response) {
                this.markAsInteracted(elementId);
            }
        })
            .catch(() => {
            this.setLoading(false, elementId);
        });
    }
    setLoading(isLoading, elementId) {
        this.isLoading = isLoading;
        if (isLoading) {
            this.loadingElement = elementId;
        }
        else {
            this.loadingElement = "";
        }
        this.requestUpdate("isLoading");
    }
    getContainerStyle() {
        const { height, width, background, borderRadius, border, wrapperPadding } = this.cardBubbleStyle;
        return {
            height: height,
            width: width,
            background: background,
            borderRadius: borderRadius,
            border: border,
            padding: wrapperPadding || "8px",
        };
    }
    getImageStyle() {
        var _a, _b, _c;
        return new uikitElements.ImageBubbleStyle({
            height: (_a = this.cardBubbleStyle) === null || _a === void 0 ? void 0 : _a.imageHeight,
            width: (_b = this.cardBubbleStyle) === null || _b === void 0 ? void 0 : _b.imageWidth,
            borderRadius: (_c = this.cardBubbleStyle) === null || _c === void 0 ? void 0 : _c.imageRadius,
            background: "transparent",
        });
    }
    getDescriptionStyle() {
        const { descriptionFontColor, descriptionFont } = this
            .cardBubbleStyle;
        return {
            color: descriptionFontColor,
            font: descriptionFont,
        };
    }
    fullScreenViewStyle() {
        let fullScreenViewerStyle = {
            closeIconTint: "white",
        };
        return fullScreenViewerStyle;
    }
};
exports.CometChatCardBubble.styles = [
    lit.css `
      .cc_flex {
        display: flex;
      }

      .cc_flex__column {
        display: flex;
        flex-direction: column;
        gap: 5px;
      }

      .cc_flex_align {
        text-align: start;
      }

      .cc__card_bubble__wrapper {
        display: flex;
        flex-direction: column;
        text-align: start;
        max-width: 100%;
        background-color: #fff;
        border-radius: 8px;
      }

      .cc__card_bubble {
        display: flex;
        flex-direction: column;
        text-align: start;
        max-width: 100%;
        border-radius: 8px;
        min-width: 210px;
        box-sizing: border-box;
      }

      .cc__card_bubble__details {
        display: flex;
        flex-direction: column;
        gap: 0px;
        padding: 8px;
      }

      .cc__card_bubble__buttons {
        display: flex;
        flex-direction: column;
        gap: 0px;
      }

      .cc__card_bubble__description{
        white-space: pre-line;
        word-break: break-word;
      }
    `,
];
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatCardBubble.prototype, "message", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatCardBubble.prototype, "cardBubbleStyle", void 0);
exports.CometChatCardBubble = __decorate([
    decorators_js.customElement("cometchat-card-bubble")
], exports.CometChatCardBubble);

var EmptyIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%3F%3E%3Csvg%20version%3D%221.0%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100.000000pt%22%20height%3D%22100.000000pt%22%20viewBox%3D%220%200%20100.000000%20100.000000%22%20preserveAspectRatio%3D%22xMidYMid%20meet%22%3E%3Cg%20transform%3D%22translate%280.000000%2C100.000000%29%20scale%280.100000%2C-0.100000%29%22fill%3D%22%23000000%22%20stroke%3D%22none%22%3E%3Cpath%20d%3D%22M375%20847%20c-221%20-73%20-326%20-269%20-254%20-472%20l22%20-62%20-25%20-74%20c-14%20-41-23%20-80%20-21%20-86%206%20-17%2042%20-15%20138%206%2077%2017%2082%2017%20138%20-1%2072%20-22%20199%20-25%20216%20-46%207%209%2021%205%2030%20-5%2013%20-21%2016%20-79%2016%20-44%200%20-98%208%20-136%2019%20-58%2018%20-67%2019%20-123%206-89%20-21%20-88%20-23%20-65%2042%20l20%2058%20-26%2056%20c-52%20116%20-25%20240%2069%20327%2077%2071%20123%2087246%2087%20123%200%20169%20-16%20245%20-86%2064%20-59%2088%20-108%2094%20-199%205%20-68%208%20-75%2028%20-78%2036-5%2048%2038%2033%20118%20-22%20125%20-94%20215%20-218%20273%20-59%2028%20-79%2032%20-167%2034%20-63%202%20-115-2%20-140%20-10z%22%2F%3E%3Cpath%20d%3D%22M687%20313%20c-16%20-15%20-4%20-42%2038%20-83%20l45%20-44%20-45%20-46%20c-47%20-48%20-56%20-74-28%20-84%2011%20-5%2031%208%2064%2040%20l48%2047%2050%20-46%20c54%20-50%2061%20-53%2079%20-35%2018%2018%2015%2025-35%2079%20l-46%2050%2048%2049%20c41%2042%2046%2051%2035%2065%20-19%2023%20-30%2019%20-80%20-30%20l-46%20-45%20-4445%20c-41%2042%20-68%2054%20-83%2038z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var ErrorIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%3F%3E%3Csvg%20version%3D%221.0%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100.000000pt%22%20height%3D%22100.000000pt%22%20viewBox%3D%220%200%20100.000000%20100.000000%22%20preserveAspectRatio%3D%22xMidYMid%20meet%22%3E%3Cg%20transform%3D%22translate%280.000000%2C100.000000%29%20scale%280.100000%2C-0.100000%29%22fill%3D%22%23000000%22%20stroke%3D%22none%22%3E%3Cpath%20d%3D%22M375%20847%20c-221%20-73%20-326%20-269%20-254%20-472%20l22%20-62%20-25%20-74%20c-14%20-41-23%20-80%20-21%20-86%206%20-17%2042%20-15%20138%206%2077%2017%2082%2017%20138%20-1%2091%20-28%20257%20-20%20278%201312%2020%20-9%2052%20-29%2044%20-9%20-4%20-51%20-10%20-94%20-12%20-59%20-4%20-92%20-1%20-145%2015%20-63%2019%20-7220%20-128%207%20-88%20-21%20-87%20-23%20-64%2042%20l20%2058%20-26%2056%20c-52%20116%20-25%20240%2069%20327%207771%20123%2087%20246%2087%2087%200%20113%20-4%20152%20-22%20101%20-47%20188%20-160%20188%20-246%200%20-69%2036-102%2061%20-56%208%2016%208%2037%20-1%2083%20-24%20122%20-96%20212%20-218%20269%20-59%2028%20-79%2032%20-167%2034-63%202%20-115%20-2%20-140%20-10z%22%2F%3E%3Cpath%20d%3D%22M764%20347%20c-2%20-8%20-4%20-47%20-2%20-88%203%20-71%204%20-74%2028%20-74%2025%200%2025%201%2025%2085%20081%20-1%2085%20-23%2088%20-12%202%20-24%20-3%20-28%20-11z%22%2F%3E%3Cpath%20d%3D%22M764%2095%20c-4%20-9%200%20-23%208%20-31%2020%20-20%2050%20-7%2046%2020%20-4%2026%20-45%2035%20-54%2011z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

class AIBaseConfiguration {
    constructor(props) {
        this.loadingIconURL = LoadingIcon;
        this.errorIconURL = ErrorIcon;
        this.emptyIconURL = EmptyIcon;
        Object.assign(this, props);
    }
}

class AIBaseStyle extends BaseStyle {
    constructor(props) {
        super({});
        Object.assign(this, props);
    }
}

class AIConversationStarterConfiguration extends AIBaseConfiguration {
    constructor(props) {
        super({});
        Object.assign(this, props);
    }
}

class AIConversationStarterStyle extends AIBaseStyle {
    constructor(props) {
        super({});
        Object.assign(this, props);
    }
}

class AIConversationSummaryConfiguration extends AIBaseConfiguration {
    constructor(props) {
        super({});
        this.unreadMessageThreshold = 30;
        this.closeIconURL = closeIcon$1;
        Object.assign(this, props);
    }
}

class AIConversationSummaryStyle extends AIBaseStyle {
    constructor(props) {
        super({});
        this.titleTextFont = "";
        this.titleTextColor = "";
        this.textFont = "";
        this.textColor = "";
        this.buttonTextColor = "";
        this.buttonTextFont = "";
        this.buttonBackground = "";
        this.closeIconTint = "";
        Object.assign(this, props);
    }
}

class AISmartRepliesConfiguration extends AIBaseConfiguration {
    constructor(props) {
        super({});
        this.backIconURL = backIcon;
        Object.assign(this, props);
    }
}

class AISmartRepliesStyle extends AIBaseStyle {
    constructor(props) {
        super({});
        this.textFont = "";
        this.textBorder = "";
        this.textBorderRadius = "";
        this.textColor = "";
        this.textBackground = "";
        this.buttonTextColor = "";
        this.buttonTextFont = "";
        this.buttonBackground = "";
        this.backIconTint = "";
        this.titleFont = "";
        this.titleColor = "";
        Object.assign(this, props);
    }
}

class AIOptionsStyle extends BaseStyle {
    constructor(props) {
        super({});
        Object.assign(this, props);
    }
}

class AIExtensionDataSource {
    enable() { }
}

class AIAssistBotStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.titleFont = "";
        this.titleColor = "";
        this.optionTitleFont = "";
        this.optionTitleColor = "";
        this.subtitleFont = "";
        this.subtitleColor = "";
        this.closeIconTint = "";
        this.backIconTint = "";
        this.sendIconTint = "";
        this.buttonTextColor = "";
        this.buttonTextFont = "";
        this.buttonBackground = "";
        Object.assign(this, props);
    }
}
class AITextMessageBubbleStyle extends BaseStyle {
    constructor(props) {
        super({});
        this.textFont = "";
        this.textColor = "";
        Object.assign(this, props);
    }
}
class AIBotMessageBubbleStyle extends AITextMessageBubbleStyle {
    constructor(props) {
        super({});
        Object.assign(this, props);
    }
}
class AISenderMessageBubbleStyle extends AITextMessageBubbleStyle {
    constructor(props) {
        super({});
        Object.assign(this, props);
    }
}

class AIAssistBotConfiguration {
    constructor(props) {
        this.loadingIconURL = loadingIcon;
        this.errorIconURL = errorIcon;
        this.closeIconURL = closeIcon$1;
        this.sendIconURL = sendIcon;
        this.backIconURL = backIcon;
        this.emptyIconURL = EmptyIcon;
        Object.assign(this, props);
    }
}

const defaultStyle = new AIBaseStyle({
    height: "fit-content",
    width: "100%",
    border: "none",
    borderRadius: "0",
    background: "none",
    errorIconTint: "grey",
    emptyIconTint: "grey",
    loadingIconTint: "grey",
    emptyStateTextColor: "#323232",
    emptyStateTextFont: "400 14px inter",
    errorStateTextColor: "#323232",
    errorStateTextFont: "400 14px inter",
    loadingStateTextColor: "#323232",
    loadingStateTextFont: "400 14px inter",
});
exports.CometChatAICard = class CometChatAICard extends lit.LitElement {
    constructor() {
        super(...arguments);
        this.state = uikitResources.States.loading;
        this.aiBaseStyle = defaultStyle;
        this.loadingIconURL = LoadingIcon;
        this.errorIconURL = ErrorIcon;
        this.emptyIconURL = EmptyIcon;
        this.loadingStateText = uikitResources.localize("LOADING");
        this.errorStateText = uikitResources.localize("SOMETHING_WRONG");
        this.emptyStateText = uikitResources.localize("NO_MESSAGES_FOUND");
        this.containerStyle = () => {
            const { height, width, border, borderRadius, background } = this.aiBaseStyle;
            return styleMap_js.styleMap({
                height: height || "fit-content",
                width: width || "100%",
                border: border || "none",
                borderRadius: borderRadius || "0",
                background: background || "none",
            });
        };
        this.iconStyle = (iconTint) => {
            return {
                buttonIconTint: iconTint || "grey",
                height: "24px",
                width: "24px",
                background: "transparent",
                border: "none",
                borderRadius: "0",
            };
        };
        this.labelStyle = (state) => {
            var _a, _b, _c, _d, _e, _f;
            switch (state) {
                case uikitResources.States.loading:
                    {
                        return new uikitElements.LabelStyle({
                            textColor: ((_a = this.aiBaseStyle) === null || _a === void 0 ? void 0 : _a.loadingStateTextColor) || "#323232",
                            textFont: ((_b = this.aiBaseStyle) === null || _b === void 0 ? void 0 : _b.loadingStateTextFont) || "400 14px inter",
                        });
                    }
                case uikitResources.States.error:
                    {
                        return new uikitElements.LabelStyle({
                            textColor: ((_c = this.aiBaseStyle) === null || _c === void 0 ? void 0 : _c.errorStateTextColor) || "#323232",
                            textFont: ((_d = this.aiBaseStyle) === null || _d === void 0 ? void 0 : _d.errorStateTextFont) || "400 14px inter",
                        });
                    }
                case uikitResources.States.empty: {
                    return new uikitElements.LabelStyle({
                        textColor: ((_e = this.aiBaseStyle) === null || _e === void 0 ? void 0 : _e.emptyStateTextColor) || "#323232",
                        textFont: ((_f = this.aiBaseStyle) === null || _f === void 0 ? void 0 : _f.emptyStateTextFont) || "400 14px inter",
                    });
                }
                default: {
                    return new uikitElements.LabelStyle({
                        textColor: "#323232",
                        textFont: "400 14px inter",
                    });
                }
            }
        };
    }
    render() {
        var _a, _b, _c;
        if (!this.loadingIconURL) {
            this.loadingIconURL = LoadingIcon;
        }
        if (!this.errorIconURL) {
            this.errorIconURL = ErrorIcon;
        }
        if (!this.emptyIconURL) {
            this.emptyIconURL = EmptyIcon;
        }
        return lit.html `
      <div class="cc__ai-card_container" style="${this.containerStyle()}">
        ${this.state === uikitResources.States.loading
            ? lit.html `
              <slot name="loadingView">
                <div class="cc__ai-card_state_wrapper">
                  <cometchat-button
                    iconURL="${this.loadingIconURL}"
                    buttonStyle="${JSON.stringify(this.iconStyle(((_a = this.aiBaseStyle) === null || _a === void 0 ? void 0 : _a.loadingIconTint) || ""))}"
                  ></cometchat-button>
                  <cometchat-label 
                  text=${this.loadingStateText} 
                  labelStyle=${JSON.stringify(this.labelStyle(this.state))}
                  />
                </div>
              </slot>
            `
            : lit.nothing}
        ${this.state === uikitResources.States.error
            ? lit.html `
              <slot name="errorView">
                <div class="cc__ai-card_state_wrapper">
                  <cometchat-button
                    iconURL="${this.errorIconURL}"
                    buttonStyle="${JSON.stringify(this.iconStyle(((_b = this.aiBaseStyle) === null || _b === void 0 ? void 0 : _b.errorIconTint) || ""))}"
                  ></cometchat-button>
                  <cometchat-label 
                  text=${this.errorStateText} 
                  labelStyle=${JSON.stringify(this.labelStyle(this.state))}
                  />
                </div>
              </slot>
            `
            : lit.nothing}
        ${this.state === uikitResources.States.empty
            ? lit.html `
              <slot name="emptyView">
                <div class="cc__ai-card_state_wrapper">
                  <cometchat-button
                    iconURL="${this.emptyIconURL}"
                    buttonStyle="${JSON.stringify(this.iconStyle(((_c = this.aiBaseStyle) === null || _c === void 0 ? void 0 : _c.emptyIconTint) || ""))}"
                  ></cometchat-button>
                  <cometchat-label 
                  text=${this.emptyStateText} 
                  labelStyle=${JSON.stringify(this.labelStyle(this.state))}
                  />
                </div>
              </slot>
            `
            : lit.nothing}
        ${this.state === uikitResources.States.loaded
            ? lit.html ` <slot name="loadedView"> </slot> `
            : lit.nothing}
      </div>
    `;
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has("state")) {
            this.requestUpdate();
        }
    }
};
exports.CometChatAICard.styles = [
    lit.css `
      .cc__ai-card_container {
        height: 100%;
        width: 100%;
      }

      .cc__ai-card_state_wrapper {
        display: flex;
        width: 100%;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        text-align: center;
      }
    `,
];
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "state", void 0);
__decorate([
    decorators_js.property({ type: Object })
], exports.CometChatAICard.prototype, "aiBaseStyle", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "loadingIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "errorIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "emptyIconURL", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "loadingStateText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "errorStateText", void 0);
__decorate([
    decorators_js.property()
], exports.CometChatAICard.prototype, "emptyStateText", void 0);
exports.CometChatAICard = __decorate([
    decorators_js.customElement("cometchat-ai-card")
], exports.CometChatAICard);

exports.AIAssistBotConfiguration = AIAssistBotConfiguration;
exports.AIAssistBotStyle = AIAssistBotStyle;
exports.AIBaseConfiguration = AIBaseConfiguration;
exports.AIBaseStyle = AIBaseStyle;
exports.AIBotMessageBubbleStyle = AIBotMessageBubbleStyle;
exports.AIConversationStarterConfiguration = AIConversationStarterConfiguration;
exports.AIConversationStarterStyle = AIConversationStarterStyle;
exports.AIConversationSummaryConfiguration = AIConversationSummaryConfiguration;
exports.AIConversationSummaryStyle = AIConversationSummaryStyle;
exports.AIExtensionDataSource = AIExtensionDataSource;
exports.AIOptionsStyle = AIOptionsStyle;
exports.AISenderMessageBubbleStyle = AISenderMessageBubbleStyle;
exports.AISmartRepliesConfiguration = AISmartRepliesConfiguration;
exports.AISmartRepliesStyle = AISmartRepliesStyle;
exports.AddMembersConfiguration = AddMembersConfiguration;
exports.AddMembersStyle = AddMembersStyle;
exports.BannedMembersConfiguration = BannedMembersConfiguration;
exports.BannedMembersStyle = BannedMembersStyle;
exports.BaseStyle = BaseStyle;
exports.CallButtonsConfiguration = CallButtonsConfiguration;
exports.CallButtonsStyle = CallButtonsStyle;
exports.CallLogDetailsConfiguration = CallLogDetailsConfiguration;
exports.CallLogDetailsStyle = CallLogDetailsStyle;
exports.CallLogHistoryConfiguration = CallLogHistoryConfiguration;
exports.CallLogHistoryStyle = CallLogHistoryStyle;
exports.CallLogParticipantsConfiguration = CallLogParticipantsConfiguration;
exports.CallLogParticipantsStyle = CallLogParticipantsStyle;
exports.CallLogRecordingsConfiguration = CallLogRecordingsConfiguration;
exports.CallLogRecordingsStyle = CallLogRecordingsStyle;
exports.CallLogsConfiguration = CallLogsConfiguration;
exports.CallLogsStyle = CallLogsStyle;
exports.CallScreenConfiguration = CallScreenConfiguration;
exports.CallingDetailsUtils = CallingDetailsUtils;
exports.CardBubbleStyle = CardBubbleStyle;
exports.CollaborativeDocumentConfiguration = CollaborativeDocumentConfiguration;
exports.CollaborativeDocumentConstants = CollaborativeDocumentConstants;
exports.CollaborativeDocumentStyle = CollaborativeDocumentStyle;
exports.CollaborativeWhiteboardConfiguration = CollaborativeWhiteboardConfiguration;
exports.CollaborativeWhiteboardConstants = CollaborativeWhiteboardConstants;
exports.CollaborativeWhiteboardStyle = CollaborativeWhiteboardStyle;
exports.CometChatSoundManager = CometChatSoundManager;
exports.CometChatUIKitCalls = CometChatUIKitCalls;
exports.CometChatUIKitHelper = CometChatUIKitHelper;
exports.CometChatUIKitUtility = CometChatUIKitUtility;
exports.ContactsConfiguration = ContactsConfiguration;
exports.ContactsStyle = ContactsStyle;
exports.ConversationUtils = ConversationUtils;
exports.ConversationsConfiguration = ConversationsConfiguration;
exports.ConversationsStyle = ConversationsStyle;
exports.CreateGroupConfiguration = CreateGroupConfiguration;
exports.CreatePollStyle = CreatePollStyle;
exports.DetailsConfiguration = DetailsConfiguration;
exports.DetailsStyle = DetailsStyle;
exports.DetailsUtils = DetailsUtils;
exports.ExtensionsDataSource = ExtensionsDataSource;
exports.ExtensionsId = ExtensionsId;
exports.FormBubbleStyle = FormBubbleStyle;
exports.GroupMemberUtils = GroupMemberUtils;
exports.GroupMembersConfiguration = GroupMembersConfiguration;
exports.GroupMembersStyle = GroupMembersStyle;
exports.GroupsConfiguration = GroupsConfiguration;
exports.GroupsStyle = GroupsStyle;
exports.ImageModerationConfiguration = ImageModerationConfiguration;
exports.ImageModerationConstants = ImageModerationConstants;
exports.ImageModerationStyle = ImageModerationStyle;
exports.IncomingCallStyle = IncomingCallStyle;
exports.InteractiveMessageUtils = InteractiveMessageUtils;
exports.JoinGroupConfiguration = JoinGroupConfiguration;
exports.LinkPreviewConstants = LinkPreviewConstants;
exports.LinkPreviewStyle = LinkPreviewStyle;
exports.ListStyle = ListStyle;
exports.MessageBubbleConfiguration = MessageBubbleConfiguration;
exports.MessageComposerConfiguration = MessageComposerConfiguration;
exports.MessageComposerStyle = MessageComposerStyle;
exports.MessageHeaderConfiguration = MessageHeaderConfiguration;
exports.MessageHeaderStyle = MessageHeaderStyle;
exports.MessageInformationConfiguration = MessageInformationConfiguration;
exports.MessageInformationStyle = MessageInformationStyle;
exports.MessageListConfiguration = MessageListConfiguration;
exports.MessageListStyle = MessageListStyle;
exports.MessageReceiptUtils = MessageReceiptUtils;
exports.MessageTranslationConfiguration = MessageTranslationConfiguration;
exports.MessageTranslationConstants = MessageTranslationConstants;
exports.MessageTranslationStyle = MessageTranslationStyle;
exports.MessagesConfiguration = MessagesConfiguration;
exports.MessagesStyle = MessagesStyle;
exports.OptionsStyle = OptionsStyle;
exports.OutgoingCallConfiguration = OutgoingCallConfiguration;
exports.OutgoingCallStyle = OutgoingCallStyle;
exports.PollsBubbleStyle = PollsBubbleStyle;
exports.PollsConstants = PollsConstants;
exports.ReactionsConstants = ReactionsConstants;
exports.ReactionsStyle = ReactionsStyle;
exports.SmartRepliesConfiguration = SmartRepliesConfiguration;
exports.SmartRepliesConstants = SmartRepliesConstants;
exports.SmartRepliesStyle = SmartRepliesStyle;
exports.StickersConfiguration = StickersConfiguration;
exports.StickersConstants = StickersConstants;
exports.StickersStyle = StickersStyle;
exports.StorageUtils = StorageUtils;
exports.TabItemStyle = TabItemStyle;
exports.ThreadedMessagesConfiguration = ThreadedMessagesConfiguration;
exports.ThreadedMessagesStyle = ThreadedMessagesStyle;
exports.ThumbnailGenerationConstants = ThumbnailGenerationConstants;
exports.TransferOwnershipConfiguration = TransferOwnershipConfiguration;
exports.TransferOwnershipStyle = TransferOwnershipStyle;
exports.UIKitSettings = UIKitSettings;
exports.UIKitSettingsBuilder = UIKitSettingsBuilder;
exports.UsersConfiguration = UsersConfiguration;
exports.UsersStyle = UsersStyle;
exports.WithDetailsStyle = WithDetailsStyle;
exports.WithMessagesStyle = WithMessagesStyle;
